var W0 = Object.defineProperty;
var q0 = (c, t, s) => t in c ? W0(c, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : c[t] = s;
var S2 = (c, t, s) => q0(c, typeof t != "symbol" ? t + "" : t, s);
import q, { useState as z, forwardRef as Y0, useRef as W, useEffect as I, useCallback as K, useMemo as T2, createContext as G0, useContext as U0 } from "react";
var h2 = { exports: {} }, f2 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var r0;
function K0() {
  if (r0) return f2;
  r0 = 1;
  var c = q, t = Symbol.for("react.element"), s = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, n = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, f = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(i, o, m) {
    var x, p = {}, g = null, S = null;
    m !== void 0 && (g = "" + m), o.key !== void 0 && (g = "" + o.key), o.ref !== void 0 && (S = o.ref);
    for (x in o) a.call(o, x) && !f.hasOwnProperty(x) && (p[x] = o[x]);
    if (i && i.defaultProps) for (x in o = i.defaultProps, o) p[x] === void 0 && (p[x] = o[x]);
    return { $$typeof: t, type: i, key: g, ref: S, props: p, _owner: n.current };
  }
  return f2.Fragment = s, f2.jsx = l, f2.jsxs = l, f2;
}
var m2 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var s0;
function J0() {
  return s0 || (s0 = 1, process.env.NODE_ENV !== "production" && function() {
    var c = q, t = Symbol.for("react.element"), s = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), i = Symbol.for("react.context"), o = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), M = Symbol.iterator, C = "@@iterator";
    function w(r) {
      if (r === null || typeof r != "object")
        return null;
      var d = M && r[M] || r[C];
      return typeof d == "function" ? d : null;
    }
    var E = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function j(r) {
      {
        for (var d = arguments.length, h = new Array(d > 1 ? d - 1 : 0), v = 1; v < d; v++)
          h[v - 1] = arguments[v];
        b("error", r, h);
      }
    }
    function b(r, d, h) {
      {
        var v = E.ReactDebugCurrentFrame, V = v.getStackAddendum();
        V !== "" && (d += "%s", h = h.concat([V]));
        var _ = h.map(function(k) {
          return String(k);
        });
        _.unshift("Warning: " + d), Function.prototype.apply.call(console[r], console, _);
      }
    }
    var y = !1, N = !1, O = !1, G = !1, D = !1, s2;
    s2 = Symbol.for("react.module.reference");
    function Z(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === a || r === f || D || r === n || r === m || r === x || G || r === S || y || N || O || typeof r == "object" && r !== null && (r.$$typeof === g || r.$$typeof === p || r.$$typeof === l || r.$$typeof === i || r.$$typeof === o || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === s2 || r.getModuleId !== void 0));
    }
    function U(r, d, h) {
      var v = r.displayName;
      if (v)
        return v;
      var V = d.displayName || d.name || "";
      return V !== "" ? h + "(" + V + ")" : h;
    }
    function J(r) {
      return r.displayName || "Context";
    }
    function A(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && j("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case a:
          return "Fragment";
        case s:
          return "Portal";
        case f:
          return "Profiler";
        case n:
          return "StrictMode";
        case m:
          return "Suspense";
        case x:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case i:
            var d = r;
            return J(d) + ".Consumer";
          case l:
            var h = r;
            return J(h._context) + ".Provider";
          case o:
            return U(r, r.render, "ForwardRef");
          case p:
            var v = r.displayName || null;
            return v !== null ? v : A(r.type) || "Memo";
          case g: {
            var V = r, _ = V._payload, k = V._init;
            try {
              return A(k(_));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var X = Object.assign, a2 = 0, H2, Z2, R2, z2, O2, P2, I2;
    function F2() {
    }
    F2.__reactDisabledLog = !0;
    function g0() {
      {
        if (a2 === 0) {
          H2 = console.log, Z2 = console.info, R2 = console.warn, z2 = console.error, O2 = console.group, P2 = console.groupCollapsed, I2 = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: F2,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        a2++;
      }
    }
    function v0() {
      {
        if (a2--, a2 === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: X({}, r, {
              value: H2
            }),
            info: X({}, r, {
              value: Z2
            }),
            warn: X({}, r, {
              value: R2
            }),
            error: X({}, r, {
              value: z2
            }),
            group: X({}, r, {
              value: O2
            }),
            groupCollapsed: X({}, r, {
              value: P2
            }),
            groupEnd: X({}, r, {
              value: I2
            })
          });
        }
        a2 < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var y2 = E.ReactCurrentDispatcher, w2;
    function l2(r, d, h) {
      {
        if (w2 === void 0)
          try {
            throw Error();
          } catch (V) {
            var v = V.stack.trim().match(/\n( *(at )?)/);
            w2 = v && v[1] || "";
          }
        return `
` + w2 + r;
      }
    }
    var j2 = !1, o2;
    {
      var b0 = typeof WeakMap == "function" ? WeakMap : Map;
      o2 = new b0();
    }
    function A2(r, d) {
      if (!r || j2)
        return "";
      {
        var h = o2.get(r);
        if (h !== void 0)
          return h;
      }
      var v;
      j2 = !0;
      var V = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var _;
      _ = y2.current, y2.current = null, g0();
      try {
        if (d) {
          var k = function() {
            throw Error();
          };
          if (Object.defineProperty(k.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(k, []);
            } catch (F) {
              v = F;
            }
            Reflect.construct(r, [], k);
          } else {
            try {
              k.call();
            } catch (F) {
              v = F;
            }
            r.call(k.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (F) {
            v = F;
          }
          r();
        }
      } catch (F) {
        if (F && v && typeof F.stack == "string") {
          for (var L = F.stack.split(`
`), P = v.stack.split(`
`), H = L.length - 1, R = P.length - 1; H >= 1 && R >= 0 && L[H] !== P[R]; )
            R--;
          for (; H >= 1 && R >= 0; H--, R--)
            if (L[H] !== P[R]) {
              if (H !== 1 || R !== 1)
                do
                  if (H--, R--, R < 0 || L[H] !== P[R]) {
                    var $ = `
` + L[H].replace(" at new ", " at ");
                    return r.displayName && $.includes("<anonymous>") && ($ = $.replace("<anonymous>", r.displayName)), typeof r == "function" && o2.set(r, $), $;
                  }
                while (H >= 1 && R >= 0);
              break;
            }
        }
      } finally {
        j2 = !1, y2.current = _, v0(), Error.prepareStackTrace = V;
      }
      var c2 = r ? r.displayName || r.name : "", Q = c2 ? l2(c2) : "";
      return typeof r == "function" && o2.set(r, Q), Q;
    }
    function y0(r, d, h) {
      return A2(r, !1);
    }
    function w0(r) {
      var d = r.prototype;
      return !!(d && d.isReactComponent);
    }
    function d2(r, d, h) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return A2(r, w0(r));
      if (typeof r == "string")
        return l2(r);
      switch (r) {
        case m:
          return l2("Suspense");
        case x:
          return l2("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case o:
            return y0(r.render);
          case p:
            return d2(r.type, d, h);
          case g: {
            var v = r, V = v._payload, _ = v._init;
            try {
              return d2(_(V), d, h);
            } catch {
            }
          }
        }
      return "";
    }
    var n2 = Object.prototype.hasOwnProperty, $2 = {}, D2 = E.ReactDebugCurrentFrame;
    function u2(r) {
      if (r) {
        var d = r._owner, h = d2(r.type, r._source, d ? d.type : null);
        D2.setExtraStackFrame(h);
      } else
        D2.setExtraStackFrame(null);
    }
    function j0(r, d, h, v, V) {
      {
        var _ = Function.call.bind(n2);
        for (var k in r)
          if (_(r, k)) {
            var L = void 0;
            try {
              if (typeof r[k] != "function") {
                var P = Error((v || "React class") + ": " + h + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw P.name = "Invariant Violation", P;
              }
              L = r[k](d, k, v, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              L = H;
            }
            L && !(L instanceof Error) && (u2(V), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", h, k, typeof L), u2(null)), L instanceof Error && !(L.message in $2) && ($2[L.message] = !0, u2(V), j("Failed %s type: %s", h, L.message), u2(null));
          }
      }
    }
    var N0 = Array.isArray;
    function N2(r) {
      return N0(r);
    }
    function L0(r) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, h = d && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return h;
      }
    }
    function k0(r) {
      try {
        return W2(r), !1;
      } catch {
        return !0;
      }
    }
    function W2(r) {
      return "" + r;
    }
    function q2(r) {
      if (k0(r))
        return j("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", L0(r)), W2(r);
    }
    var Y2 = E.ReactCurrentOwner, M0 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, G2, U2;
    function E0(r) {
      if (n2.call(r, "ref")) {
        var d = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function S0(r) {
      if (n2.call(r, "key")) {
        var d = Object.getOwnPropertyDescriptor(r, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function V0(r, d) {
      typeof r.ref == "string" && Y2.current;
    }
    function T0(r, d) {
      {
        var h = function() {
          G2 || (G2 = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        h.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: h,
          configurable: !0
        });
      }
    }
    function _0(r, d) {
      {
        var h = function() {
          U2 || (U2 = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        h.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: h,
          configurable: !0
        });
      }
    }
    var B0 = function(r, d, h, v, V, _, k) {
      var L = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: r,
        key: d,
        ref: h,
        props: k,
        // Record the component responsible for creating this element.
        _owner: _
      };
      return L._store = {}, Object.defineProperty(L._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(L, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(L, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: V
      }), Object.freeze && (Object.freeze(L.props), Object.freeze(L)), L;
    };
    function H0(r, d, h, v, V) {
      {
        var _, k = {}, L = null, P = null;
        h !== void 0 && (q2(h), L = "" + h), S0(d) && (q2(d.key), L = "" + d.key), E0(d) && (P = d.ref, V0(d, V));
        for (_ in d)
          n2.call(d, _) && !M0.hasOwnProperty(_) && (k[_] = d[_]);
        if (r && r.defaultProps) {
          var H = r.defaultProps;
          for (_ in H)
            k[_] === void 0 && (k[_] = H[_]);
        }
        if (L || P) {
          var R = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          L && T0(k, R), P && _0(k, R);
        }
        return B0(r, L, P, V, v, Y2.current, k);
      }
    }
    var L2 = E.ReactCurrentOwner, K2 = E.ReactDebugCurrentFrame;
    function e2(r) {
      if (r) {
        var d = r._owner, h = d2(r.type, r._source, d ? d.type : null);
        K2.setExtraStackFrame(h);
      } else
        K2.setExtraStackFrame(null);
    }
    var k2;
    k2 = !1;
    function M2(r) {
      return typeof r == "object" && r !== null && r.$$typeof === t;
    }
    function J2() {
      {
        if (L2.current) {
          var r = A(L2.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Z0(r) {
      return "";
    }
    var X2 = {};
    function R0(r) {
      {
        var d = J2();
        if (!d) {
          var h = typeof r == "string" ? r : r.displayName || r.name;
          h && (d = `

Check the top-level render call using <` + h + ">.");
        }
        return d;
      }
    }
    function Q2(r, d) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var h = R0(d);
        if (X2[h])
          return;
        X2[h] = !0;
        var v = "";
        r && r._owner && r._owner !== L2.current && (v = " It was passed a child from " + A(r._owner.type) + "."), e2(r), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', h, v), e2(null);
      }
    }
    function e0(r, d) {
      {
        if (typeof r != "object")
          return;
        if (N2(r))
          for (var h = 0; h < r.length; h++) {
            var v = r[h];
            M2(v) && Q2(v, d);
          }
        else if (M2(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var V = w(r);
          if (typeof V == "function" && V !== r.entries)
            for (var _ = V.call(r), k; !(k = _.next()).done; )
              M2(k.value) && Q2(k.value, d);
        }
      }
    }
    function z0(r) {
      {
        var d = r.type;
        if (d == null || typeof d == "string")
          return;
        var h;
        if (typeof d == "function")
          h = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === o || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === p))
          h = d.propTypes;
        else
          return;
        if (h) {
          var v = A(d);
          j0(h, r.props, "prop", v, r);
        } else if (d.PropTypes !== void 0 && !k2) {
          k2 = !0;
          var V = A(d);
          j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", V || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function O0(r) {
      {
        for (var d = Object.keys(r.props), h = 0; h < d.length; h++) {
          var v = d[h];
          if (v !== "children" && v !== "key") {
            e2(r), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), e2(null);
            break;
          }
        }
        r.ref !== null && (e2(r), j("Invalid attribute `ref` supplied to `React.Fragment`."), e2(null));
      }
    }
    var c0 = {};
    function t0(r, d, h, v, V, _) {
      {
        var k = Z(r);
        if (!k) {
          var L = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var P = Z0();
          P ? L += P : L += J2();
          var H;
          r === null ? H = "null" : N2(r) ? H = "array" : r !== void 0 && r.$$typeof === t ? (H = "<" + (A(r.type) || "Unknown") + " />", L = " Did you accidentally export a JSX literal instead of a component?") : H = typeof r, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, L);
        }
        var R = H0(r, d, h, V, _);
        if (R == null)
          return R;
        if (k) {
          var $ = d.children;
          if ($ !== void 0)
            if (v)
              if (N2($)) {
                for (var c2 = 0; c2 < $.length; c2++)
                  e0($[c2], r);
                Object.freeze && Object.freeze($);
              } else
                j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              e0($, r);
        }
        if (n2.call(d, "key")) {
          var Q = A(r), F = Object.keys(d).filter(function(D0) {
            return D0 !== "key";
          }), E2 = F.length > 0 ? "{key: someKey, " + F.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!c0[Q + E2]) {
            var $0 = F.length > 0 ? "{" + F.join(": ..., ") + ": ...}" : "{}";
            j(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, E2, Q, $0, Q), c0[Q + E2] = !0;
          }
        }
        return r === a ? O0(R) : z0(R), R;
      }
    }
    function P0(r, d, h) {
      return t0(r, d, h, !0);
    }
    function I0(r, d, h) {
      return t0(r, d, h, !1);
    }
    var F0 = I0, A0 = P0;
    m2.Fragment = a, m2.jsx = F0, m2.jsxs = A0;
  }()), m2;
}
var a0;
function X0() {
  return a0 || (a0 = 1, process.env.NODE_ENV === "production" ? h2.exports = K0() : h2.exports = J0()), h2.exports;
}
var e = X0();
function d0(c) {
  var t, s, a = "";
  if (typeof c == "string" || typeof c == "number") a += c;
  else if (typeof c == "object") if (Array.isArray(c)) {
    var n = c.length;
    for (t = 0; t < n; t++) c[t] && (s = d0(c[t])) && (a && (a += " "), a += s);
  } else for (s in c) c[s] && (a && (a += " "), a += s);
  return a;
}
function u() {
  for (var c, t, s = 0, a = "", n = arguments.length; s < n; s++) (c = arguments[s]) && (t = d0(c)) && (a && (a += " "), a += t);
  return a;
}
const Q0 = "cfm:transition-all cfm:duration-200 cfm:cursor-pointer cfm:disabled:cursor-not-allowed cfm:flex cfm:items-center cfm:justify-center cfm:gap-2 cfm:font-bold cfm:focus:ring-0 cfm:focus:outline-none cfm:disabled:text-gray-500", e4 = {
  contained: "cfm:rounded-full cfm:focus:border-2 cfm:focus:border-focus",
  outlined: "cfm:rounded-full cfm:border-2 cfm:focus:border-focus",
  text: "cfm:bg-transparent cfm:border-none cfm:underline cfm:hover:no-underline cfm:focus:text-focus"
}, c4 = {
  sm: "cfm:px-[17px] cfm:py-[8px] cfm:text-base",
  md: "cfm:px-[49px] cfm:py-[13px] cfm:text-base",
  lg: "cfm:px-[52px] cfm:py-[16px] cfm:text-base",
  xl: "cfm:px-[84px] cfm:py-[20px] cfm:text-base"
}, n0 = {
  contained: {
    default: "cfm:bg-primary-main cfm:text-white cfm:hover:bg-primary-300 cfm:dark:border-2 cfm:dark:border-white cfm:dark:bg-tertiary-800 cfm:dark:text-white",
    disabled: "cfm:disabled:bg-secondary-500 cfm:disabled:text-secondary-900",
    focus: "cfm:focus:ring-focus"
  },
  outlined: {
    default: "cfm:bg-transparent cfm:border-primary-main cfm:text-primary-main cfm:hover:border-primary-300 cfm:hover:bg-primary-300 cfm:hover:text-white cfm:dark:bg-tertiary-800 cfm:dark:border-white cfm:dark:text-white",
    disabled: "cfm:disabled:border-secondary-500 cfm:disabled:bg-transparent cfm:disabled:text-secondary-900",
    focus: "cfm:focus:ring-focus"
  },
  text: {
    default: "cfm:text-primary-main cfm:hover:text-primary-300 cfm:dark:text-white cfm:dark:hover:text-tertiary-300",
    disabled: "cfm:disabled:text-secondary-500",
    focus: "cfm:focus:ring-focus"
  }
}, Y = ({
  children: c,
  className: t,
  size: s = "md",
  variant: a = "contained",
  action: n,
  disabled: f,
  ...l
}) => {
  const i = u(
    Q0,
    e4[a],
    // Solo aplicar tamaño si no es variant text
    a !== "text" && c4[s],
    // Aplicar colores y estados
    n0[a].default,
    n0[a].disabled,
    t
  );
  return typeof n == "string" ? /* @__PURE__ */ e.jsx(
    "a",
    {
      href: n,
      className: u(i, f && "cfm:pointer-events-none"),
      "aria-disabled": f,
      tabIndex: f ? -1 : 0,
      ...l,
      children: c
    }
  ) : /* @__PURE__ */ e.jsx(
    "button",
    {
      onClick: n,
      className: i,
      disabled: f,
      ...l,
      children: c
    }
  );
};
function t4(c) {
  return c = c.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), c = c.replace(
    new RegExp("(?<!_)__([^_]+)__(?!_)", "g"),
    "<strong>$1</strong>"
  ), c = c.replace(
    new RegExp("(?<!!)!!([^!]+)!!(?!!)", "g"),
    '<span style="color:#ee2b7b;">$1</span>'
  ), c = c.replace(
    new RegExp("(?<!\\^)\\^\\^([^^]+)\\^\\^(?!\\^)", "g"),
    "<em>$1</em>"
  ), c = c.replace(/\/n/g, "<br/>"), c;
}
const r4 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p"
}, T = ({
  variant: c = "body1",
  children: t,
  className: s,
  as: a,
  ...n
}) => {
  const f = a || r4[c];
  return typeof t == "string" ? /* @__PURE__ */ e.jsx(
    f,
    {
      className: u(`cfm:typography-${c}`, s),
      dangerouslySetInnerHTML: { __html: t4(t) },
      id: n.id,
      ...n
    }
  ) : /* @__PURE__ */ e.jsx(f, { id: n.id, className: u(`cfm:typography-${c}`, s), ...n, children: t });
}, p1 = ({
  color: c = "primary",
  defaultChecked: t = !1,
  onChange: s,
  disabled: a = !1,
  size: n = "md",
  className: f,
  variant: l = "normal"
}) => {
  const [i, o] = z(t), m = "cfm:relative cfm:flex cfm:items-center cfm:justify-center cfm:rounded-md cfm:border-2 cfm:transition-all cfm:duration-200 cfm:ease-in-out", x = "cfm:focus:outline-terteary-100 cfm:focus:border-focus", p = "cfm:disabled:cursor-not-allowed cfm:disabled:bg-secondary-500 cfm:disabled:border-secondary-500 cfm:disabled:text-white", g = "cfm:cursor-pointer", S = "cfm:border-transparent", M = "cfm:bg-tertiary-100 cfm:border-tertiary-600", C = {
    primary: {
      checked: "cfm:bg-primary-400 cfm:hover:bg-primary-500 cfm:dark:hover:bg-primary-100",
      unchecked: "cfm:hover:border-primary-500"
    },
    warning: {
      checked: "cfm:bg-warning-400 cfm:hover:bg-warning-500 cfm:dark:hover:bg-warning-100",
      unchecked: "cfm:hover:border-warning-500"
    },
    info: {
      checked: "cfm:bg-info-400 cfm:hover:bg-info-500 cfm:dark:hover:bg-info-100",
      unchecked: "cfm:hover:border-info-500"
    },
    success: {
      checked: "cfm:bg-success-400 cfm:hover:bg-success-500 cfm:dark:hover:bg-success-100",
      unchecked: "cfm:hover:border-success-500"
    },
    error: {
      checked: "cfm:bg-error-400 cfm:hover:bg-error-500 cfm:dark:hover:bg-error-100",
      unchecked: "cfm:hover:border-error-500"
    }
  }, w = () => {
    if (!a) {
      const y = !i;
      o(y), s == null || s(y);
    }
  }, E = {
    sm: "cfm:w-4 cfm:h-4",
    md: "cfm:w-6 cfm:h-6",
    lg: "cfm:w-8 cfm:h-8"
  }, j = {
    sm: "cfm:w-2.5 cfm:h-2.5",
    md: "cfm:w-3.5 cfm:h-3.5",
    lg: "cfm:w-5 cfm:h-5"
  }, b = {
    sm: "cfm:w-2 cfm:h-0.5",
    md: "cfm:w-3 cfm:h-0.5",
    lg: "cfm:w-4 cfm:h-1"
  };
  return /* @__PURE__ */ e.jsxs(
    "button",
    {
      type: "button",
      className: u(
        m,
        x,
        p,
        E[n],
        !a && g,
        i ? u(C[c].checked, S) : u(C[c].unchecked, M),
        f
      ),
      disabled: a,
      onClick: w,
      "aria-checked": i,
      role: "checkbox",
      children: [
        /* @__PURE__ */ e.jsx("span", { className: "cfm:sr-only", children: "Checkbox" }),
        i && l === "normal" && /* @__PURE__ */ e.jsx(
          "svg",
          {
            className: u("cfm:text-white", j[n]),
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: /* @__PURE__ */ e.jsx("polyline", { points: "20 6 9 17 4 12" })
          }
        ),
        i && l === "minus" && /* @__PURE__ */ e.jsx(
          "div",
          {
            className: u(
              "cfm:bg-white cfm:rounded-sm",
              b[n]
            )
          }
        )
      ]
    }
  );
}, s4 = ({ className: c = "" }) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    className: `cfm:animate-spin ${c}`,
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 1024 1024",
    height: "200px",
    width: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e.jsx("path", { d: "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z" })
  }
);
var u0 = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, f0 = q.createContext && /* @__PURE__ */ q.createContext(u0), a4 = ["attr", "size", "title"];
function n4(c, t) {
  if (c == null) return {};
  var s = f4(c, t), a, n;
  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(c);
    for (n = 0; n < f.length; n++)
      a = f[n], !(t.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(c, a) && (s[a] = c[a]);
  }
  return s;
}
function f4(c, t) {
  if (c == null) return {};
  var s = {};
  for (var a in c)
    if (Object.prototype.hasOwnProperty.call(c, a)) {
      if (t.indexOf(a) >= 0) continue;
      s[a] = c[a];
    }
  return s;
}
function x2() {
  return x2 = Object.assign ? Object.assign.bind() : function(c) {
    for (var t = 1; t < arguments.length; t++) {
      var s = arguments[t];
      for (var a in s)
        Object.prototype.hasOwnProperty.call(s, a) && (c[a] = s[a]);
    }
    return c;
  }, x2.apply(this, arguments);
}
function m0(c, t) {
  var s = Object.keys(c);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(c);
    t && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(c, n).enumerable;
    })), s.push.apply(s, a);
  }
  return s;
}
function p2(c) {
  for (var t = 1; t < arguments.length; t++) {
    var s = arguments[t] != null ? arguments[t] : {};
    t % 2 ? m0(Object(s), !0).forEach(function(a) {
      m4(c, a, s[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(s)) : m0(Object(s)).forEach(function(a) {
      Object.defineProperty(c, a, Object.getOwnPropertyDescriptor(s, a));
    });
  }
  return c;
}
function m4(c, t, s) {
  return t = i4(t), t in c ? Object.defineProperty(c, t, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : c[t] = s, c;
}
function i4(c) {
  var t = l4(c, "string");
  return typeof t == "symbol" ? t : t + "";
}
function l4(c, t) {
  if (typeof c != "object" || !c) return c;
  var s = c[Symbol.toPrimitive];
  if (s !== void 0) {
    var a = s.call(c, t);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(c);
}
function h0(c) {
  return c && c.map((t, s) => /* @__PURE__ */ q.createElement(t.tag, p2({
    key: s
  }, t.attr), h0(t.child)));
}
function B(c) {
  return (t) => /* @__PURE__ */ q.createElement(o4, x2({
    attr: p2({}, c.attr)
  }, t), h0(c.child));
}
function o4(c) {
  var t = (s) => {
    var {
      attr: a,
      size: n,
      title: f
    } = c, l = n4(c, a4), i = n || s.size || "1em", o;
    return s.className && (o = s.className), c.className && (o = (o ? o + " " : "") + c.className), /* @__PURE__ */ q.createElement("svg", x2({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, s.attr, a, l, {
      className: o,
      style: p2(p2({
        color: c.color || s.color
      }, s.style), c.style),
      height: i,
      width: i,
      xmlns: "http://www.w3.org/2000/svg"
    }), f && /* @__PURE__ */ q.createElement("title", null, f), c.children);
  };
  return f0 !== void 0 ? /* @__PURE__ */ q.createElement(f0.Consumer, null, (s) => t(s)) : t(u0);
}
function d4(c) {
  return B({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }, child: [] }] })(c);
}
function u4(c) {
  return B({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }, child: [] }] })(c);
}
const h4 = (c) => ({
  default: {
    bg: "cfm:bg-tertiary-50 cfm:dark:bg-tertiary-800",
    border: "cfm:border-tertiary-800 cfm:dark:border-tertiary-50",
    focusBorder: "cfm:focus:border-primary",
    text: "cfm:text-secondary-900 cfm:dark:text-tertiary-50",
    icon: "cfm:text-primary cfm:dark:text-tertiary-50",
    trailingIcon: ""
  },
  success: {
    bg: "cfm:bg-tertiary-50 cfm:dark:bg-tertiary-800",
    border: "cfm:border-success-500",
    focusBorder: "cfm:focus:border-success-500",
    text: "cfm:text-success-500",
    icon: "cfm:text-success-500",
    trailingIcon: /* @__PURE__ */ e.jsx(d4, {})
  },
  error: {
    bg: "cfm:bg-tertiary-50 cfm:dark:bg-tertiary-800",
    border: "cfm:border-red-500",
    focusBorder: "cfm:focus:border-error-500",
    text: "cfm:text-red-700",
    icon: "cfm:text-red-500",
    trailingIcon: /* @__PURE__ */ e.jsx(u4, {})
  }
})[c], x4 = (c, t, s, a) => {
  const n = [
    "cfm:w-full",
    "cfm:h-[52px]",
    "cfm:outline-none",
    "cfm:transition-all",
    "cfm:duration-200",
    "cfm:text-sm",
    "cfm:text-secondary-900 cfm:dark:text-tertiary-50",
    s ? "cfm:pl-9" : "cfm:pl-3",
    a ? "cfm:pr-9" : "cfm:pr-3"
  ], f = c === "filled" ? [
    "cfm:rounded-lg",
    "cfm:border",
    t.bg,
    t.border,
    t.focusBorder
  ] : [
    "cfm:bg-transparent",
    "cfm:border-b-2",
    t.border,
    t.focusBorder
  ];
  return [...n, ...f];
}, p4 = Y0(
  ({
    className: c,
    label: t,
    variant: s = "filled",
    colorScheme: a = "default",
    helperText: n,
    showTrailingIcon: f = !1,
    isLoading: l = !1,
    leftIcon: i,
    onChange: o,
    ...m
  }, x) => {
    const p = h4(a), g = x4(
      s,
      p,
      !!i,
      f
    ), S = (C) => {
      o == null || o(C);
    }, M = () => l ? /* @__PURE__ */ e.jsx(s4, { className: "cfm:w-4 cfm:h-4 cfm:text-current" }) : p.trailingIcon;
    return /* @__PURE__ */ e.jsxs("div", { className: u("cfm:w-full", c), children: [
      t && /* @__PURE__ */ e.jsx(
        "label",
        {
          className: u(
            "cfm:block cfm:text-lg cfm:font-medium cfm:mb-1",
            p.text
          ),
          children: t
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "cfm:relative", children: [
        i && /* @__PURE__ */ e.jsx("div", { className: "cfm:absolute cfm:left-3 cfm:top-1/2 cfm:-translate-y-1/2 cfm:flex cfm:items-center cfm:text-slate-500", children: i }),
        /* @__PURE__ */ e.jsx(
          "input",
          {
            ref: x,
            className: u(g),
            onChange: S,
            ...m
          }
        ),
        f && /* @__PURE__ */ e.jsx(
          "div",
          {
            className: u(
              "cfm:absolute cfm:right-4 cfm:top-1/2 cfm:-translate-y-1/2",
              p.icon
            ),
            children: M()
          }
        )
      ] }),
      n && /* @__PURE__ */ e.jsx("p", { className: u("cfm:mt-2 cfm:text-sm cfm:text-seconday-900 cfm:dark:text-tertiary-700"), children: n })
    ] });
  }
);
p4.displayName = "Input";
const C4 = {
  primary: "cfm:bg-primary cfm:text-primary cfm:hover:bg-primary-500 cfm:hover:text-primary-500 cfm:dark:hover:bg-primary-100 cfm:dark:hover:text-primary-500",
  warning: "cfm:bg-warning cfm:text-warning cfm:hover:bg-warning-500 cfm:hover:text-warning-500 cfm:dark:hover:bg-warning-100 cfm:dark:hover:text-warning-500",
  info: "cfm:bg-info cfm:text-info cfm:hover:bg-info-500 cfm:hover:text-info-500 cfm:dark:hover:bg-info-100 cfm:dark:hover:text-info-500",
  success: "cfm:bg-success cfm:text-success cfm:hover:bg-success-500 cfm:hover:text-success-500 cfm:dark:hover:bg-success-100 cfm:dark:hover:text-success-500",
  error: "cfm:bg-error cfm:text-error cfm:hover:bg-error-500 cfm:hover:text-error-500 cfm:dark:hover:bg-error-100 cfm:dark:hover:text-error-500"
}, g4 = {
  sm: {
    track: "cfm:w-[30px] cfm:h-4",
    thumb: "cfm:w-3 cfm:h-3",
    translate: "cfm:translate-x-4",
    icon: 10
  },
  md: {
    track: "cfm:w-[42px] cfm:h-6",
    thumb: "cfm:w-5 cfm:h-5",
    translate: "cfm:translate-x-full",
    icon: 12
  },
  lg: {
    track: "cfm:w-[54px] cfm:h-7",
    thumb: "cfm:w-6 cfm:h-6",
    translate: "cfm:translate-x-7",
    icon: 14
  }
}, v4 = "cfm:relative cfm:flex cfm:items-center cfm:shrink-0 cfm:cursor-pointer cfm:rounded-full cfm:transition-colors cfm:duration-200 cfm:ease-in-out cfm:focus:outline-none cfm:focus-visible:ring-2 cfm:focus-visible:ring-offset-2", b4 = "cfm:pointer-events-none cfm:absolute cfm:flex cfm:items-center cfm:justify-center cfm:rounded-full cfm:bg-white cfm:dark:bg-black cfm:shadow-lg cfm:ring-0 cfm:transition cfm:duration-200 cfm:ease-in-out", y4 = ({ size: c, disabled: t }) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    width: c,
    height: c,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: t ? "cfm:text-secondary-400" : "cfm:text-current cfm:dark:text-white",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M7.47164 13.2723L16.241 4.50298C16.4479 4.29604 16.6893 4.19257 16.9653 4.19257C17.2412 4.19257 17.4826 4.29604 17.6896 4.50298C17.8965 4.70993 18 4.95568 18 5.24023C18 5.52478 17.8965 5.77053 17.6896 5.97747L8.19595 15.497C7.98901 15.7039 7.74757 15.8074 7.47164 15.8074C7.19571 15.8074 6.95428 15.7039 6.74733 15.497L2.298 11.0476C2.09106 10.8407 1.99189 10.5949 2.00052 10.3104C2.00914 10.0258 2.11692 9.7801 2.32387 9.57315C2.53082 9.36621 2.77656 9.26273 3.06111 9.26273C3.34566 9.26273 3.59141 9.36621 3.79836 9.57315L7.47164 13.2723Z",
        fill: "currentColor"
      }
    )
  }
), C1 = ({
  color: c = "primary",
  defaultChecked: t = !1,
  onChange: s,
  disabled: a = !1,
  size: n = "md",
  className: f
}) => {
  const [l, i] = z(t), o = g4[n], m = () => {
    if (a) return;
    const g = !l;
    i(g), s == null || s(g);
  }, x = () => u(
    v4,
    o.track,
    l ? C4[c] : "cfm:bg-tertieary-100 cfm:border-2 cfm:border-tertiary-600",
    a && "cfm:cursor-not-allowed cfm:bg-secondary-400",
    f
  ), p = () => u(
    b4,
    o.thumb,
    l ? o.translate : "cfm:translate-x-0 cfm:border-2 cfm:border-tertiary-600"
  );
  return /* @__PURE__ */ e.jsx(
    "button",
    {
      type: "button",
      className: x(),
      disabled: a,
      onClick: m,
      "aria-pressed": l,
      "aria-label": "Toggle switch",
      children: /* @__PURE__ */ e.jsx(
        "span",
        {
          className: p(),
          "aria-hidden": "true",
          children: l && /* @__PURE__ */ e.jsx(y4, { size: o.icon, disabled: a })
        }
      )
    }
  );
}, g1 = ({
  color: c = "primary",
  name: t,
  defaultChecked: s = !1,
  onChange: a,
  disabled: n = !1,
  size: f = "md",
  className: l
}) => {
  const [i, o] = z(s), m = {
    primary: "cfm:border-primary cfm:text-primary",
    secondary: "cfm:border-secondary cfm:text-secondary",
    tertiary: "cfm:border-tertiary cfm:text-tertiary",
    turquoise: "cfm:border-turquoise-500 cfm:text-turquoise-500",
    yellow: "cfm:border-yellow-500 cfm:text-yellow-500",
    salmon: "cfm:border-salmon-500 cfm:text-salmon-500",
    warning: "cfm:border-amber-500 cfm:text-amber-500",
    info: "cfm:border-blue-500 cfm:text-blue-500",
    success: "cfm:border-green-500 cfm:text-green-500",
    error: "cfm:border-red-500 cfm:text-red-500"
  }, x = () => m[c] ? m[c] : c.startsWith("border-") || c.startsWith("cfm:border-") ? `${c} ${c.replace("border-", "text-")}` : `cfm:border-${c}-500 cfm:text-${c}-500`, p = () => {
    !i && !n && (o(!0), a == null || a(!0));
  }, g = {
    sm: "cfm:w-4 cfm:h-4",
    md: "cfm:w-6 cfm:h-6",
    lg: "cfm:w-8 cfm:h-8"
  }, S = {
    sm: "cfm:w-2 cfm:h-2",
    md: "cfm:w-3 cfm:h-3",
    lg: "cfm:w-4 cfm:h-4"
  };
  return /* @__PURE__ */ e.jsxs(
    "button",
    {
      type: "button",
      className: u(
        "cfm:relative cfm:flex cfm:items-center cfm:justify-center cfm:rounded-full cfm:border-2 cfm:transition-colors cfm:duration-200 cfm:ease-in-out focus:cfm:outline-none",
        g[f],
        i ? `${x()} cfm:bg-transparent hover:cfm:opacity-90 focus:cfm:ring-2 focus:cfm:ring-opacity-30 focus:cfm:ring-current cfm:cursor-pointer cfm:disabled:border-secondary-500 cfm:disabled:bg-secondary-200 cfm:cursor-not-allowed` : "cfm:border-gray-300 cfm:bg-transparent hover:cfm:border-opacity-90 hover:cfm:border-current focus:cfm:border-current focus:cfm:ring-2 focus:cfm:ring-opacity-30 focus:cfm:ring-current cfm:cursor-pointer cfm:disabled:border-secondary-500 cfm:disabled:bg-secondary-200 cfm:cursor-not-allowed",
        l
      ),
      disabled: n,
      onClick: p,
      "aria-checked": i,
      role: "radio",
      "aria-label": t,
      name: t,
      children: [
        /* @__PURE__ */ e.jsx("span", { className: "cfm:sr-only", children: "Radio Button" }),
        i && /* @__PURE__ */ e.jsx(
          "div",
          {
            className: u(
              "cfm:rounded-full",
              S[f],
              n ? "cfm:bg-secondary-500" : "cfm:bg-current"
            )
          }
        )
      ]
    }
  );
}, _2 = ({
  src: c,
  alt: t = "",
  className: s,
  rounded: a = "none",
  aspectRatio: n
}) => /* @__PURE__ */ e.jsx(
  "img",
  {
    src: c,
    alt: t,
    className: u(
      "cfm:bg-[#B7BAD1] cfm:object-cover cfm:w-full",
      {
        "cfm:rounded-none": a === "none",
        "cfm:rounded-sm": a === "sm",
        "cfm:rounded-lg": a === "md",
        "cfm:rounded-2xl": a === "lg",
        "cfm:rounded-3xl": a === "xl",
        "cfm:rounded-full": a === "full",
        "cfm:aspect-square": n === "1/1",
        "cfm:aspect-video": n === "16/9",
        "cfm:aspect-[4/3]": n === "4/3",
        "cfm:aspect-[3/2]": n === "3/2",
        "cfm:aspect-[2/1]": n === "2/1",
        "cfm:aspect-[9/16]": n === "9/16",
        "cfm:aspect-[3/4]": n === "3/4",
        "cfm:aspect-[2/3]": n === "2/3",
        "cfm:aspect-[1/2]": n === "1/2"
      },
      s
    )
  }
), v1 = ({
  columns: c,
  data: t,
  cellRenderer: s,
  className: a = ""
}) => {
  const n = (f, l) => {
    if (s)
      return s(f, l);
    const i = f[l];
    return i == null ? "-" : typeof i == "object" && q.isValidElement(i) ? i : String(i);
  };
  return /* @__PURE__ */ e.jsx("div", { className: "cfm:overflow-x-auto", children: /* @__PURE__ */ e.jsxs(
    "table",
    {
      className: `cfm:min-w-full cfm:border-collapse cfm:rounded-lg cfm:overflow-hidden cfm:table-fixed ${a}`,
      children: [
        /* @__PURE__ */ e.jsx("thead", { children: /* @__PURE__ */ e.jsx("tr", { className: "cfm:h-[82px] cfm:bg-primary-50", children: c.map((f, l) => /* @__PURE__ */ e.jsx(
          "th",
          {
            className: "cfm:px-6 cfm:py-3 cfm:text-left cfm:text-xs cfm:font-medium cfm:text-black cfm:uppercase cfm:tracking-wider",
            style: {
              width: f.width,
              minWidth: f.minWidth
            },
            children: /* @__PURE__ */ e.jsx("div", { className: "cfm:truncate", children: f.header })
          },
          `header-${l}-${String(f.accessorKey)}`
        )) }) }),
        /* @__PURE__ */ e.jsx("tbody", { className: "cfm:divide-y cfm:divide-secondary-100", children: t.length === 0 ? /* @__PURE__ */ e.jsx("tr", { className: "cfm:bg-common-white", children: /* @__PURE__ */ e.jsx(
          "td",
          {
            colSpan: c.length,
            className: "cfm:px-6 cfm:py-4 cfm:text-center cfm:text-secondary-500",
            children: "No hay datos disponibles"
          }
        ) }) : t.map((f, l) => /* @__PURE__ */ e.jsx(
          "tr",
          {
            className: `${l % 2 === 0 ? "cfm:bg-common-white" : "cfm:bg-secondary-100"} cfm:hover:bg-secondary-200 cfm:transition-colors cfm:duration-150`,
            children: c.map((i, o) => /* @__PURE__ */ e.jsx(
              "td",
              {
                className: "cfm:px-6 cfm:py-4 cfm:text-sm cfm:text-secondary-900",
                style: {
                  width: i.width,
                  minWidth: i.minWidth
                },
                children: /* @__PURE__ */ e.jsx("div", { className: "cfm:truncate", children: n(f, i.accessorKey) })
              },
              `cell-${l}-${o}-${String(
                i.accessorKey
              )}`
            ))
          },
          `row-${l}`
        )) })
      ]
    }
  ) });
}, w4 = ({
  variant: c = "primary",
  description: t,
  ctaLabel: s,
  ctaAction: a,
  icon: n,
  className: f
}) => {
  const l = {
    primary: "cfm:bg-primary-50",
    tertiary: "cfm:bg-tertiary-200",
    yellow: "cfm:bg-yellow-200",
    turquoise: "cfm:bg-turquoise-50",
    secondary: "cfm:bg-secondary-200",
    salmon: "cfm:bg-salmon-50"
  }, i = {
    primary: "cfm:text-neutral-900 cfm:mix-blend-color-burn",
    tertiary: "cfm:text-secondary-900",
    yellow: "cfm:text-secondary-900",
    turquoise: "cfm:text-neutral-900 cfm:mix-blend-color-burn",
    secondary: "cfm:text-secondary-900",
    salmon: "cfm:text-neutral-900 cfm:mix-blend-color-burn"
  };
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: u(l[c], "cfm:p-6 cfm:rounded-2xl", f),
      children: /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:flex-col cfm:items-start cfm:space-y-4 cfm:h-full", children: [
        n && /* @__PURE__ */ e.jsx("img", { src: n, alt: "Ícono", className: "cfm:w-12" }),
        /* @__PURE__ */ e.jsx(
          T,
          {
            className: u(
              "cfm:flex-1 cfm:font-semibold",
              i[c]
            ),
            children: t
          }
        ),
        s && /* @__PURE__ */ e.jsx(
          Y,
          {
            action: a,
            title: s,
            className: "cfm:self-end",
            size: "sm",
            children: s
          }
        )
      ] })
    }
  );
}, b1 = ({
  image: c,
  category: t,
  title: s,
  description: a,
  ctaLabel: n,
  ctaAction: f,
  variant: l = "dark",
  className: i
}) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: u(
      "cfm:flex cfm:flex-col cfm:h-full cfm:overflow-hidden cfm:rounded-[3rem]",
      i
    ),
    children: [
      /* @__PURE__ */ e.jsx("div", { className: "cfm:relative cfm:w-full cfm:h-48 cfm:overflow-hidden cfm:rounded-t-[3rem]", children: /* @__PURE__ */ e.jsx(
        "img",
        {
          src: c,
          alt: s,
          className: "cfm:w-full cfm:h-full cfm:object-cover cfm:bg-secondary-300"
        }
      ) }),
      /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: u(
            "cfm:flex cfm:flex-col cfm:flex-grow cfm:p-6",
            l === "dark" ? "cfm:bg-gray-900" : "cfm:bg-secondary-100"
          ),
          children: [
            /* @__PURE__ */ e.jsx("div", { className: "cfm:text-center cfm:mb-2", children: /* @__PURE__ */ e.jsx(
              "span",
              {
                className: u(
                  "cfm:text-sm cfm:font-bold",
                  l === "dark" ? "cfm:text-white" : "cfm:text-primary-main"
                ),
                children: t
              }
            ) }),
            /* @__PURE__ */ e.jsx("div", { className: "cfm:text-center cfm:mb-4 cfm:min-h-[3.5rem] cfm:flex cfm:items-center cfm:justify-center", children: /* @__PURE__ */ e.jsx(
              T,
              {
                as: "h3",
                variant: "h6",
                className: u(
                  "cfm:font-bold cfm:leading-tight",
                  l === "dark" ? "cfm:text-white" : "cfm:text-typography-main"
                ),
                children: s
              }
            ) }),
            /* @__PURE__ */ e.jsx("div", { className: "cfm:text-center cfm:mb-6 cfm:flex-grow cfm:min-h-[4.5rem] cfm:flex cfm:items-start cfm:justify-center", children: /* @__PURE__ */ e.jsx(
              "p",
              {
                className: u(
                  "cfm:text-base cfm:leading-5",
                  l === "dark" ? "cfm:text-white" : "cfm:text-typography-main"
                ),
                children: a
              }
            ) }),
            /* @__PURE__ */ e.jsx("div", { className: "cfm:flex cfm:justify-center cfm:mt-auto", children: /* @__PURE__ */ e.jsx(Y, { action: f, children: n }) })
          ]
        }
      )
    ]
  }
), j4 = ({
  title: c,
  description: t,
  icon: s,
  className: a
}) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: u(
      "cfm:flex cfm:flex-col cfm:items-start cfm:text-left",
      a
    ),
    children: [
      /* @__PURE__ */ e.jsx("div", { className: "cfm:rounded-full cfm:mb-4", children: /* @__PURE__ */ e.jsx("img", { src: s, alt: c, className: "cfm:w-16" }) }),
      /* @__PURE__ */ e.jsx(T, { variant: "h5", className: "cfm:mb-2 cfm:font-bold", children: c }),
      /* @__PURE__ */ e.jsx(T, { children: t })
    ]
  }
), y1 = ({
  title: c,
  subtitle: t,
  imageSrc: s
}) => /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:flex-col cfm:space-y-1", children: [
  /* @__PURE__ */ e.jsx(_2, { src: s, alt: c, rounded: "lg", aspectRatio: "16/9" }),
  /* @__PURE__ */ e.jsx(
    T,
    {
      variant: "subtitle2",
      className: "cfm:text-primary-main cfm:font-bold cfm:mt-2",
      children: t
    }
  ),
  /* @__PURE__ */ e.jsx(T, { variant: "h6", className: "cfm:text-typography-main cfm:font-bold", children: c })
] }), N4 = ({
  title: c,
  description: t,
  img: s,
  variant: a = "primary",
  className: n
}) => {
  const f = {
    primary: "cfm:bg-primary-50",
    secondary: "cfm:bg-secondary-200",
    tertiary: "cfm:bg-tertiary-200",
    yellow: "cfm:bg-yellow-200",
    turquoise: "cfm:bg-turquoise-50",
    salmon: "cfm:bg-salmon-500"
  }, l = {
    primary: "cfm:text-primary-main",
    secondary: "cfm:text-secondary-600",
    tertiary: "cfm:text-primary-main",
    yellow: "cfm:text-primary-main",
    turquoise: "cfm:text-turquoise-main",
    salmon: "cfm:text-yellow-800"
  }, i = {
    primary: "cfm:text-neutral-900",
    secondary: "cfm:text-secondary-900",
    tertiary: "cfm:text-secondary-900",
    yellow: "cfm:text-secondary-900",
    turquoise: "cfm:text-turquoise-800",
    salmon: "cfm:text-white"
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: u(
        f[a],
        "cfm:flex cfm:flex-col cfm:items-start cfm:text-left cfm:p-8 cfm:rounded-[28px] cfm:w-full cfm:max-w-[302px] cfm:sm:max-w-none cfm:sm:w-[302px] cfm:h-[378px] cfm:shadow-[-10px_6px_15px_rgba(0,0,0,0.16)]",
        n
      ),
      children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: u(
              l[a],
              "cfm:rounded-full cfm:mb-6 cfm:w-[102px] cfm:h-[102px] cfm:rounded-full cfm:overflow-hidden cfm:border-[4px] cfm:border-solid"
            ),
            children: /* @__PURE__ */ e.jsx(
              "img",
              {
                src: s,
                alt: c,
                className: "cfm:w-full cfm:h-full cfm:object-cover cfm:object-center"
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(
          T,
          {
            as: "h3",
            variant: "h6",
            className: u(i[a], "cfm:mb-4 cfm:font-bold"),
            children: c
          }
        ),
        /* @__PURE__ */ e.jsx(
          T,
          {
            className: u(
              i[a],
              "cfm:typography-body2 max-w-[220px]"
            ),
            children: t
          }
        )
      ]
    }
  );
}, L4 = ({
  title: c,
  description: t,
  icon: s,
  backgroundImage: a,
  ctaLabel: n,
  ctaAction: f,
  className: l
}) => {
  const i = () => {
    typeof f == "function" && f();
  };
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: u(
        "cfm:flex cfm:flex-col cfm:items-start cfm:text-left cfm:px-10 cfm:py-14 cfm:rounded-[28px] cfm:w-full cfm:max-w-[384px] cfm:h-[322px] cfm:relative cfm:overflow-hidden",
        a && "cfm:bg-cover cfm:bg-center cfm:bg-no-repeat",
        l
      ),
      style: { backgroundImage: a ? `url(${a})` : void 0 },
      children: /* @__PURE__ */ e.jsxs("div", { className: "cfm:relative cfm:z-10 cfm:flex cfm:flex-col cfm:h-full cfm:w-full", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:justify-between cfm:items-center cfm:w-full", children: [
          /* @__PURE__ */ e.jsx(T, { variant: "subtitle1", className: "cfm:font-bold", children: c }),
          typeof s == "string" ? /* @__PURE__ */ e.jsx(
            "img",
            {
              src: s,
              alt: c,
              className: "cfm:w-12 cfm:h-12 cfm:object-cover cfm:object-center"
            }
          ) : /* @__PURE__ */ e.jsx("div", { className: "cfm:text-5xl cfm:text-current", children: s })
        ] }),
        /* @__PURE__ */ e.jsx(
          T,
          {
            variant: "body1",
            className: "cfm:text-current cfm:my-6 cfm:flex-1",
            children: t
          }
        ),
        n && f && /* @__PURE__ */ e.jsx(
          Y,
          {
            variant: "text",
            color: "primary",
            onClick: i,
            className: "cfm:text-current cfm:text-left cfm:justify-start",
            children: n
          }
        )
      ] })
    }
  );
}, k4 = ({
  title: c,
  description: t,
  img: s,
  imgPosition: a = "left",
  ctaLabel: n = "Conoce más",
  ctaAction: f,
  className: l
}) => {
  const i = () => {
    switch (a) {
      case "right":
        return "cfm:md:flex-row-reverse";
      default:
        return "cfm:md:flex-row";
    }
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: u(
        `${i()} cfm:flex cfm:flex-col cfm:md:items-center cfm:max-w-[354px] cfm:md:max-w-[996px] cfm:mx-auto cfm:gap-6`,
        l
      ),
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "cfm:md:w-1/2 cfm:flex cfm:justify-center cfm:items-center cfm:md:h-[388px]", children: /* @__PURE__ */ e.jsx(
          "img",
          {
            src: s,
            alt: c,
            className: "cfm:rounded-[48px] cfm:w-full cfm:h-auto cfm:object-cover cfm:object-center"
          }
        ) }),
        /* @__PURE__ */ e.jsxs("div", { className: "cfm:md:w-1/2 cfm:flex cfm:flex-col cfm:justify-center", children: [
          /* @__PURE__ */ e.jsx(T, { variant: "h3", className: "cfm:mb-6", children: c }),
          /* @__PURE__ */ e.jsx(T, { children: t }),
          f && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("div", { className: "cfm:hidden cfm:md:flex cfm:mt-8", children: /* @__PURE__ */ e.jsx(
              Y,
              {
                action: f,
                variant: "outlined",
                color: "primary",
                size: "lg",
                children: n
              }
            ) }),
            /* @__PURE__ */ e.jsx("div", { className: "cfm:flex cfm:md:hidden cfm:w-full cfm:mt-8", children: /* @__PURE__ */ e.jsx(
              Y,
              {
                action: f,
                variant: "outlined",
                color: "primary",
                className: "cfm:mx-auto",
                children: n
              }
            ) })
          ] })
        ] })
      ]
    }
  );
}, M4 = ({
  title: c,
  ctaAction: t,
  ctaLabel: s,
  plans: a
}) => /* @__PURE__ */ e.jsxs("div", { className: "cfm:overflow-hidden cfm:flex cfm:items-center cfm:flex-col cfm:gap-1.5 cfm:w-[384px]", children: [
  /* @__PURE__ */ e.jsx("div", { className: "cfm:bg-primary-50 cfm:text-center cfm:h-12 cfm:rounded-lg cfm:flex cfm:justify-center cfm:items-center cfm:w-full", children: /* @__PURE__ */ e.jsx(
    T,
    {
      variant: "h6",
      as: "h3",
      className: "cfm:text-primary-main cfm:font-bold",
      children: c
    }
  ) }),
  a.map((n, f) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "cfm:flex cfm:justify-between cfm:items-center cfm:even:bg-secondary-100 cfm:mx-0 cfm:py-6 cfm:px-4 cfm:w-full",
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "cfm:flex cfm:justify-center cfm:flex-col", children: n.left.map((l, i) => /* @__PURE__ */ e.jsx(
          T,
          {
            className: "cfm:font-semibold cfm:text-gray-800 cfm:mb-2",
            children: l
          },
          i
        )) }),
        /* @__PURE__ */ e.jsx("div", { className: "cfm:text-right cfm:text-gray-900 cfm:text-base cfm:min-w-[150px]", children: n.right.map((l, i) => /* @__PURE__ */ e.jsx("div", { children: l }, i)) })
      ]
    },
    f
  )),
  t && /* @__PURE__ */ e.jsx(Y, { className: "cfm:mt-1.5", action: t, children: s || "Ver más" })
] });
class E4 {
  constructor() {
    S2(this, "messages", []);
    S2(this, "observers", []);
  }
  subscribe(t) {
    this.observers.includes(t) || this.observers.push(t);
  }
  unSubscribe(t) {
    const s = this.observers.indexOf(t);
    s !== -1 && this.observers.splice(s, 1);
  }
  notify() {
    for (const t of this.observers)
      t.update(this.messages);
  }
  notifyStreamResponse(t) {
    for (const s of this.observers)
      s.updateStreamResponse(t);
  }
  addInitialMessage(t) {
    if (this.messages.length === 0) {
      const s = {
        id: "initial",
        content: t,
        sender: "bot",
        timestamp: /* @__PURE__ */ new Date()
      };
      this.messages.push(s), this.notify();
    }
  }
  addUserMessage(t) {
    if (t.trim() === "") return;
    const s = {
      id: Date.now().toString(),
      content: t,
      sender: "user",
      timestamp: /* @__PURE__ */ new Date()
    };
    this.messages.push(s), this.notify();
  }
  addBotMessage(t) {
    const s = {
      id: Date.now().toString(),
      content: t,
      sender: "bot",
      timestamp: /* @__PURE__ */ new Date()
    };
    this.messages.push(s), this.notify();
  }
  updateStreamContent(t) {
    this.notifyStreamResponse(t);
  }
  getMessages() {
    return this.messages;
  }
}
const S4 = (c) => c.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), w1 = ({
  initialMessage: c,
  onMessage: t,
  onMessageStream: s,
  className: a,
  aliasUser: n = "Tú",
  aliasBot: f = "Soporte",
  titleChat: l = "Chat de Soporte",
  placeholder: i = "Escribe un mensaje...",
  mode: o = "floating",
  logo: m
}) => {
  const [x, p] = z(!1), [g, S] = z([]), [M] = z(new E4()), [C, w] = z(""), [E, j] = z(""), b = W(null), y = W(null);
  I(() => {
    const Z = {
      update: (U) => {
        S([...U]);
      },
      updateStreamResponse: (U) => {
        j((J) => J + U);
      }
    };
    return M.subscribe(Z), () => {
      M.unSubscribe(Z);
    };
  }, [M]), I(() => {
    M.addInitialMessage(c);
  }, [M, c]), I(() => {
    N();
  }, [g, E]), I(() => {
    y.current && (y.current.style.height = "auto", y.current.style.height = `${y.current.scrollHeight}px`);
  }, [C]), I(() => {
    o === "full" && p(!0);
  }, [o]);
  const N = () => {
    b.current && b.current.scrollIntoView({ behavior: "smooth" });
  }, O = () => {
    p(!x);
  }, G = (Z) => {
    w(Z.target.value);
  }, D = (Z) => {
    Z.key === "Enter" && !Z.shiftKey && (Z.preventDefault(), s2(Z));
  }, s2 = (Z) => {
    if (Z.preventDefault(), C.trim() === "") return;
    M.addUserMessage(C);
    const U = C;
    w(""), t == null || t(U, (A) => {
      M.addBotMessage(A);
    });
    let J = "";
    s == null || s(
      U,
      (A) => {
        J += A, M.updateStreamContent(A), N();
      },
      () => {
        M.addBotMessage(J), j("");
      }
    );
  };
  return /* @__PURE__ */ e.jsxs("div", { className: u(a), children: [
    o !== "full" && /* @__PURE__ */ e.jsx(
      "button",
      {
        onClick: O,
        className: u(
          "cfm:fixed cfm:bottom-6 cfm:right-6 cfm:w-14 cfm:h-14 cfm:rounded-full cfm:flex cfm:items-center cfm:justify-center cfm:shadow-lg cfm:transition-all cfm:duration-300 cfm:cursor-pointer",
          {
            "cfm:bg-secondary-dark cfm:rotate-90": x,
            "cfm:bg-primary-main cfm:hover:bg-primary-light": !x
          }
        ),
        "aria-label": x ? "Cerrar chat" : "Abrir chat",
        children: x ? (
          // Icono X (cerrar)
          /* @__PURE__ */ e.jsxs(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "cfm:text-white",
              children: [
                /* @__PURE__ */ e.jsx("path", { d: "M18 6 6 18" }),
                /* @__PURE__ */ e.jsx("path", { d: "m6 6 12 12" })
              ]
            }
          )
        ) : (
          // Icono de chat
          /* @__PURE__ */ e.jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "cfm:text-white",
              children: /* @__PURE__ */ e.jsx("path", { d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" })
            }
          )
        )
      }
    ),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: u(
          "cfm:fixed cfm:bg-white cfm:shadow-xl cfm:transition-all cfm:duration-300",
          {
            "cfm:flex cfm:flex-col": x,
            "cfm:hidden cfm:scale-95 cfm:pointer-events-none": !x,
            "cfm:w-full cfm:h-full": o === "full",
            "cfm:bottom-24 cfm:right-6 cfm:w-85 cfm:md:w-96 cfm:rounded-3xl cfm:h-full cfm:max-h-[80vh] cfm:md:max-h-[60vh] cfm:lg:max-h-[80vh] cfm:xl:max-h-[60vh]": o !== "full"
          }
        ),
        children: [
          /* @__PURE__ */ e.jsxs("div", { className: u(
            "cfm:bg-primary-main cfm:text-white cfm:p-4 cfm:flex cfm:items-center",
            {
              "cfm:rounded-t-3xl cfm:justify-between": o !== "full"
            }
          ), children: [
            m && /* @__PURE__ */ e.jsx(
              "img",
              {
                src: m,
                alt: "Logo",
                className: "cfm:h-5 cfm:mr-5"
              }
            ),
            /* @__PURE__ */ e.jsx("h3", { className: "cfm:font-medium cfm:mt-2", children: l }),
            o !== "full" && /* @__PURE__ */ e.jsx(
              "button",
              {
                onClick: O,
                className: "cfm:text-white cfm:cursor-pointer",
                children: /* @__PURE__ */ e.jsxs(
                  "svg",
                  {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                      /* @__PURE__ */ e.jsx("path", { d: "M18 6 6 18" }),
                      /* @__PURE__ */ e.jsx("path", { d: "m6 6 12 12" })
                    ]
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: u(
            "cfm:flex-1 cfm:overflow-y-auto cfm:p-4 cfm:space-y-4",
            {
              "cfm:max-w-4xl cfm:mx-auto cfm:w-full": o === "full"
            }
          ), children: [
            g.map((Z) => /* @__PURE__ */ e.jsxs(
              "div",
              {
                className: u("cfm:p-3 cfm:rounded-lg", {
                  "cfm:bg-primary-300 cfm:text-white cfm:ml-auto cfm:rounded-br-none": Z.sender === "user",
                  "cfm:bg-secondary-100 cfm:text-typography-main cfm:rounded-bl-none": Z.sender === "bot",
                  "cfm:max-w-[60%]": o === "full",
                  "cfm:max-w-[80%]": o !== "full"
                }),
                children: [
                  /* @__PURE__ */ e.jsxs("div", { className: "cfm:text-sm cfm:font-semibold cfm:mb-1 cfm:flex cfm:justify-between", children: [
                    /* @__PURE__ */ e.jsx("p", { children: Z.sender === "user" ? `${n}:` : `${f}:` }),
                    /* @__PURE__ */ e.jsx("div", { className: "cfm:text-xs cfm:text-right cfm:self-center", children: /* @__PURE__ */ e.jsx("span", { children: S4(Z.timestamp) }) })
                  ] }),
                  /* @__PURE__ */ e.jsx("p", { children: Z.content })
                ]
              },
              Z.id
            )),
            E && /* @__PURE__ */ e.jsxs("div", { className: "cfm:max-w-[80%] cfm:p-3 cfm:rounded-lg cfm:bg-secondary-100 cfm:text-typography-main cfm:rounded-bl-none", children: [
              /* @__PURE__ */ e.jsx("div", { className: "cfm:text-sm cfm:font-semibold cfm:mb-1", children: /* @__PURE__ */ e.jsx("p", { children: `${f}:` }) }),
              /* @__PURE__ */ e.jsx("p", { children: E })
            ] }),
            /* @__PURE__ */ e.jsx("div", { ref: b })
          ] }),
          /* @__PURE__ */ e.jsx(
            "form",
            {
              onSubmit: s2,
              className: u(
                "cfm:p-4 cfm:border-t cfm:border-gray-200 cfm:rounded-b-3xl",
                {
                  "cfm:max-w-4xl cfm:mx-auto cfm:w-full": o === "full"
                }
              ),
              children: /* @__PURE__ */ e.jsxs("div", { className: "cfm:relative", children: [
                /* @__PURE__ */ e.jsx(
                  "textarea",
                  {
                    ref: y,
                    value: C,
                    onChange: G,
                    onKeyDown: D,
                    placeholder: i,
                    className: "cfm:w-full cfm:border cfm:border-secondary-500 cfm:rounded-3xl cfm:py-2 cfm:pl-6 cfm:pr-14 cfm:focus:outline-none cfm:focus:ring-2 cfm:focus:ring-primary-main cfm:focus:border-transparent cfm:resize-none cfm:overflow-hidden",
                    style: {
                      minHeight: "40px",
                      maxHeight: "120px",
                      lineHeight: "1.5",
                      textIndent: "0px"
                    },
                    rows: 1
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  "button",
                  {
                    type: "submit",
                    className: "cfm:absolute cfm:right-5 cfm:bottom-1/2 cfm:transform cfm:translate-y-1/2 cfm:text-primary-400 cfm:hover:text-primary-main/80 cfm:disabled:text-secondary-500",
                    disabled: C.trim() === "",
                    children: /* @__PURE__ */ e.jsxs(
                      "svg",
                      {
                        className: "cfm:cursor-pointer",
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [
                          /* @__PURE__ */ e.jsx("path", { d: "m22 2-7 20-4-9-9-4Z" }),
                          /* @__PURE__ */ e.jsx("path", { d: "M22 2 11 13" })
                        ]
                      }
                    )
                  }
                )
              ] })
            }
          )
        ]
      }
    )
  ] });
}, V4 = ({
  items: c,
  handleClick: t,
  activeId: s,
  className: a
}) => /* @__PURE__ */ e.jsx(
  "div",
  {
    className: u(
      "cfm:transition-all cfm:duration-300 cfm:flex cfm:justify-center cfm:gap-12 cfm:mb-12 cfm:mx-auto",
      a
    ),
    children: c.map((n) => /* @__PURE__ */ e.jsxs(
      "button",
      {
        onClick: () => t(n.id),
        className: u(
          {
            "cfm:hover:text-typography-light": s !== n.id
          },
          "cfm:w-[200px] cfm:h-[60px] cfm:bg-transparent cfm:flex cfm:items-start cfm:justify-center cfm:text-typography-subtitle1 cfm:font-bold cfm:relative cfm:cursor-pointer"
        ),
        children: [
          /* @__PURE__ */ e.jsx("span", { children: n.label }),
          /* @__PURE__ */ e.jsx(
            "span",
            {
              className: u(
                {
                  "cfm:w-full": s === n.id,
                  "cfm:w-0": s !== n.id
                },
                "cfm:absolute cfm:bottom-0 cfm:left-0 cfm:h-1 cfm:bg-primary-main cfm:transition-all cfm:duration-300 cfm:rounded"
              )
            }
          )
        ]
      },
      n.id
    ))
  }
), i0 = ({ className: c = "" }) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    width: "15",
    height: "8",
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${c}`,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M14.0724 0.98179C14.1158 1.00147 14.1519 1.03126 14.1766 1.0678C14.2013 1.10434 14.2137 1.14614 14.2123 1.18845C14.211 1.23514 14.1977 1.281 14.1735 1.32278C14.1494 1.36456 14.1149 1.40125 14.0724 1.43018L7.44607 7.11057C7.4233 7.14804 7.38881 7.17923 7.34652 7.2006C7.30423 7.22197 7.25581 7.23266 7.20683 7.23143C7.15277 7.23037 7.09964 7.21899 7.05127 7.19809C7.0029 7.1772 6.96038 7.1473 6.92696 7.11057L0.352329 1.43018C0.309169 1.4106 0.273224 1.38095 0.248507 1.34465C0.22379 1.30835 0.211318 1.26681 0.212476 1.2247C0.213708 1.17799 0.226883 1.13209 0.251068 1.0903C0.275253 1.04851 0.309815 1.01185 0.352329 0.982971L0.979021 0.429461C1.00442 0.392884 1.04032 0.362547 1.08319 0.341383C1.12605 0.32022 1.17452 0.308933 1.22389 0.308594C1.27748 0.311673 1.32971 0.323951 1.37775 0.344703C1.42578 0.365454 1.46859 0.39427 1.5036 0.429461L7.20257 5.30615L12.9015 0.429461C12.9269 0.392884 12.9628 0.362547 13.0057 0.341383C13.0486 0.32022 13.097 0.308933 13.1464 0.308594C13.2 0.31174 13.2522 0.32403 13.3003 0.344776C13.3483 0.365523 13.3911 0.394321 13.4261 0.429461L14.0724 0.98179Z",
        fill: "#EE2B7B"
      }
    )
  }
), T4 = ({
  items: c,
  handleClick: t,
  activeId: s,
  className: a
}) => {
  const [n, f] = z(!1), l = (i) => {
    t(i), f(!1);
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: u(
        "cfm:relative cfm:flex cfm:justify-center cfm:w-full cfm:max-w-[354px] cfm:mx-auto cfm:mb-8",
        a
      ),
      children: [
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            className: u(
              "cfm:flex cfm:justify-between cfm:items-center cfm:px-[20px]",
              "cfm:w-full cfm:h-[60px] cfm:rounded-[8px] cfm:shadow-[3px_3px_14px_rgba(0,0,0,0.21)]",
              "cfm:text-[14px] cfm:leading-[19px] cfm:bg-transparent"
            ),
            onClick: () => f(!n),
            children: [
              /* @__PURE__ */ e.jsx("span", { className: "cfm:font-bold", children: c[s].label }),
              n ? /* @__PURE__ */ e.jsx(i0, { className: "cfm:-rotate-180 cfm:transition-all cfm:duration-300" }) : /* @__PURE__ */ e.jsx(i0, { className: "cfm:transition-all cfm:duration-300" })
            ]
          }
        ),
        n && /* @__PURE__ */ e.jsx(
          "div",
          {
            className: u(
              "cfm:absolute cfm:flex cfm:flex-col cfm:top-[120%] cfm:left-0 cfm:bg-white cfm:rounded-[8px]",
              "cfm:shadow-[3px_3px_14px_rgba(0,0,0,0.21)] cfm:w-[354px] cfm:py-[10px] cfm:overflow-hidden cfm:z-[1]"
            ),
            children: c.map((i) => /* @__PURE__ */ e.jsx(
              "button",
              {
                className: "cfm:px-[20px] cfm:py-[10px] cfm:bg-white cfm:text-[14px] cfm:font-bold",
                onClick: () => l(i.id),
                children: i.label
              },
              i.id
            ))
          }
        )
      ]
    }
  );
}, j1 = ({
  title: c,
  subtitle: t,
  items: s = [],
  imageSrc: a = "https://placehold.co/600x300",
  ctaLabel: n = "Ver más",
  ctaAction: f,
  className: l = "",
  id: i,
  ...o
}) => {
  const [m, x] = z(
    0
  ), p = (g) => {
    x(m === g ? null : g);
  };
  return /* @__PURE__ */ e.jsx(i2, { id: i, className: "cfm:p-0 cfm:px-0", children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      ...o,
      className: u(
        "cfm:rounded-[60px] cfm:bg-salmon-50 cfm:p-6 cfm:py-18 cfm:w-full cfm:mx-auto cfm:relative cfm:overflow-hidden",
        l
      ),
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "cfm:text-center cfm:mb-8 cfm:md:mb-12", children: [
          t && /* @__PURE__ */ e.jsx(
            T,
            {
              variant: "subtitle1",
              className: "cfm:text-salmon-900 cfm:font-bold cfm:mb-4",
              children: t
            }
          ),
          /* @__PURE__ */ e.jsx(
            T,
            {
              variant: "h3",
              as: "h2",
              className: "cfm:font-bold cfm:text-salmon-900",
              children: c
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "cfm:grid cfm:grid-cols-1 cfm:md:grid-cols-2 cfm:gap-8 cfm:mt-8", children: [
          /* @__PURE__ */ e.jsx("div", { className: "cfm:w-full cfm:space-y-4", children: s.map((g, S) => {
            const M = m === S;
            return /* @__PURE__ */ e.jsxs(
              "div",
              {
                className: "cfm:rounded-xl cfm:transition-all cfm:duration-200",
                children: [
                  /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs(
                    "button",
                    {
                      type: "button",
                      className: "cfm:flex cfm:justify-between cfm:items-center cfm:p-4 cfm:cursor-pointer cfm:w-full cfm:text-left",
                      onClick: () => p(S),
                      "aria-expanded": M,
                      "aria-controls": `benefit-content-${g.id}`,
                      children: [
                        /* @__PURE__ */ e.jsx(
                          T,
                          {
                            className: "cfm:font-bold cfm:text-lg cfm:text-salmon-900",
                            variant: "h6",
                            children: g.title
                          }
                        ),
                        /* @__PURE__ */ e.jsx(
                          "div",
                          {
                            className: "cfm:w-12.5 cfm:h-12.5 cfm:rounded-full cfm:flex cfm:items-center cfm:justify-center cfm:transition-all cfm:bg-salmon-200 cfm:flex-shrink-0",
                            children: /* @__PURE__ */ e.jsx(
                              "span",
                              {
                                className: "cfm:font-bold cfm:text-lg cfm:text-salmon-900 cfm:leading-none",
                                children: M ? "−" : "+"
                              }
                            )
                          }
                        )
                      ]
                    }
                  ) }),
                  /* @__PURE__ */ e.jsx(
                    "div",
                    {
                      id: `benefit-content-${g.id}`,
                      className: u(
                        "cfm:px-4 cfm:transition-all cfm:overflow-hidden",
                        M ? "cfm:max-h-96 cfm:opacity-100 cfm:py-4" : "cfm:max-h-0 cfm:opacity-0 cfm:py-0"
                      ),
                      style: {
                        transitionProperty: "max-height, opacity, padding"
                      },
                      children: /* @__PURE__ */ e.jsx(T, { className: "cfm:text-salmon-900", variant: "body2", children: g.description })
                    }
                  )
                ]
              },
              g.id
            );
          }) }),
          /* @__PURE__ */ e.jsxs("div", { className: "cfm:w-full cfm:flex cfm:flex-col cfm:justify-center cfm:items-start", children: [
            /* @__PURE__ */ e.jsx("div", { className: "cfm:rounded-3xl cfm:overflow-hidden cfm:w-full cfm:aspect-[4/3] cfm:relative", children: /* @__PURE__ */ e.jsx(
              "img",
              {
                src: a,
                alt: "Benefit illustration",
                className: "cfm:object-cover cfm:w-full cfm:h-full",
                loading: "lazy"
              }
            ) }),
            f && /* @__PURE__ */ e.jsx("div", { className: "cfm:w-full cfm:flex cfm:justify-center cfm:mt-8", children: /* @__PURE__ */ e.jsx(Y, { action: f, className: "cfm:font-medium", children: n }) })
          ] })
        ] })
      ]
    }
  ) });
}, N1 = ({
  tagline: c,
  heading: t,
  description: s,
  cards: a,
  className: n,
  ...f
}) => /* @__PURE__ */ e.jsxs("section", { ...f, className: u("cfm:section-contained", n), children: [
  /* @__PURE__ */ e.jsx(
    r2,
    {
      tagline: c,
      heading: t,
      description: s
    }
  ),
  /* @__PURE__ */ e.jsx("div", { className: "cfm:grid cfm:sm:grid-cols-2 cfm:lg:grid-cols-4 cfm:gap-3", children: a.map(({ id: l, ...i }) => /* @__PURE__ */ e.jsx(w4, { ...i }, l)) })
] }), L1 = ({
  tagline: c,
  heading: t,
  description: s,
  cards: a,
  className: n,
  ...f
}) => /* @__PURE__ */ e.jsxs(
  "section",
  {
    ...f,
    className: u(
      "cfm:section-contained",
      n
    ),
    children: [
      /* @__PURE__ */ e.jsx(
        r2,
        {
          tagline: c,
          heading: t,
          description: s,
          className: "cfm:mb-16"
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "cfm:grid cfm:sm:grid-cols-2 cfm:lg:grid-cols-4 cfm:gap-8 cfm:lg:gap-5 cfm:xl:w-7/10 cfm:mx-auto", children: a.map(({ id: l, ...i }) => /* @__PURE__ */ e.jsx(j4, { ...i }, l)) })
    ]
  }
), k1 = ({
  tagline: c,
  heading: t,
  description: s,
  cards: a,
  className: n,
  ...f
}) => /* @__PURE__ */ e.jsxs(
  "section",
  {
    ...f,
    className: u(
      "cfm:section-contained",
      n
    ),
    children: [
      /* @__PURE__ */ e.jsx(
        r2,
        {
          tagline: c,
          heading: t,
          description: s,
          className: "cfm:mb-16"
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "cfm:grid cfm:sm:grid-cols-2 cfm:lg:grid-cols-3 cfm:gap-8 cfm:lg:gap-5 cfm:mx-auto", children: a.map(({ id: l, ...i }) => /* @__PURE__ */ e.jsx(L4, { ...i }, l)) })
    ]
  }
), r2 = ({
  tagline: c,
  heading: t,
  description: s,
  className: a
}) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: u(
      "cfm:text-center cfm:sm:w-8/10 cfm:mx-auto cfm:mb-8 cfm:md:mb-12",
      a
    ),
    children: [
      c && /* @__PURE__ */ e.jsx(
        T,
        {
          as: "span",
          variant: "subtitle1",
          className: "cfm:text-primary-main cfm:font-bold cfm:mb-4",
          children: c
        }
      ),
      /* @__PURE__ */ e.jsx(
        T,
        {
          variant: "h3",
          as: "h2",
          className: "cfm:font-bold cfm:text-secondary-900",
          children: t
        }
      ),
      s && /* @__PURE__ */ e.jsx(T, { className: "cfm:mt-6 cfm:text-secondary-900", children: s })
    ]
  }
), M1 = ({
  imageUrl: c,
  title: t,
  description: s,
  buttonText: a,
  buttonAction: n
}) => /* @__PURE__ */ e.jsxs("section", { className: "cfm:section-contained cfm:flex cfm:flex-col cfm:md:flex-row cfm:items-center cfm:justify-center cfm:space-y-8 cfm:md:space-y-0 cfm:md:space-x-8", children: [
  /* @__PURE__ */ e.jsx("div", { className: "cfm:w-full cfm:md:w-1/2 cfm:md:pr-18", children: /* @__PURE__ */ e.jsx(
    _2,
    {
      src: c,
      alt: t,
      rounded: "full",
      className: "cfm:object-cover cfm:aspect-[3/5] cfm:max-w-sm cfm:mx-auto cfm:md:float-right"
    }
  ) }),
  /* @__PURE__ */ e.jsxs("div", { className: "cfm:w-full cfm:md:w-1/2 cfm:text-left cfm:lg:pr-18", children: [
    /* @__PURE__ */ e.jsx(T, { variant: "h3", as: "h2", className: "cfm:text-primary cfm:mb-4", children: t }),
    /* @__PURE__ */ e.jsx(T, { variant: "body1", className: "cfm:text-gray-700 cfm:mb-12", children: s }),
    /* @__PURE__ */ e.jsx(Y, { color: "primary", variant: "outlined", size: "xl", action: n, children: a })
  ] })
] }), E1 = ({
  title: c,
  description: t,
  imageUrl: s = "https://picsum.photos/1200/600",
  buttonText: a,
  onButtonClick: n
}) => /* @__PURE__ */ e.jsx("div", { className: "cfm:section-contained-bg cfm:text-center cfm:relative cfm:bg-black cfm:overflow-hidden", children: /* @__PURE__ */ e.jsxs("div", { className: "cfm:my-20 cfm:max-w-3xl cfm:mx-auto", children: [
  /* @__PURE__ */ e.jsx(
    _2,
    {
      src: s,
      alt: "Background",
      className: "cfm:absolute cfm:left-0 cfm:top-0 cfm:w-full cfm:h-full cfm:opacity-40"
    }
  ),
  /* @__PURE__ */ e.jsxs("div", { className: "cfm:relative cfm:z-10 cfm:flex cfm:flex-col cfm:items-center cfm:justify-center", children: [
    /* @__PURE__ */ e.jsx(T, { variant: "h3", as: "h2", className: "cfm:text-white cfm:mb-4", children: c }),
    /* @__PURE__ */ e.jsx(T, { variant: "body2", className: "cfm:text-white cfm:mb-6", children: t }),
    /* @__PURE__ */ e.jsx(Y, { color: "primary", onClick: n, children: a })
  ] })
] }) }), S1 = ({
  tagline: c,
  heading: t,
  description: s,
  cards: a,
  className: n,
  ...f
}) => /* @__PURE__ */ e.jsx(i2, { ...f, children: /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: u(
      "cfm:flex cfm:flex-col cfm:items-center",
      "cfm:rounded-[60px]",
      "cfm:bg-secondary-100",
      "cfm:p-6 cfm:py-18 cfm:w-full cfm:mx-auto"
    ),
    children: [
      /* @__PURE__ */ e.jsx(
        r2,
        {
          tagline: c,
          heading: t,
          description: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: `cfm:relative cfm:z-0 cfm:grid cfm:justify-center cfm:gap-4 cfm:md:grid-cols-2 cfm:lg:grid-cols-${a.length} cfm:max-w-[812px] cfm:mt-4 cfm:lg:mr-${a.length === 3 ? "8" : "0"}`,
          children: a.map(({ id: l, ...i }, o) => {
            let m = "";
            return a.length === 3 && (m = `cfm:relative ${o === 0 ? "cfm:lg:-rotate-5 cfm:lg:-translate-y-2 cfm:z-0" : o === 2 ? "cfm:lg:rotate-5 cfm:lg:-translate-y-2 cfm:z-20" : "cfm:lg:rotate-0 cfm:z-10"} ${o === 1 ? "cfm:lg:hover:-translate-y-8" : "cfm:lg:hover:-translate-y-6"} cfm:duration-300`), /* @__PURE__ */ e.jsx(N4, { ...i, className: m }, l);
          })
        }
      )
    ]
  }
) }), V1 = ({
  title: c,
  description: t,
  ctaLabel: s = "Conoce más",
  ctaAction: a,
  img: n,
  imgPosition: f = "right",
  imgBackground: l,
  backgroundColor: i,
  breadcrumbItems: o,
  className: m
}) => {
  const x = () => {
    switch (f) {
      case "right":
        return "cfm:md:flex-row";
      default:
        return "cfm:md:flex-row-reverse";
    }
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "cfm:relative cfm:w-full",
      style: { backgroundColor: i || "white" },
      children: [
        l && /* @__PURE__ */ e.jsx(
          "img",
          {
            src: l,
            alt: "",
            className: "cfm:absolute cfm:top-0 cfm:right-0 cfm:w-full cfm:h-auto cfm:object-cover cfm:object-center"
          }
        ),
        /* @__PURE__ */ e.jsxs(
          i2,
          {
            className: u(
              x(),
              "cfm:flex",
              "cfm:flex-col",
              "cfm:md:items-center",
              "cfm:mx-auto",
              "cfm:gap-6",
              m
            ),
            children: [
              /* @__PURE__ */ e.jsxs("div", { className: "cfm:md:w-1/2 cfm:flex cfm:flex-col cfm:justify-center cfm:mb-[80px] cfm:lg:mb-[104px]", children: [
                o && /* @__PURE__ */ e.jsx(H4, { items: o, className: "cfm:mb-6 cfm:hidden cfm:md:block" }),
                /* @__PURE__ */ e.jsx(T, { variant: "h2", as: "h1", className: "cfm:mb-6", children: c }),
                /* @__PURE__ */ e.jsx(T, { children: t }),
                a && /* @__PURE__ */ e.jsx("div", { className: "cfm:mt-12", children: /* @__PURE__ */ e.jsx(Y, { action: a, children: s }) })
              ] }),
              /* @__PURE__ */ e.jsx("div", { className: "cfm:md:w-1/2 cfm:flex cfm:justify-center cfm:items-center cfm:max-w-[588px]", children: /* @__PURE__ */ e.jsx(
                "img",
                {
                  src: n,
                  alt: c,
                  className: "cfm:rounded-[48px] cfm:w-full cfm:h-auto cfm:md:h-[446px] cfm:lg:h-[548px] cfm:object-cover cfm:object-center"
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}, T1 = ({
  tagline: c,
  heading: t,
  description: s,
  cards: a,
  items: n,
  className: f,
  ...l
}) => {
  const [i, o] = z(0);
  return /* @__PURE__ */ e.jsxs(i2, { ...l, children: [
    /* @__PURE__ */ e.jsx(
      r2,
      {
        tagline: c,
        heading: t,
        description: s,
        className: "cfm:md:mb-26"
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "cfm:hidden cfm:md:block", children: /* @__PURE__ */ e.jsx(
      V4,
      {
        items: n,
        activeId: i,
        handleClick: (m) => o(m)
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { className: "cfm:md:hidden cfm:w-full", children: /* @__PURE__ */ e.jsx(
      T4,
      {
        items: n,
        activeId: i,
        handleClick: (m) => o(m)
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { children: a.map(
      ({ ...m }, x) => x === i ? /* @__PURE__ */ e.jsx(k4, { ...m }, x) : null
    ) })
  ] });
}, _1 = ({
  tagline: c,
  heading: t,
  description: s,
  cards: a,
  className: n,
  ...f
}) => /* @__PURE__ */ e.jsx(i2, { ...f, children: /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: u(
      "cfm:flex cfm:flex-col cfm:items-center",
      "cfm:w-full cfm:mx-auto"
    ),
    children: [
      /* @__PURE__ */ e.jsx(
        r2,
        {
          tagline: c,
          heading: t,
          description: s
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "cfm:flex cfm:flex-wrap cfm:gap-12 cfm:lg:gap-6 cfm:items-start cfm:justify-center", children: a.map(({ ...l }, i) => /* @__PURE__ */ e.jsx(M4, { ...l }, i)) })
    ]
  }
) }), _4 = ({
  ids: c,
  navHeight: t = 0,
  visibleThreshold: s = 0.5,
  topMargin: a = 0,
  bottomMargin: n = "-70%",
  debounceTime: f = 400
}) => {
  const [l, i] = z(
    c.length > 0 ? c[0] : ""
  ), o = W(null), m = W(null), x = W(null);
  return I(() => {
    o.current && o.current.disconnect();
    const S = {
      root: null,
      rootMargin: `-${t + a}px 0px ${n} 0px`,
      // Usar menos thresholds para reducir la frecuencia de actualizaciones
      threshold: s
    }, M = (E) => {
      x.current = E, m.current !== null && window.clearTimeout(m.current), m.current = window.setTimeout(() => {
        x.current === E && i(E), m.current = null;
      }, f);
    }, C = /* @__PURE__ */ new Map(), w = (E) => {
      E.forEach((b) => {
        C.set(
          b.target.id,
          b.isIntersecting ? b.intersectionRatio : 0
        );
      });
      const j = Array.from(C.entries()).filter(([b, y]) => y > 0).sort((b, y) => {
        if (Math.abs(b[1] - y[1]) > 0.2)
          return y[1] - b[1];
        const N = document.getElementById(b[0]), O = document.getElementById(y[0]);
        return N && O ? N.getBoundingClientRect().top - O.getBoundingClientRect().top : 0;
      });
      j.length > 0 && M(j[0][0]);
    };
    return o.current = new IntersectionObserver(
      w,
      S
    ), c.forEach((E) => {
      var b;
      const j = document.getElementById(E);
      j && (C.set(E, 0), (b = o.current) == null || b.observe(j));
    }), () => {
      var E;
      m.current !== null && window.clearTimeout(m.current), (E = o.current) == null || E.disconnect();
    };
  }, [c, t, s, a, n, f]), {
    activeId: l,
    setActiveId: (g) => {
      x.current = g, i(g);
    }
  };
};
function B4() {
  const c = W(null), [t, s] = z(!1), [a, n] = z(0);
  return I(() => {
    if (typeof window > "u") return;
    const f = c.current;
    if (!f) return;
    const l = () => {
      const m = f.getBoundingClientRect().top + window.scrollY;
      return n(m), m;
    };
    let i = l();
    window.addEventListener("resize", () => {
      i = l();
    });
    const o = () => {
      requestAnimationFrame(() => {
        window.scrollY > i ? s(!0) : s(!1);
      });
    };
    return window.addEventListener("scroll", o), o(), () => {
      window.removeEventListener("scroll", o), window.removeEventListener("resize", l), document.body.style.paddingTop = "0px";
    };
  }, []), { navRef: c, isSticky: t, navTop: a };
}
const B1 = ({ items: c, className: t }) => {
  var o;
  const { navRef: s, isSticky: a } = B4(), n = c.map((m) => m.id), { activeId: f, setActiveId: l } = _4({
    ids: n,
    // Calcular la altura del nav dinámicamente
    navHeight: ((o = s.current) == null ? void 0 : o.offsetHeight) ?? 0,
    // Personaliza estos valores según necesites
    visibleThreshold: 0.3,
    bottomMargin: "0%"
  }), i = (m) => {
    l(m);
  };
  return I(() => {
    (() => {
      c.forEach((x) => {
        const p = document.getElementById(x.id);
        p && p.classList.add("scroll-margin-nav");
      });
    })();
  }, [c]), /* @__PURE__ */ e.jsx(
    "div",
    {
      ref: s,
      className: u(
        "cfm:w-full cfm:z-40 cfm:bg-white cfm:transition-all cfm:duration-300",
        { "cfm:fixed cfm:left-0 cfm:shadow-md": a },
        t
      ),
      style: { top: a ? 0 : void 0 },
      children: /* @__PURE__ */ e.jsx("div", { className: "cfm:container cfm:mx-auto cfm:px-4", children: /* @__PURE__ */ e.jsx(
        "div",
        {
          className: "cfm:flex cfm:overflow-x-auto cfm:py-2 cfm:scrollbar-hide cfm:snap-x cfm:snap-mandatory",
          style: { scrollbarWidth: "none", msOverflowStyle: "none" },
          children: /* @__PURE__ */ e.jsx("div", { className: "cfm:flex cfm:space-x-6 cfm:md:space-x-8 cfm:px-2 cfm:md:px-0 cfm:min-w-max cfm:mx-auto", children: c.map((m) => /* @__PURE__ */ e.jsxs(
            "a",
            {
              href: `#${m.id}`,
              onClick: () => i(m.id),
              "data-id": m.id,
              className: u(
                "cfm:relative cfm:py-2 cfm:px-1 cfm:text-lg cfm:transition-colors cfm:whitespace-nowrap cfm:snap-start cfm:cursor-pointer",
                {
                  "cfm:text-typography-main cfm:font-bold": f === m.id,
                  "cfm:text-typography-light cfm:font-medium cfm:hover:text-typography-main": f !== m.id
                }
              ),
              children: [
                m.label,
                f === m.id && /* @__PURE__ */ e.jsx("span", { className: "cfm:absolute cfm:bottom-0 cfm:left-0 cfm:w-full cfm:h-1 cfm:bg-primary-main" })
              ]
            },
            m.id
          )) })
        }
      ) })
    }
  );
}, H4 = ({
  items: c,
  className: t,
  id: s
}) => /* @__PURE__ */ e.jsx("nav", { id: s, "aria-label": "Breadcrumb", className: u(t), children: /* @__PURE__ */ e.jsx(
  "ol",
  {
    itemScope: !0,
    itemType: "https://schema.org/BreadcrumbList",
    className: "cfm:flex cfm:flex-wrap cfm:items-center cfm:list-none cfm:p-0",
    children: c.map((a, n) => {
      const f = n === c.length - 1;
      return /* @__PURE__ */ e.jsxs(
        "li",
        {
          itemProp: "itemListElement",
          itemScope: !0,
          itemType: "https://schema.org/ListItem",
          className: u(
            "cfm:inline-flex cfm:items-center cfm:after:content-['/'] cfm:after:mx-2 cfm:after:text-secondary-900",
            "cfm:last:after:content-none"
          ),
          children: [
            f ? /* @__PURE__ */ e.jsx(
              "span",
              {
                itemProp: "name",
                "aria-current": "page",
                className: "cfm:typography-subtitle2 cfm:text-secondary-500",
                children: a.label
              }
            ) : /* @__PURE__ */ e.jsx(
              "a",
              {
                href: a.link,
                itemProp: "item",
                className: "cfm:focus-visible:underline",
                children: /* @__PURE__ */ e.jsx(
                  "span",
                  {
                    itemProp: "name",
                    className: "cfm:typography-subtitle2 cfm:text-secondary-900",
                    children: a.label
                  }
                )
              }
            ),
            /* @__PURE__ */ e.jsx("meta", { itemProp: "position", content: (n + 1).toString() })
          ]
        },
        a.id ?? a.label
      );
    })
  }
) });
function Z4(c) {
  return B({ attr: { viewBox: "0 0 640 512" }, child: [{ tag: "path", attr: { d: "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z" }, child: [] }] })(c);
}
function R4(c) {
  return B({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" }, child: [] }] })(c);
}
function z4(c) {
  return B({ attr: { viewBox: "0 0 496 512" }, child: [{ tag: "path", attr: { d: "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" }, child: [] }] })(c);
}
function O4(c) {
  return B({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" }, child: [] }] })(c);
}
function P4(c) {
  return B({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" }, child: [] }] })(c);
}
function I4(c) {
  return B({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z" }, child: [] }] })(c);
}
function F4(c) {
  return B({ attr: { viewBox: "0 0 496 512" }, child: [{ tag: "path", attr: { d: "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z" }, child: [] }] })(c);
}
function A4(c) {
  return B({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z" }, child: [] }] })(c);
}
function $4(c) {
  return B({ attr: { viewBox: "0 0 496 512" }, child: [{ tag: "path", attr: { d: "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z" }, child: [] }] })(c);
}
function D4(c) {
  return B({ attr: { viewBox: "0 0 496 512" }, child: [{ tag: "path", attr: { d: "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z" }, child: [] }] })(c);
}
function W4(c) {
  return B({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" }, child: [] }] })(c);
}
function q4(c) {
  return B({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z" }, child: [] }] })(c);
}
function Y4(c) {
  return B({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" }, child: [] }] })(c);
}
function G4(c) {
  return B({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" }, child: [] }] })(c);
}
function U4(c) {
  return B({ attr: { viewBox: "0 0 576 512" }, child: [{ tag: "path", attr: { d: "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" }, child: [] }] })(c);
}
const K4 = {
  facebook: R4,
  twitter: Y4,
  instagram: O4,
  linkedin: P4,
  youtube: U4,
  tiktok: W4,
  spotify: $4,
  whatsapp: G4,
  pinterest: F4,
  reddit: A4,
  twitch: q4,
  discord: Z4,
  github: z4,
  medium: I4,
  telegram: D4
}, H1 = ({
  label: c = "Síguenos",
  items: t,
  className: s,
  iconClassName: a,
  labelClassName: n
}) => /* @__PURE__ */ e.jsxs("div", { className: u("cfm:flex cfm:flex-col cfm:gap-6", s), children: [
  c && /* @__PURE__ */ e.jsx(T, { variant: "body1", className: u("cfm:text-secondary-900 cfm:font-bold", n), children: c }),
  /* @__PURE__ */ e.jsx("div", { className: "cfm:flex cfm:items-center cfm:gap-8", children: t.map((f) => {
    const l = K4[f.type];
    return /* @__PURE__ */ e.jsx(
      "a",
      {
        href: f.url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "cfm:text-secondary-900 cfm:transition-opacity cfm:hover:opacity-80",
        "aria-label": `Visitar ${f.type}`,
        children: /* @__PURE__ */ e.jsx(
          l,
          {
            className: u(
              "cfm:text-[2rem]",
              a
            )
          }
        )
      },
      f.url
    );
  }) })
] });
function J4(c) {
  return B({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m12 19-7-7 7-7" }, child: [] }, { tag: "path", attr: { d: "M19 12H5" }, child: [] }] })(c);
}
function X4(c) {
  return B({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M5 12h14" }, child: [] }, { tag: "path", attr: { d: "m12 5 7 7-7 7" }, child: [] }] })(c);
}
function Q4(c) {
  return B({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M20 6 9 17l-5-5" }, child: [] }] })(c);
}
function e1(c) {
  return B({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m15 18-6-6 6-6" }, child: [] }] })(c);
}
function c1(c) {
  return B({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m9 18 6-6-6-6" }, child: [] }] })(c);
}
const l0 = (c) => {
  switch (c) {
    case "completed":
      return {
        bg: "cfm:bg-primary-300",
        text: "cfm:text-white",
        border: "cfm:border-primary-300",
        line: "cfm:bg-primary-300"
      };
    case "active":
      return {
        bg: "cfm:bg-primary",
        text: "cfm:text-white",
        border: "cfm:border-primary",
        line: "cfm:bg-primary"
      };
    case "error":
      return {
        bg: "cfm:bg-red-500",
        text: "cfm:text-white",
        border: "cfm:border-red-500",
        line: "cfm:bg-gray-300"
      };
    default:
      return {
        bg: "cfm:bg-gray-300",
        text: "cfm:text-gray-600",
        border: "cfm:border-gray-300",
        line: "cfm:bg-gray-300"
      };
  }
}, t1 = (c) => {
  switch (c) {
    case "completed":
      return "Completed";
    case "active":
      return "In Progress";
    case "error":
      return "Error";
    default:
      return "Pending";
  }
}, r1 = (c) => {
  switch (c) {
    case "completed":
      return "cfm:bg-emerald-100 cfm:text-emerald-700";
    case "active":
      return "cfm:bg-blue-100 cfm:text-blue-700";
    case "error":
      return "cfm:bg-red-100 cfm:text-red-700";
    default:
      return "cfm:bg-gray-100 cfm:text-gray-600";
  }
};
function V2({
  label: c,
  description: t,
  status: s,
  variant: a
}) {
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `${a === "alternative" ? "cfm:text-center" : "cfm:text-left"}`,
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "cfm:font-medium cfm:text-gray-900", children: c }),
        t && /* @__PURE__ */ e.jsx("div", { className: "cfm:text-sm cfm:text-gray-500 cfm:mt-1", children: t }),
        a === "default" && /* @__PURE__ */ e.jsx(
          "div",
          {
            className: `cfm:inline-block cfm:px-2 cfm:py-1 cfm:rounded-full cfm:text-xs cfm:font-medium cfm:mt-2 ${r1(
              s
            )}`,
            children: t1(s)
          }
        )
      ]
    }
  );
}
function s1({ step: c, index: t, isLast: s, orientation: a, variant: n }) {
  const f = l0(c.status), l = () => c.status === "completed" ? /* @__PURE__ */ e.jsx(Q4, { className: "cfm:w-4 cfm:h-4" }) : c.icon ? c.icon : /* @__PURE__ */ e.jsx("span", { className: "cfm:text-sm cfm:font-medium", children: t + 1 }), i = () => {
    if (s) return null;
    const o = c.status === "completed" ? "completed" : "pending", m = l0(o);
    return a === "horizontal" ? /* @__PURE__ */ e.jsx("div", { className: `cfm:flex-1 cfm:h-0.5 cfm:mx-4 ${m.line}` }) : /* @__PURE__ */ e.jsx("div", { className: `cfm:w-0.5 cfm:h-12 cfm:my-4 ${m.line}` });
  };
  return a === "horizontal" ? /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:items-center cfm:flex-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:flex-col cfm:items-center", children: [
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: `cfm:w-8 cfm:h-8 cfm:rounded-full cfm:border-2 ${f.border} ${f.bg} ${f.text} cfm:flex cfm:items-center cfm:justify-center`,
          children: l()
        }
      ),
      n === "alternative" && /* @__PURE__ */ e.jsx("div", { className: "cfm:mt-2", children: /* @__PURE__ */ e.jsx(
        V2,
        {
          label: c.label,
          description: c.description,
          status: c.status,
          variant: n
        }
      ) })
    ] }),
    n !== "alternative" && /* @__PURE__ */ e.jsx("div", { className: "cfm:ml-4", children: /* @__PURE__ */ e.jsx(
      V2,
      {
        label: c.label,
        description: c.description,
        status: c.status,
        variant: n
      }
    ) }),
    i()
  ] }) : /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:flex-col cfm:items-center", children: [
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: `cfm:w-8 cfm:h-8 cfm:rounded-full cfm:border-2 ${f.border} ${f.bg} ${f.text} cfm:flex cfm:items-center cfm:justify-center`,
          children: l()
        }
      ),
      i()
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "cfm:ml-4 cfm:pb-8", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "cfm:text-xs cfm:text-gray-500 cfm:uppercase cfm:tracking-wide", children: [
        "STEP ",
        t + 1
      ] }),
      /* @__PURE__ */ e.jsx(
        V2,
        {
          label: c.label,
          description: c.description,
          status: c.status,
          variant: n
        }
      )
    ] })
  ] });
}
function Z1({
  steps: c,
  orientation: t = "horizontal",
  variant: s = "default",
  className: a = ""
}) {
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `${t === "horizontal" ? "cfm:flex cfm:items-center" : "cfm:flex cfm:flex-col"} ${a}`,
      children: c.map((n, f) => /* @__PURE__ */ e.jsx(
        s1,
        {
          step: n,
          index: f,
          isLast: f === c.length - 1,
          orientation: t,
          variant: s
        },
        n.id
      ))
    }
  );
}
const i2 = ({
  children: c,
  bgColor: t,
  className: s,
  ...a
}) => {
  const n = u(
    !t && "cfm:section-contained",
    t,
    s
  );
  return /* @__PURE__ */ e.jsx("section", { ...a, className: n, children: t ? /* @__PURE__ */ e.jsx("div", { className: "cfm:section-contained", children: c }) : c });
}, a1 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='154'%20height='35.894'%20viewBox='0%200%20154%2035.894'%20%3e%3cdefs%3e%3cclipPath%20id='clip-path'%3e%3cpath%20id='Trazado_3461'%20data-name='Trazado%203461'%20d='M66.675,19.71,62.97,22.543v6.591H73.495c7.6,0,7.43-9.424,7.43-9.424H66.682Z'%20transform='translate(-62.97%20-19.71)'%20fill='none'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip-path-2'%3e%3cpath%20id='Trazado_3463'%20data-name='Trazado%203463'%20d='M66.086,1.057,59.132,8.011c-6.611,6.6,1.732,14.639,1.732,14.639l15.6-15.6L70.435,1.024A3.074,3.074,0,0,0,68.287-.01a3.165,3.165,0,0,0-2.195,1.061'%20transform='translate(-56.584%200.01)'%20fill='none'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip-path-3'%3e%3cpath%20id='Trazado_3465'%20data-name='Trazado%203465'%20d='M66.49,35.312l6.028,6.028a2.786,2.786,0,0,0,4.349-.027l6.954-6.954c6.611-6.6-1.732-14.639-1.732-14.639l-15.6,15.6Z'%20transform='translate(-66.49%20-19.72)'%20fill='none'%20/%3e%3c/clipPath%3e%3c/defs%3e%3cg%20id='Grupo_42105'%20data-name='Grupo%2042105'%20transform='translate(291.557%20-760)'%3e%3cg%20id='Grupo_87'%20data-name='Grupo%2087'%20transform='translate(-260.412%20763.219)'%3e%3cpath%20id='Trazado_3452'%20data-name='Trazado%203452'%20d='M3.75,71.9H0L10.469,47.76h3.066L23.9,71.9H20.076l-2.454-5.93H6.172ZM7.363,63H16.4L11.9,51.687,7.371,63Z'%20transform='translate(0%20-47.76)'%20fill='%23888888'%20/%3e%3cpath%20id='Trazado_3453'%20data-name='Trazado%203453'%20d='M40.761,61.652A4.235,4.235,0,0,0,39.225,60.2,4.383,4.383,0,0,0,37,59.641a5.122,5.122,0,0,0-1.094.121,3.149,3.149,0,0,0-.974.378,2.185,2.185,0,0,0-.684.644,1.772,1.772,0,0,0-.257.974,1.6,1.6,0,0,0,.917,1.513,11.348,11.348,0,0,0,2.76.9,17.84,17.84,0,0,1,2.148.644,6.646,6.646,0,0,1,1.722.941A4.047,4.047,0,0,1,42.685,67.1a3.915,3.915,0,0,1,.41,1.843,4.967,4.967,0,0,1-.547,2.422A4.673,4.673,0,0,1,41.1,72.982a5.885,5.885,0,0,1-2.06.9,10.22,10.22,0,0,1-2.39.274,9.5,9.5,0,0,1-3.6-.716A7.01,7.01,0,0,1,30.14,71.26l2.285-1.939a5.277,5.277,0,0,0,1.794,1.6,4.956,4.956,0,0,0,2.5.644,5.538,5.538,0,0,0,1.175-.121,3.256,3.256,0,0,0,1.022-.394,2.151,2.151,0,0,0,.732-.716,2.087,2.087,0,0,0,.274-1.127,1.775,1.775,0,0,0-1.078-1.674,14.173,14.173,0,0,0-3.154-1.022c-.547-.137-1.094-.306-1.65-.5a5.507,5.507,0,0,1-1.521-.8,4.071,4.071,0,0,1-1.11-1.279,3.887,3.887,0,0,1-.426-1.891,4.488,4.488,0,0,1,.531-2.237A4.625,4.625,0,0,1,32.9,58.265a6.151,6.151,0,0,1,1.947-.885,8.692,8.692,0,0,1,2.253-.29,8.485,8.485,0,0,1,3.355.684,5.478,5.478,0,0,1,2.5,1.979l-2.213,1.875Z'%20transform='translate(-5.888%20-49.583)'%20fill='%23888888'%20/%3e%3cpath%20id='Trazado_3454'%20data-name='Trazado%203454'%20d='M64.869,65.611a8.62,8.62,0,0,1-.668,3.444,8.144,8.144,0,0,1-1.843,2.712,8.236,8.236,0,0,1-2.776,1.77,9.762,9.762,0,0,1-6.888,0,8.131,8.131,0,0,1-2.76-1.77,8.348,8.348,0,0,1-1.827-2.712,8.761,8.761,0,0,1-.668-3.444,8.653,8.653,0,0,1,.668-3.428,8.09,8.09,0,0,1,4.587-4.426,9.763,9.763,0,0,1,6.888,0,8.369,8.369,0,0,1,2.776,1.754A8.1,8.1,0,0,1,64.2,62.183a8.653,8.653,0,0,1,.668,3.428m-3.339.016a6.787,6.787,0,0,0-.362-2.213,5.582,5.582,0,0,0-1.046-1.851,5.034,5.034,0,0,0-1.69-1.271,5.854,5.854,0,0,0-4.619,0,4.879,4.879,0,0,0-1.69,1.271,5.428,5.428,0,0,0-1.038,1.851,6.942,6.942,0,0,0,0,4.426,5.873,5.873,0,0,0,1.038,1.867,4.994,4.994,0,0,0,1.69,1.3,5.854,5.854,0,0,0,4.619,0,4.749,4.749,0,0,0,1.69-1.3,5.825,5.825,0,0,0,1.046-1.867,6.752,6.752,0,0,0,.362-2.213'%20transform='translate(-9.267%20-49.59)'%20fill='%23888888'%20/%3e%3cpath%20id='Trazado_3455'%20data-name='Trazado%203455'%20d='M83.126,61.66a3.908,3.908,0,0,0-1.537-1.312,4.669,4.669,0,0,0-2.181-.531,5.079,5.079,0,0,0-2.237.475,5.174,5.174,0,0,0-1.65,1.279,5.524,5.524,0,0,0-1.038,1.859,6.781,6.781,0,0,0-.354,2.213,6.966,6.966,0,0,0,.354,2.213,5.749,5.749,0,0,0,1.038,1.859A5.183,5.183,0,0,0,77.2,70.994a5.526,5.526,0,0,0,4.482,0,4.554,4.554,0,0,0,1.65-1.3l2.148,1.947A6.963,6.963,0,0,1,82.916,73.5a8.668,8.668,0,0,1-3.476.668,9.3,9.3,0,0,1-3.46-.612,8.23,8.23,0,0,1-2.744-1.722,7.962,7.962,0,0,1-1.827-2.68,8.91,8.91,0,0,1-.66-3.508,9.039,9.039,0,0,1,.644-3.476,7.953,7.953,0,0,1,1.81-2.7,8.142,8.142,0,0,1,2.744-1.738,9.366,9.366,0,0,1,3.428-.612,8.945,8.945,0,0,1,3.4.684,6.137,6.137,0,0,1,2.679,1.979l-2.317,1.875Z'%20transform='translate(-13.821%20-49.59)'%20fill='%23888888'%20/%3e%3cpath%20id='Trazado_3456'%20data-name='Trazado%203456'%20d='M101.069,63.261a3.206,3.206,0,0,0-1.094-2.679,4.5,4.5,0,0,0-2.9-.869,6.331,6.331,0,0,0-2.575.531,6.7,6.7,0,0,0-2.028,1.344l-1.706-2.044a8.6,8.6,0,0,1,2.913-1.77,10.376,10.376,0,0,1,3.7-.644,8.531,8.531,0,0,1,3.017.491,5.69,5.69,0,0,1,2.1,1.344,5.524,5.524,0,0,1,1.223,2.012,7.394,7.394,0,0,1,.41,2.486v7.057c0,.547.016,1.118.056,1.722a8.876,8.876,0,0,0,.185,1.481h-2.9a9.909,9.909,0,0,1-.274-2.317h-.1a6.271,6.271,0,0,1-2.229,2.012,6.746,6.746,0,0,1-3.186.716,8.438,8.438,0,0,1-2-.257,5.73,5.73,0,0,1-1.891-.837A4.737,4.737,0,0,1,90.383,71.5a4.6,4.6,0,0,1-.563-2.35,4.123,4.123,0,0,1,.99-2.913A6.2,6.2,0,0,1,93.4,64.605a14.43,14.43,0,0,1,3.613-.732q2.016-.169,4.055-.169v-.443Zm-.781,2.76c-.8,0-1.617.032-2.47.1a10.829,10.829,0,0,0-2.317.41,4.463,4.463,0,0,0-1.722.917,2.074,2.074,0,0,0-.684,1.633,2.251,2.251,0,0,0,.29,1.191,2.363,2.363,0,0,0,.764.781,3.194,3.194,0,0,0,1.054.426,5.8,5.8,0,0,0,1.191.121,4.427,4.427,0,0,0,3.46-1.344,4.893,4.893,0,0,0,1.207-3.388v-.853h-.781Z'%20transform='translate(-17.546%20-49.59)'%20fill='%23888888'%20/%3e%3cpath%20id='Trazado_3457'%20data-name='Trazado%203457'%20d='M106.468,73.615a5.408,5.408,0,0,0,1.3.169,2.168,2.168,0,0,0,1.159-.274,1.869,1.869,0,0,0,.684-.732,3.242,3.242,0,0,0,.322-1.094,10.093,10.093,0,0,0,.089-1.344V55.752h3.2V70.445a11.211,11.211,0,0,1-.225,2.317,5.2,5.2,0,0,1-.8,1.939,3.992,3.992,0,0,1-1.6,1.344,6.057,6.057,0,0,1-2.623.491,8.314,8.314,0,0,1-.958-.064c-.338-.048-.636-.089-.885-.137l.338-2.728Zm7.3-23.689a1.879,1.879,0,0,1-.636,1.464,2.262,2.262,0,0,1-3.042-.016,1.913,1.913,0,0,1-.628-1.448,1.982,1.982,0,0,1,.628-1.481,2.24,2.24,0,0,1,3.042,0,1.965,1.965,0,0,1,.636,1.481'%20transform='translate(-20.732%20-47.778)'%20fill='%23888888'%20/%3e%3cpath%20id='Trazado_3458'%20data-name='Trazado%203458'%20d='M128.267,63.261a3.206,3.206,0,0,0-1.094-2.679,4.518,4.518,0,0,0-2.9-.869,6.331,6.331,0,0,0-2.575.531,6.7,6.7,0,0,0-2.028,1.344l-1.706-2.044a8.6,8.6,0,0,1,2.913-1.77,10.377,10.377,0,0,1,3.7-.644,8.531,8.531,0,0,1,3.017.491,5.689,5.689,0,0,1,2.1,1.344,5.543,5.543,0,0,1,1.231,2.012,7.394,7.394,0,0,1,.41,2.486v7.057c0,.547.016,1.118.048,1.722a8.876,8.876,0,0,0,.185,1.481h-2.9A9.909,9.909,0,0,1,128.4,71.4h-.1a6.228,6.228,0,0,1-2.237,2.012,6.746,6.746,0,0,1-3.186.716,8.438,8.438,0,0,1-2-.257,5.73,5.73,0,0,1-1.891-.837,4.738,4.738,0,0,1-1.416-1.537,4.6,4.6,0,0,1-.563-2.35,4.123,4.123,0,0,1,.99-2.913,6.2,6.2,0,0,1,2.591-1.633,14.43,14.43,0,0,1,3.613-.732q2.016-.169,4.055-.169v-.443Zm-.781,2.76c-.8,0-1.617.032-2.47.1a10.829,10.829,0,0,0-2.317.41,4.463,4.463,0,0,0-1.722.917,2.074,2.074,0,0,0-.684,1.633,2.251,2.251,0,0,0,.29,1.191,2.441,2.441,0,0,0,.764.781,3.193,3.193,0,0,0,1.054.426,5.862,5.862,0,0,0,1.191.121,4.427,4.427,0,0,0,3.46-1.344,4.893,4.893,0,0,0,1.207-3.388v-.853h-.781Z'%20transform='translate(-22.858%20-49.59)'%20fill='%23888888'%20/%3e%3cpath%20id='Trazado_3459'%20data-name='Trazado%203459'%20d='M147.193,61.652a4.235,4.235,0,0,0-1.537-1.448,4.374,4.374,0,0,0-2.213-.563,5.122,5.122,0,0,0-1.094.121,3.149,3.149,0,0,0-.974.378,2.1,2.1,0,0,0-.684.644,1.772,1.772,0,0,0-.258.974,1.6,1.6,0,0,0,.917,1.513,11.348,11.348,0,0,0,2.76.9,17.84,17.84,0,0,1,2.148.644,6.646,6.646,0,0,1,1.722.941,4.047,4.047,0,0,1,1.143,1.344,3.915,3.915,0,0,1,.41,1.843,4.967,4.967,0,0,1-.547,2.422,4.674,4.674,0,0,1-1.448,1.617,5.886,5.886,0,0,1-2.06.9,10.22,10.22,0,0,1-2.39.274,9.526,9.526,0,0,1-3.6-.716,7.01,7.01,0,0,1-2.913-2.181l2.285-1.939a5.278,5.278,0,0,0,1.794,1.6,4.956,4.956,0,0,0,2.5.644,5.538,5.538,0,0,0,1.175-.121,3.256,3.256,0,0,0,1.022-.394,2.151,2.151,0,0,0,.732-.716,2.087,2.087,0,0,0,.274-1.127,1.78,1.78,0,0,0-1.07-1.674,14.319,14.319,0,0,0-3.154-1.022c-.547-.137-1.094-.306-1.65-.5a5.507,5.507,0,0,1-1.521-.8,3.972,3.972,0,0,1-1.11-1.279,3.887,3.887,0,0,1-.426-1.891,4.488,4.488,0,0,1,.531-2.237,4.625,4.625,0,0,1,1.384-1.537,6.151,6.151,0,0,1,1.947-.885,8.737,8.737,0,0,1,2.253-.29,8.484,8.484,0,0,1,3.355.684,5.478,5.478,0,0,1,2.5,1.979l-2.213,1.875Z'%20transform='translate(-26.681%20-49.583)'%20fill='%23888888'%20/%3e%3c/g%3e%3cg%20id='Grupo_88'%20data-name='Grupo%2088'%20transform='translate(-291.557%20760)'%3e%3cg%20id='Grupo_82'%20data-name='Grupo%2082'%20transform='translate(4.287%2013.236)'%20clip-path='url(%23clip-path)'%20%3e%3cpath%20id='Trazado_3460'%20data-name='Trazado%203460'%20d='M57.85,18.326l12.5,17.163,12.5-17.163L70.348,1.17Z'%20transform='translate(-61.287%20-13.614)'%20fill='%23888888'%20/%3e%3c/g%3e%3cg%20id='Grupo_83'%20data-name='Grupo%2083'%20transform='translate(0%200)'%20clip-path='url(%23clip-path-2)'%20%3e%3cpath%20id='Trazado_3462'%20data-name='Trazado%203462'%20d='M72.388-2.173,44.19-6.61l4.262,27.1,28.2,4.43Z'%20transform='translate(-52.509%202.18)'%20fill='%23888888'%20/%3e%3c/g%3e%3cg%20id='Grupo_84'%20data-name='Grupo%2084'%20transform='translate(6.649%2013.243)'%20clip-path='url(%23clip-path-3)'%20%3e%3cpath%20id='Trazado_3464'%20data-name='Trazado%203464'%20d='M64.376,40.543l28.251,4.443L88.311,17.533,60.06,13.09Z'%20transform='translate(-64.376%20-17.54)'%20fill='%23888888'%20/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", n1 = "data:image/svg+xml,%3csvg%20width='154'%20height='auto'%20viewBox='0%200%20450%20157'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3cpath%20d='M187.155%2066.2505H193.151V54.42H200.444C207.737%2054.42%20210.978%2049.396%20210.978%2044.5341C210.978%2038.0516%20206.278%2034.4863%20200.12%2034.4863H187.155V66.2505ZM193.151%2039.5102H199.309C202.551%2039.5102%20205.144%2040.6446%20205.144%2044.5341C205.144%2047.7754%20202.875%2049.5581%20199.471%2049.5581H193.151V39.5102Z'%20fill='%23888888'%20/%3e%3cpath%20d='M228.156%2064.3057C228.156%2064.6299%20228.319%2066.0884%20228.319%2066.4126H233.667C233.343%2065.9264%20233.343%2062.5231%20233.343%2061.5507V50.3684C233.343%2044.8582%20228.643%2043.0756%20223.619%2043.0756C219.405%2043.0756%20214.543%2044.6962%20214.543%2049.7201V50.3684H219.405V49.5581C219.405%2048.0995%20221.188%2047.2892%20223.457%2047.2892C226.212%2047.2892%20227.832%2048.2616%20227.832%2050.6925V52.7993H221.836C217.46%2052.7993%20213.409%2055.3923%20213.409%2059.768C213.409%2064.1437%20216.65%2066.7367%20221.35%2066.7367C224.429%2066.7367%20226.212%2066.2505%20228.156%2064.3057ZM227.994%2057.8232C227.994%2060.2542%20227.346%2062.361%20222.97%2062.361C220.377%2062.361%20218.919%2061.3886%20218.919%2059.4439C218.919%2057.4991%20220.378%2056.6888%20222.808%2056.6888H228.156V57.8232H227.994Z'%20fill='%23888888'%20/%3e%3cpath%20d='M258.462%2052.4752V51.989C258.462%2045.9927%20253.438%2043.0756%20248.414%2043.0756C242.742%2043.0756%20237.88%2046.6409%20237.88%2053.1234V57.6612C237.88%2063.6575%20242.904%2067.0608%20248.576%2067.0608C253.6%2067.0608%20258.462%2064.1437%20258.462%2058.1474V57.9853H253.114V58.1474C253.114%2061.2265%20250.845%2062.5231%20248.576%2062.5231C245.659%2062.5231%20243.552%2060.9024%20243.552%2057.9853V52.6372C243.552%2049.2339%20245.983%2047.9374%20248.414%2047.9374C250.683%2047.9374%20253.114%2049.2339%20253.114%2052.3131V52.7993H258.462V52.4752Z'%20fill='%23888888'%20/%3e%3cpath%20d='M269.645%2066.7366C270.455%2066.7366%20272.4%2066.5746%20273.696%2066.2504V61.5506C272.562%2061.7127%20272.075%2061.7127%20270.941%2061.7127C269.645%2061.7127%20268.834%2061.2265%20268.834%2059.6059V47.7753H273.858V43.3996H268.834V36.4309H263.324V43.3996H260.245V47.7753H263.324V60.9024C263.324%2064.954%20266.241%2066.7366%20269.645%2066.7366Z'%20fill='%23888888'%20/%3e%3cpath%20d='M297.033%2057.337V52.6372C297.033%2046.803%20292.009%2043.0756%20286.499%2043.0756C281.475%2043.0756%20276.127%2046.4789%20276.127%2052.6372V57.8232C276.127%2063.6575%20281.151%2066.7367%20286.661%2066.7367C291.847%2066.8987%20297.033%2063.4954%20297.033%2057.337ZM291.523%2057.8232C291.523%2061.0645%20289.092%2062.361%20286.823%2062.361C284.068%2062.361%20281.799%2060.7404%20281.799%2057.9853V52.3131C281.799%2049.0719%20284.23%2047.7754%20286.499%2047.7754C289.254%2047.7754%20291.523%2049.396%20291.523%2052.151V57.8232Z'%20fill='%23888888'%20/%3e%3cpath%20d='M337.387%2056.3646V49.7201H323.611V55.0681H331.877V55.8784C331.877%2060.0921%20328.959%2061.5506%20325.556%2061.5506C321.829%2061.5506%20318.587%2059.4438%20318.587%2055.5543V45.3444C318.587%2040.8066%20322.315%2039.186%20325.394%2039.186C328.311%2039.186%20331.877%2040.3204%20331.877%2044.5341V45.0203H337.549V44.0479C337.549%2036.9171%20331.552%2034%20325.394%2034C318.425%2034%20312.753%2038.2136%20312.753%2045.6685V55.8784C312.753%2063.0092%20318.749%2066.8987%20325.718%2066.8987C331.552%2066.8987%20337.387%2063.4954%20337.387%2056.3646Z'%20fill='%23888888'%20/%3e%3cpath%20d='M352.621%2061.8748C351.648%2062.0369%20351.162%2062.0369%20350.19%2062.0369C348.731%2062.0369%20348.245%2061.2266%20348.245%2060.0921V34.4863H342.735V60.0921C342.735%2062.199%20342.897%2066.5746%20348.245%2066.5746C349.703%2066.5746%20351.486%2066.2505%20352.621%2065.9264V61.8748Z'%20fill='%23888888'%20/%3e%3cpath%20d='M365.91%2066.8987C370.934%2066.8987%20376.282%2063.4954%20376.282%2057.337V52.6372C376.282%2046.803%20371.258%2043.0756%20365.748%2043.0756C360.724%2043.0756%20355.376%2046.4789%20355.376%2052.6372V57.8232C355.376%2063.6575%20360.399%2066.8987%20365.91%2066.8987ZM360.886%2052.151C360.886%2048.9098%20363.317%2047.6133%20365.585%2047.6133C368.341%2047.6133%20370.609%2049.2339%20370.609%2051.989V57.6612C370.609%2060.9024%20368.178%2062.1989%20365.91%2062.1989C363.155%2062.1989%20360.886%2060.5783%20360.886%2057.8232V52.151Z'%20fill='%23888888'%20/%3e%3cpath%20d='M401.725%2057.6612V52.1511C401.725%2046.3168%20397.674%2043.0756%20392.65%2043.0756C390.543%2043.0756%20388.112%2043.8859%20386.33%2046.1548V34.4863H380.819V66.2505H386.005V63.9816H386.167C387.302%2065.4402%20389.409%2066.7367%20392.002%2066.7367C397.188%2066.8988%20401.725%2063.8196%20401.725%2057.6612ZM386.492%2057.8233V52.6373C386.492%2049.396%20389.085%2047.7754%20391.353%2047.7754C394.109%2047.7754%20396.377%2049.396%20396.377%2052.1511V57.8233C396.377%2061.0645%20393.946%2062.361%20391.678%2062.361C388.598%2062.199%20386.492%2060.5783%20386.492%2057.8233Z'%20fill='%23888888'%20/%3e%3cpath%20d='M425.062%2061.3886V50.2063C425.062%2044.6961%20420.363%2042.9135%20415.339%2042.9135C411.125%2042.9135%20406.263%2044.5341%20406.263%2049.558V50.2063H411.125V49.396C411.125%2047.9374%20412.908%2047.1271%20415.177%2047.1271C417.932%2047.1271%20419.552%2048.0994%20419.552%2050.5304V52.6372H413.556C409.18%2052.6372%20405.129%2055.2302%20405.129%2059.6059C405.129%2063.9816%20408.37%2066.5746%20413.07%2066.5746C415.987%2066.5746%20417.77%2066.0884%20419.714%2063.9816H419.876C419.876%2064.3057%20420.039%2065.7643%20420.039%2066.0884H425.387C425.225%2065.7643%20425.062%2062.523%20425.062%2061.3886ZM419.552%2057.8232C419.552%2060.2541%20418.904%2062.361%20414.528%2062.361C411.935%2062.361%20410.477%2061.3886%20410.477%2059.4438C410.477%2057.4991%20411.935%2056.6888%20414.366%2056.6888H419.714V57.8232H419.552Z'%20fill='%23888888'%20/%3e%3cpath%20d='M430.735%2034.4862V60.0921C430.735%2062.1989%20430.897%2066.5746%20436.245%2066.5746C437.703%2066.5746%20439.486%2066.2505%20440.62%2065.9263V61.7127C439.648%2061.8748%20439.162%2061.8748%20438.189%2061.8748C436.731%2061.8748%20436.245%2061.0645%20436.245%2059.93V34.3242H430.735V34.4862Z'%20fill='%23888888'%20/%3e%3cpath%20d='M288.93%2097.5285V95.5838C288.93%2089.5875%20283.744%2085.3738%20276.613%2085.3738C268.996%2085.3738%20263.486%2090.3978%20263.486%2097.6906V110.331C263.486%20117.948%20269.32%20122%20276.775%20122C283.906%20122%20288.93%20118.11%20288.93%20111.79V110.331H286.013V111.142C286.013%20116.004%20282.61%20119.083%20276.775%20119.083C270.779%20119.083%20266.565%20115.355%20266.565%20109.683V97.6906C266.565%2091.8564%20270.779%2088.1289%20276.451%2088.1289C282.285%2088.1289%20285.851%2091.2081%20285.851%2096.07V97.5285H288.93Z'%20fill='%23888888'%20/%3e%3cpath%20d='M303.353%20121.838C309.026%20121.838%20313.239%20118.435%20313.239%20112.114V105.794C313.239%2099.6354%20309.35%2096.07%20303.191%2096.07C297.519%2096.07%20293.144%2099.3113%20293.144%20105.794V112.438C293.144%20118.597%20297.195%20121.838%20303.353%20121.838ZM296.061%20105.632C296.061%20101.256%20298.492%2098.501%20303.191%2098.501C308.053%2098.501%20310.322%20101.418%20310.322%20105.47V112.114C310.322%20116.814%20308.053%20119.407%20303.353%20119.407C298.492%20119.407%20296.223%20116.49%20296.223%20112.276V105.632H296.061Z'%20fill='%23888888'%20/%3e%3cpath%20d='M318.587%2085.86V115.355C318.587%20118.435%20319.884%20121.514%20324.098%20121.514C325.232%20121.514%20326.528%20121.352%20327.825%20121.028V118.759C327.015%20118.921%20326.042%20119.083%20325.07%20119.083C322.639%20119.083%20321.505%20117.624%20321.505%20115.68V86.0221H318.587V85.86Z'%20fill='%23888888'%20/%3e%3cpath%20d='M340.79%20121.838C346.462%20121.838%20350.676%20118.435%20350.676%20112.114V105.794C350.676%2099.6354%20346.786%2096.07%20340.628%2096.07C334.956%2096.07%20330.58%2099.3113%20330.58%20105.794V112.438C330.58%20118.597%20334.632%20121.838%20340.79%20121.838ZM333.497%20105.632C333.497%20101.256%20335.928%2098.501%20340.628%2098.501C345.49%2098.501%20347.759%20101.418%20347.759%20105.47V112.114C347.759%20116.814%20345.49%20119.407%20340.79%20119.407C335.928%20119.407%20333.659%20116.49%20333.659%20112.276V105.632H333.497Z'%20fill='%23888888'%20/%3e%3cpath%20d='M390.705%20121.19V103.525C390.705%2099.1492%20387.788%2096.07%20383.088%2096.07C379.361%2096.07%20376.12%2098.0148%20374.337%20101.418C373.689%2098.501%20371.42%2096.07%20367.368%2096.07C363.803%2096.07%20360.562%2097.8527%20358.779%20101.418H358.617V96.7183H355.862V121.352H358.779V106.442C358.779%20101.58%20362.83%2098.8251%20366.234%2098.8251C369.799%2098.8251%20371.744%20100.932%20371.906%20105.146V121.352H374.823V106.118C374.985%20101.742%20378.388%2098.663%20382.278%2098.663C385.843%2098.663%20387.95%20100.77%20387.95%20105.146V121.19H390.705Z'%20fill='%23888888'%20/%3e%3cpath%20d='M399.781%20116.814C400.915%20120.055%20404.318%20121.838%20407.398%20121.838C412.097%20121.838%20416.635%20119.083%20416.635%20112.438V104.497C416.635%2099.3113%20413.07%2096.07%20407.884%2096.07C405.129%2096.07%20401.563%2097.5286%20399.943%20101.094H399.781V86.0222H396.864V121.352H399.619V116.814H399.781ZM399.943%20106.766C399.943%20101.742%20403.67%2098.501%20407.074%2098.501C411.287%2098.501%20413.718%20101.094%20413.718%20104.497V112.925C413.718%20117.3%20410.315%20119.407%20407.074%20119.407C403.184%20119.407%20399.781%20116.328%20399.781%20111.628V106.766H399.943Z'%20fill='%23888888'%20/%3e%3cpath%20d='M424.9%2086.0222H421.983V91.0461H424.9V86.0222Z'%20fill='%23888888'%20/%3e%3cpath%20d='M424.9%2096.5562H421.983V121.19H424.9V96.5562Z'%20fill='%23888888'%20/%3e%3cpath%20d='M440.134%2096.07C435.597%2096.07%20431.059%2097.8527%20431.059%20102.715V103.525H433.652V102.715C433.652%2099.4733%20436.893%2098.3389%20439.972%2098.3389C443.7%2098.3389%20446.293%2099.6354%20446.293%20103.525V107.252H439C434.948%20107.252%20429.924%20109.035%20429.924%20114.545C429.924%20119.083%20433.652%20121.514%20438.027%20121.514C441.107%20121.514%20444.348%20120.866%20446.455%20117.138H446.617C446.617%20117.948%20446.779%20120.217%20446.779%20121.028H449.696C449.534%20119.893%20449.372%20116.328%20449.372%20114.869V102.877C449.21%2097.6907%20444.996%2096.07%20440.134%2096.07ZM446.293%20112.276C446.293%20116.49%20443.7%20119.407%20438.838%20119.407C435.759%20119.407%20432.841%20117.786%20432.841%20114.545C432.841%20110.332%20436.245%20109.521%20439.648%20109.521H446.293V112.276Z'%20fill='%23888888'%20/%3e%3cpath%20d='M175%20121.19H178.079V106.604H185.858L196.392%20121.19H199.958L189.262%20106.442C195.42%20105.632%20198.337%20101.256%20198.337%2096.232C198.337%2089.7495%20193.799%2085.86%20186.993%2085.86H175V121.19ZM178.241%2088.6151H186.182C191.855%2088.6151%20195.42%2091.2081%20195.42%2096.232C195.42%20101.58%20192.179%20104.173%20186.182%20104.173H178.241V88.6151Z'%20fill='%23888888'%20/%3e%3cpath%20d='M222.808%20109.359V105.794C222.808%2099.4734%20218.757%2096.07%20213.247%2096.07C207.413%2096.07%20203.037%2099.7975%20203.037%20106.604V111.952C203.037%20118.759%20207.413%20121.838%20213.409%20121.838C216.65%20121.838%20220.053%20120.866%20222.322%20117.624L220.215%20116.166C218.919%20117.786%20216.812%20119.407%20213.571%20119.407C208.871%20119.407%20206.116%20116.652%20206.116%20112.276V109.359H222.808ZM206.116%20105.956C206.116%20102.066%20208.709%2098.501%20213.085%2098.501C217.785%2098.501%20219.891%20101.742%20219.891%20105.632V107.252H205.954V105.956H206.116Z'%20fill='%23888888'%20/%3e%3cpath%20d='M246.47%20121.19V86.0222H243.552V101.094H243.39C242.418%2097.8527%20239.015%2096.07%20235.936%2096.07C231.236%2096.07%20226.86%2098.8251%20226.86%20105.47V113.573C226.86%20118.759%20230.263%20122%20235.611%20122C238.366%20122%20241.77%20120.541%20243.552%20116.49H243.715V121.352H246.47V121.19ZM243.552%20111.142C243.552%20116.328%20239.825%20119.407%20236.26%20119.407C232.046%20119.407%20229.615%20116.814%20229.615%20113.249V104.983C229.615%20100.608%20233.018%2098.501%20236.26%2098.501C240.149%2098.501%20243.552%20101.58%20243.552%20106.28V111.142Z'%20fill='%23888888'%20/%3e%3cpath%20d='M54.4%206.54446C54.1%205.74446%2053.5%205.14446%2052.7%204.84446C51.8%204.54446%2050.9%204.54446%2049.5%205.14446L43.6%207.64446L43.8%208.14446H45.6L49.8%2017.9445L48.5%2019.1445L48.7%2019.6445L53.8%2017.4445C55.5%2016.7445%2056.3%2016.2445%2056.9%2015.3445C57.5%2014.5445%2057.6%2013.3445%2057.2%2012.3445C56.4%2010.4445%2054.7%209.94446%2052.1%2010.8445C54.1%209.84446%2055%208.14446%2054.4%206.54446ZM54.6%2013.3445C54.9%2014.1445%2054.9%2014.8445%2054.6%2015.4445C54.2%2016.0445%2053.8%2016.4445%2052.8%2016.8445L52.1%2017.1445L50%2012.2445L50.9%2011.8445C52.7%2011.2445%2054%2011.7445%2054.6%2013.3445ZM50.5%2011.1445L49.7%2011.4445L47.7%206.84446L48.8%206.34446C50.3%205.74446%2051.4%206.24446%2052%207.74446C52.6%209.24446%2052%2010.5445%2050.5%2011.1445Z'%20fill='%23888888'%20/%3e%3cpath%20d='M27.9%2077.1444C27.9%20103.444%2050.3%20126.444%2076.1%20126.444C76.1%20126.044%2075.8%20120.244%2075.8%20120.244C75.8%20119.644%2075.6%20119.444%2074.8%20119.344C74.8%20119.344%2063.5%20118.444%2059.8%20116.544C59.7%20116.444%2059.7%20116.344%2059.9%20116.344C59.9%20116.344%2067.5%20117.644%2074.7%20117.644C74.7%20117.644%2075.5%20117.644%2075.5%20116.744C75.5%20115.944%2075.2%2098.0444%2075.2%2098.0444C75.1%2096.7444%2074.9%2096.4444%2073.6%2096.3444C65.8%2095.9444%2058.1%2094.3444%2051.5%2091.5444C51.3%2091.4444%2051.2%2091.4444%2051.1%2091.5444C51%2091.6444%2051%2091.9444%2051%2091.9444C50.4%20100.244%2051.3%20108.344%2051.3%20108.344C51.3%20108.444%2051.3%20108.544%2051.2%20108.544C51.1%20108.544%2051%20108.444%2051%20108.444C49.8%20104.044%2049.2%2099.1444%2049.2%2093.9444C49.2%2093.5444%2049.2%2091.4444%2049.2%2091.4444C49.2%2090.8444%2049%2090.5444%2048.5%2090.2444C45.3%2088.7444%2042.6%2086.7444%2040.1%2084.7444C40.1%2084.7444%2039.9%2084.5444%2040.1%2084.4444C40.2%2084.3444%2040.4%2084.4444%2040.4%2084.4444C43%2086.1444%2045.9%2087.4444%2049%2088.7444H49.3C49.5%2088.6444%2049.5%2088.3444%2049.5%2087.9444C50%2080.3444%2052.1%2072.2444%2055%2064.5444C55.1%2064.3444%2055.1%2064.2444%2055.1%2064.1444C55.1%2063.9444%2055%2063.7444%2054.6%2063.5444C49.8%2061.4444%2046.1%2058.5444%2043.7%2055.4444C43.7%2055.4444%2043.5%2055.2444%2043.7%2055.1444C43.8%2055.0444%2044%2055.1444%2044%2055.1444C46.7%2057.8444%2050.7%2060.0444%2055.4%2061.7444C55.6%2061.8444%2055.7%2061.8444%2055.9%2061.8444C56.1%2061.8444%2056.3%2061.7444%2056.6%2061.0444C59.7%2053.8444%2063.8%2047.0444%2068.4%2041.4444C64.5%2040.5444%2060.5%2038.4444%2059.6%2036.1444C59.6%2036.1444%2059.5%2035.8444%2059.7%2035.8444C59.9%2035.7444%2060.1%2035.9444%2060.1%2035.9444C64.4%2040.6444%2077%2040.3444%2077%2040.3444C82.2%2040.3444%2093.1%2038.5444%2093.1%2034.1444C93.1%2030.1444%2087.3%2028.0444%2076.8%2027.9444C44.9%2027.8444%2027.9%2055.3444%2027.9%2077.1444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M66.8%2013.8444L72.4%2013.0444L72.3%2012.5444L70.8%2012.1444L64%201.04443L63%201.24443L60.1%2014.2444L58.8%2015.0444L58.9%2015.5444L63.2%2014.5444L63.1%2014.0444L61.5%2013.6444L62.2%209.64443L66.1%208.84443L68%2012.3444L66.7%2013.3444L66.8%2013.8444ZM62.4%208.64443L63.4%203.94443L65.7%208.04443L62.4%208.64443Z'%20fill='%23888888'%20/%3e%3cpath%20d='M24.2%2021.1444L20%2025.2444L20.4%2025.6444L22.1%2024.9444L29.6%2032.5444L28.9%2034.0444L29.3%2034.4444C32.5%2031.1444%2035.8%2028.0444%2035.8%2028.0444L33.7%2025.4444L33.1%2026.0444L33.9%2028.5444L31.5%2030.8444L23.9%2023.1444L24.6%2021.5444L24.2%2021.1444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M73.6%2012.5444V13.0444C77.6%2012.9444%2082.6%2013.1444%2082.6%2013.1444L82.9%209.74444H82.1L80.8%2012.2444L77.7%2012.1444L77.8%201.24444L79.5%200.544444V0.0444444C79.5%200.0444444%2076.7%20-0.0555556%2073.7%200.0444444V0.544444L75.3%201.24444L75.2%2011.8444L73.6%2012.5444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M9.4%2073.0444C6.8%2072.8444%204.1%2072.5444%201.5%2072.3444C1.3%2071.7444%201.1%2071.2444%201%2070.6444C0.8%2070.6444%200.6%2070.6444%200.5%2070.5444C0.3%2072.5444%200.1%2074.5444%200%2076.5444C0.2%2076.5444%200.4%2076.5444%200.5%2076.5444C0.8%2075.9444%201%2075.4444%201.3%2074.8444C3.9%2075.0444%206.6%2075.2444%209.2%2075.4444C11.8%2075.6444%2013.5%2074.0444%2013.8%2070.9444C13.9%2069.5444%2013.7%2068.3444%2013.2%2067.3444C12.5%2066.1444%2011.5%2065.4444%209.6%2065.2444C7.2%2064.9444%204.8%2064.6444%202.3%2064.4444C2.1%2063.8444%202%2063.2444%201.8%2062.6444C1.6%2062.6444%201.4%2062.6444%201.3%2062.5444C1.1%2064.2444%200.9%2065.8444%200.7%2067.5444C0.9%2067.5444%201.1%2067.5444%201.2%2067.6444C1.5%2067.1444%201.8%2066.5444%202.1%2066.0444C4.6%2066.3444%207.2%2066.6444%209.7%2066.8444C11.1%2067.0444%2011.9%2067.3444%2012.3%2068.1444C12.6%2068.7444%2012.8%2069.4444%2012.7%2070.3444C12.5%2072.3444%2011.5%2073.2444%209.4%2073.0444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M2.10001%2058.8444C2.30001%2058.9444%202.40001%2058.9444%202.60001%2059.0444C3.00001%2058.5444%203.40001%2058.0444%203.80001%2057.6444C7.20001%2058.7444%2010.5%2059.8444%2013.8%2060.8444C13.9%2061.4444%2013.9%2062.0444%2014%2062.6444C14.2%2062.7444%2014.3%2062.7444%2014.5%2062.8444C15%2061.4444%2015.4%2060.0444%2015.9%2058.5444C15.7%2058.4444%2015.6%2058.4444%2015.4%2058.3444C15%2058.7444%2014.6%2059.1444%2014.3%2059.6444C11.5%2058.7444%208.60001%2057.7444%205.80001%2056.8444C9.90001%2055.3444%2014.1%2053.9444%2018.2%2052.6444C18.3%2052.3444%2018.4%2052.0444%2018.5%2051.7444C14.7%2050.3444%2011%2049.0444%207.20001%2047.6444C7.20001%2047.0444%207.20001%2046.4444%207.10001%2045.8444C6.90001%2045.7444%206.80001%2045.7444%206.60001%2045.6444C6.10001%2047.1444%205.50001%2048.5444%205.00001%2050.0444C5.20001%2050.1444%205.30001%2050.1444%205.50001%2050.2444C5.90001%2049.8444%206.30001%2049.3444%206.70001%2048.9444C9.10001%2049.7444%2011.5%2050.6444%2013.8%2051.4444C10.3%2052.5444%206.80001%2053.7444%203.20001%2055.0444C2.90001%2056.3444%202.50001%2057.5444%202.10001%2058.8444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M15.3%20128.644C20.3%20132.644%2026.8%20132.144%2032.5%20134.344C27.3%20129.344%2026.4%20121.944%2024.2%20115.444C22.7%20111.444%2020.4%20107.744%2017.9%20104.244C20.6%20110.744%2019.3%20119.244%2023%20125.244C24%20127.244%2025.7%20128.944%2027.1%20130.544L27%20130.644C25.7%20129.944%2024.5%20128.844%2023.3%20127.644C17%20121.544%207.7%20120.744%204%20110.744C5%20118.044%2010%20124.444%2015.3%20128.644Z'%20fill='%23888888'%20/%3e%3cpath%20d='M78.4%2093.1444C78.5%2093.2444%2078.8%2093.3444%2079.2%2093.3444C82.6%2093.1444%2091.5%2092.5444%20100.3%2089.1444C101.5%2088.6444%20101.8%2088.1444%20101.8%2087.2444C101.8%2087.0444%20101.8%2086.7444%20101.7%2086.5444C100.8%2079.7444%2099.2%2072.9444%2096.9%2066.1444C96.6%2065.2444%2096.4%2065.1444%2096.2%2065.1444C96%2065.1444%2095.8%2065.2444%2095.5%2065.3444C90.6%2066.9444%2085.2%2067.8444%2079.5%2068.0444C78.4%2068.0444%2078.1%2068.8444%2078.1%2069.6444C78.1%2073.1444%2078.2%2078.7444%2078.2%2086.1444C78.2%2088.0444%2078.2%2090.5444%2078.2%2092.4444C78.1%2092.3444%2078.1%2092.9444%2078.4%2093.1444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M118.3%20132.444C121.2%20128.144%20124.7%20121.144%20125.4%20120.644C119.3%20124.444%20115.1%20129.044%20109.6%20133.644C105.4%20137.144%20101.3%20138.044%2096.5%20139.044C96.5%20139.044%2097.1%20139.344%2097.9%20139.344C102.7%20139.344%20110.1%20143.144%20120.1%20143.144C127.1%20143.144%20137.7%20139.644%20142.8%20130.344C142.8%20130.344%20138.3%20136.944%20120.9%20136.944C116.5%20136.944%20108.5%20138.644%20108.5%20138.644C107.6%20138.844%20107.2%20138.644%20107.2%20138.644C107.2%20138.644%20107.7%20138.344%20110.2%20137.744C113%20137.144%20116.3%20135.444%20118.3%20132.444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M132.9%2043.3444L131.6%2042.2444L131.1%2042.5444C131.1%2042.5444%20132.3%2044.5444%20133.3%2046.3444L133.8%2046.1444L133.7%2044.5444L137.7%2044.2444L139.5%2047.8444L136.8%2050.6444L135.5%2049.6444L135%2049.8444C135%2049.8444%20136.1%2052.2444%20137.1%2054.9444L137.6%2054.7444V53.1444L146.5%2043.7444L146%2042.6444L132.9%2043.3444ZM140.3%2047.0444L138.8%2044.0444L143.6%2043.7444L140.3%2047.0444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M112.5%208.34445C108.7%206.34445%20105.1%207.74445%20103.3%2011.6444C101.7%2015.1444%20102.7%2018.4444%20105.9%2020.0444C109.5%2021.8444%20113.1%2020.3444%20115.1%2016.7444C116.9%2013.5444%20116.1%2010.1444%20112.5%208.34445ZM112.6%2015.9444C110.9%2018.9444%20108.5%2020.2444%20106.7%2019.3444C104.8%2018.3444%20104.4%2015.6444%20105.8%2012.4444C107.2%209.24445%20109.3%207.84445%20111.8%209.14445C114.1%2010.2444%20114.2%2013.0444%20112.6%2015.9444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M118.1%20150.344C122%20148.944%20125.7%20146.944%20128.5%20143.644C122.8%20147.344%20114.4%20147.644%20107.9%20145.344C99.3%20141.844%2090.2%20137.344%2079.8%20139.444C78.6%20139.644%2077.7%20139.944%2076.6%20139.944C75.6%20139.944%2074.6%20139.644%2073.4%20139.444C62.9%20137.344%2053.9%20141.744%2045.3%20145.344C38.8%20147.744%2030.4%20147.344%2024.7%20143.644C27.5%20146.944%2031.3%20148.944%2035.2%20150.344C42.4%20153.044%2051%20151.244%2057%20147.344C62.1%20144.644%2066.5%20139.344%2073.3%20141.344C66.4%20144.344%2060.2%20148.544%2054.5%20153.944L58.1%20156.644C58.1%20156.644%2064.8%20147.644%2076.7%20142.244C88.7%20147.644%2095.3%20156.644%2095.3%20156.644L98.9%20153.944C93.2%20148.544%2086.9%20144.344%2080.1%20141.344C86.8%20139.344%2091.3%20144.644%2096.4%20147.344C102.3%20151.244%20110.9%20153.044%20118.1%20150.344Z'%20fill='%23888888'%20/%3e%3cpath%20d='M35%2012.3444C31.4%2014.6444%2030.8%2018.5444%2033.2%2021.9444C35.4%2025.0444%2038.8%2025.9444%2041.8%2023.8444C45.1%2021.6444%2045.7%2017.8444%2043.6%2014.3444C41.7%2011.2444%2038.4%2010.2444%2035%2012.3444ZM41.6%2022.8444C39.8%2024.0444%2037.2%2023.0444%2035.2%2020.1444C33.2%2017.3444%2033%2014.8444%2035.4%2013.3444C37.6%2011.9444%2040%2013.2444%2041.7%2016.0444C43.4%2019.0444%2043.3%2021.7444%2041.6%2022.8444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M96.4%2033.7444C96.4%2035.0444%2095.8%2036.2444%2094.7%2037.5444C100.2%2040.7444%20104.9%2044.5444%20108.9%2049.2444C108.9%2049.2444%20109.5%2050.0444%20109.9%2050.0444C110.2%2050.0444%20110.4%2049.3444%20110.4%2049.3444C111.3%2047.1444%20111.4%2044.1444%20110.5%2041.9444C109.6%2039.8444%20106.9%2037.8444%20106.9%2037.8444C102.7%2034.5444%2098%2032.5444%2095.8%2031.6444C96.2%2032.2444%2096.4%2033.0444%2096.4%2033.7444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M89.9%207.74443C89%2011.6444%2090.7%2014.6444%2094.5%2015.6444C95.6%2015.9444%2096.6%2016.0444%2098.5%2016.1444H98.8L99.8%2013.1444L99%2012.9444L97.3%2015.2444C96.8%2015.2444%2096.5%2015.1444%2096%2015.0444C93%2014.2444%2091.7%2011.7444%2092.5%208.44443C93.2%205.24443%2095.3%203.24443%2099.5%204.34443C100.1%204.54443%20100.5%204.74443%20100.5%204.74443L100.7%207.54443L101.5%207.74443L102.3%204.64443C100.9%203.84443%2099.7%203.34443%2098.6%203.04443C93.7%201.74443%2090.8%203.64443%2089.9%207.74443Z'%20fill='%23888888'%20/%3e%3cpath%20d='M74%2067.9444C68.3%2067.6444%2062.6%2066.6444%2057.8%2064.9444C57.6%2064.8444%2057.4%2064.8444%2057.3%2064.8444C57.1%2064.8444%2057%2064.9444%2056.9%2065.3444C52.4%2076.7444%2051.5%2089.0444%2051.5%2089.0444C51.5%2089.6444%2051.6%2089.7444%2052%2089.9444C52%2089.9444%2061.6%2093.6444%2074%2093.6444C74%2093.6444%2074.9%2093.6444%2075.1%2093.4444C75.4%2093.1444%2075.4%2092.9444%2075.4%2091.9444C75.4%2085.8444%2075.6%2069.7444%2075.6%2069.7444C75.4%2068.4444%2074.9%2067.9444%2074%2067.9444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M112.7%2053.5444C112.7%2053.9444%20112.9%2054.1444%20113.1%2054.6444C113.1%2054.6444%20118%2061.4444%20120.9%2072.6444C124%2067.2444%20124%2062.7444%20124%2062.7444C124%2062.4444%20124%2062.2444%20124%2062.0444C122.6%2055.8444%20119.3%2050.0444%20114.4%2044.6444C114.5%2045.1444%20114.5%2045.6444%20114.5%2046.1444C114.5%2048.0444%20114.1%2049.9444%20113.2%2051.9444C112.9%2052.6444%20112.7%2053.1444%20112.7%2053.5444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M143.4%2053.2444C139.5%2054.5444%20137.8%2057.2444%20138.9%2061.1444C139.2%2062.2444%20139.6%2063.1444%20140.5%2064.7444L140.7%2065.0444L143.8%2064.3444L143.6%2063.5444L140.7%2063.2444V63.1444C140.5%2062.7444%20140.4%2062.4444%20140.2%2062.0444C139.4%2058.9444%20140.9%2056.7444%20144.1%2055.6444C147.4%2054.5444%20150.1%2055.9444%20151.1%2059.5444C151.2%2059.9444%20151.3%2060.4444%20151.3%2060.7444L149%2062.3444L149.2%2063.1444L152.4%2062.3444C152.4%2060.7444%20152.2%2059.3444%20151.9%2058.1444C150.8%2053.9444%20147.5%2051.9444%20143.4%2053.2444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M112.9%2023.2444L112.5%2023.6444L116.2%2026.3444L116.6%2025.9444L115.9%2024.3444L121.3%2017.5444L118.3%2028.0444L118.7%2028.3444L128.6%2023.8444L122.7%2030.1444L121.1%2029.6444L120.7%2030.0444C120.7%2030.0444%20122.6%2031.9444%20124.6%2033.8444L125%2033.4444L124.2%2031.8444L131.6%2024.2444L133.3%2024.8444L133.7%2024.4444L130.8%2021.4444L121.8%2025.5444L124.5%2016.0444L121.1%2013.5444L120.7%2013.9444L121.5%2015.5444L114.7%2023.7444L112.9%2023.2444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M77.8%20117.344C78%20117.544%2078.5%20117.444%2078.5%20117.444C86%20116.944%2093.1%20115.344%2099.6%20112.644C100.6%20112.244%20100.7%20111.644%20101%20110.544C102.8%20103.444%20102.3%2093.8445%20102.3%2093.8445C102.3%2093.8445%20102.3%2092.6445%20101.9%2092.4445C101.5%2092.1445%20100.6%2092.5445%20100.6%2092.5445C94%2094.8445%2086.9%2096.1445%2079.3%2096.3445C77.9%2096.4445%2078%2096.7445%2077.9%2097.8445C77.8%20104.444%2077.7%20110.744%2077.5%20116.444C77.7%20116.544%2077.6%20117.144%2077.8%20117.344Z'%20fill='%23888888'%20/%3e%3cpath%20d='M76.2%2042.5444C74.1%2042.5444%2071.5%2042.1444%2069.7%2041.7444C65.1%2047.6444%2061.3%2054.2444%2058.2%2061.6444C57.9%2062.3444%2058%2062.5444%2058%2062.5444C58.1%2062.6444%2058.3%2062.7444%2058.3%2062.7444C62%2063.9444%2069.1%2065.1444%2074.1%2065.1444C74.7%2065.1444%2075%2065.0444%2075.2%2064.8444C75.4%2064.6444%2075.5%2064.2444%2075.5%2063.5444C75.6%2056.7444%2075.8%2049.5444%2076.2%2042.5444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M12.1%20115.344C13.8%20116.744%2017.3%20120.044%2018%20120.944C18%20120.944%2017.6%20119.644%2017.2%20117.944C16.8%20116.344%2016.2%20112.344%2014.6%20108.844C13.3%20106.144%208%2097.3445%207%2092.4445C7%2092.6445%203.2%20107.744%2012.1%20115.344Z'%20fill='%23888888'%20/%3e%3cpath%20d='M45.7%20138.744C45.7%20138.744%2037.6%20137.044%2033.3%20137.044C15.9%20137.044%2011.4%20130.444%2011.4%20130.444C16.5%20139.744%2027.2%20143.244%2034.1%20143.244C44%20143.244%2051.5%20139.444%2056.3%20139.444C57.1%20139.444%2057.7%20139.144%2057.7%20139.144C52.8%20138.044%2048.7%20137.144%2044.6%20133.744C39.1%20129.144%2034.9%20124.544%2028.8%20120.744C29.5%20121.244%2033%20128.344%2035.9%20132.544C37.9%20135.544%2041.2%20137.144%2044%20137.844C46.5%20138.444%2047%20138.744%2047%20138.744C47%20138.744%2046.6%20138.944%2045.7%20138.744Z'%20fill='%23888888'%20/%3e%3cpath%20d='M77.5%2042.5445C77.7%2049.7445%2077.9%2056.8445%2078%2063.7445C78%2064.3445%2078.1%2064.7445%2078.3%2064.8445C78.4%2064.9445%2078.7%2065.0445%2079.1%2065.0445C83.8%2065.0445%2090.5%2063.5445%2094.4%2062.1445C94.8%2062.0445%2095%2061.9445%2095.1%2061.5445C95.2%2061.2445%2094.9%2060.5445%2094.9%2060.5445C92%2053.4445%2088.5%2047.0445%2084.8%2041.9445C82.8%2042.3445%2078.9%2042.5445%2077.5%2042.5445Z'%20fill='%23888888'%20/%3e%3cpath%20d='M109.8%2056.9445C109.7%2056.9445%20109.4%2057.0445%20109.1%2057.3445C107%2059.4445%20104.3%2061.3445%20100.9%2062.9445C100.1%2063.3445%20100%2063.6445%20100%2063.9445C100%2064.1445%20100.1%2064.4445%20100.2%2064.8445C102.7%2071.4445%20104.4%2078.0445%20105.2%2084.7445C105.2%2084.7445%20105.3%2086.0445%20105.6%2086.2445C105.9%2086.4445%20106.8%2085.9445%20106.9%2085.8445C110.7%2083.5445%20114.3%2080.6445%20116.3%2078.6445C117.1%2077.8445%20117.4%2077.2445%20117.4%2076.3445C117.4%2075.8445%20117.3%2075.3445%20117.1%2074.6445C115.6%2068.4445%20113.3%2062.6445%20110.3%2057.4445C110.1%2057.1445%20109.9%2056.9445%20109.8%2056.9445Z'%20fill='%23888888'%20/%3e%3cpath%20d='M95.9%20122.644C97.2%20120.844%2098.3%20118.844%2099.2%20116.644C99.3%20116.444%2099.4%20116.244%2099.4%20116.044C99.4%20115.844%2099.3%20115.944%2099.3%20115.944C99.2%20115.944%2098.9%20116.044%2098.4%20116.144C90.2%20118.744%2083.1%20119.344%2078.5%20119.444C77.9%20119.444%2077.7%20119.644%2077.6%20120.444L77.2%20126.544C77.2%20126.344%2086.4%20126.544%2095.9%20122.644Z'%20fill='%23888888'%20/%3e%3cpath%20d='M103.7%20110.944C104.1%20110.744%20111%20107.444%20115.7%20102.744C117.3%20101.244%20118.5%2098.8444%20118.8%2096.3444C119.7%2087.9444%20118.6%2082.3444%20118.6%2082.3444C118.6%2082.1444%20118.4%2082.3444%20118.4%2082.3444C116.2%2084.5444%20112.2%2087.4444%20107.5%2089.8444C106%2090.6444%20105.8%2091.1444%20105.8%2092.5444C105.9%20100.144%20105%20105.944%20103.3%20110.844C103.4%20110.744%20103.2%20111.144%20103.7%20110.944Z'%20fill='%23888888'%20/%3e%3cpath%20d='M125.8%2069.1444C125.3%2071.4444%20124.5%2073.8444%20123.2%2076.0444C122.3%2077.5444%20122%2078.5444%20122.1%2079.5444C122.4%2082.8444%20122.4%2085.7444%20122.4%2085.7444C122.4%2089.1444%20122.1%2092.4444%20121.4%2095.5444C124.1%2090.8444%20126.4%2083.9444%20126.4%2076.0444C126.4%2073.7444%20126.2%2071.4444%20125.8%2069.1444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M130.8%20127.644C129.6%20128.844%20128.4%20129.844%20127.1%20130.644L127%20130.544C128.4%20129.044%20130.1%20127.244%20131.1%20125.244C134.8%20119.244%20133.5%20110.744%20136.2%20104.244C133.7%20107.844%20131.4%20111.444%20129.9%20115.444C127.7%20122.044%20126.8%20129.444%20121.6%20134.344C127.2%20132.144%20133.7%20132.644%20138.7%20128.644C144%20124.444%20148.9%20118.044%20150%20110.744C146.4%20120.644%20137.1%20121.544%20130.8%20127.644Z'%20fill='%23888888'%20/%3e%3cpath%20d='M17.4%2028.7445C16.1%2029.9445%2015.2%2030.8445%2014.5%2031.7445C11.6%2035.7445%2012.6%2039.2445%2016%2041.6445C19.4%2044.0445%2022.8%2043.3445%2025.2%2039.9445C25.9%2038.9445%2026.4%2037.8445%2027.1%2036.0445L24.2%2033.9445L24.6%2032.2445L24.1%2031.9445L20.8%2036.4445L21.2%2036.7445L22.7%2035.8445L25.3%2037.6445C25.3%2037.6445%2025.3%2037.9445%2024.9%2038.4445C23.1%2041.0445%2020.3%2041.4445%2017.5%2039.4445C14.4%2037.2445%2013.6%2034.4445%2016.1%2031.2445C16.4%2030.9445%2016.6%2030.6445%2017%2030.4445L19.6%2031.1445L20.2%2030.3445L17.6%2028.4445L17.4%2028.7445Z'%20fill='%23888888'%20/%3e%3cpath%20d='M142.1%20115.344C151%20107.744%20147.2%2092.5444%20147.2%2092.5444C146.2%2097.3444%20140.9%20106.244%20139.6%20108.944C138%20112.344%20137.4%20116.444%20137%20118.044C136.6%20119.644%20136.2%20121.044%20136.2%20121.044C136.8%20120.044%20140.4%20116.844%20142.1%20115.344Z'%20fill='%23888888'%20/%3e%3cpath%20d='M149.7%2065.7444L149.8%2066.5444L152.6%2067.3444L152.8%2070.0444L142.1%2070.8444L141.3%2068.7444H140.8C140.8%2068.7444%20141.2%2072.0444%20141.3%2075.5444H141.8L142.3%2073.3444L153%2072.5444L153.2%2075.2444L150.6%2076.4444L150.7%2077.2444L154.3%2076.9444C154.3%2071.2444%20153.4%2065.5444%20153.4%2065.5444L149.7%2065.7444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M93%2038.9445C91.5%2039.9445%2089.2%2040.8445%2086.7%2041.4445C91%2046.5445%2094.6%2052.4445%2097.7%2059.0445C98%2059.7445%2098.2%2060.0445%2098.4%2060.1445C98.7%2060.2445%2099.1%2060.0445%2099.4%2059.8445C102.4%2058.2445%20105.1%2056.3445%20106.8%2054.5445C107.2%2054.1445%20107.3%2053.8445%20107.3%2053.4445C107.3%2053.0445%20107.1%2052.6445%20106.7%2052.0445C102.9%2046.6445%2098.2%2042.2445%2093%2038.9445Z'%20fill='%23888888'%20/%3e%3cpath%20d='M126.2%2034.9444L125.8%2035.2444C125.8%2035.2444%20127.6%2037.5444%20129.3%2039.7444L129.7%2039.4444L129.3%2037.7444L132.6%2035.2444L133.4%2036.3444C135.2%2038.7444%20137.6%2039.5444%20139.6%2038.0444C140.6%2037.3444%20141%2036.3444%20141%2035.2444C141%2034.1444%20140.6%2033.2444%20139.5%2031.6444L136.1%2027.2444L135.6%2027.5444L136%2029.2444L127.7%2035.7444L126.2%2034.9444ZM137.8%2031.1444L138.6%2032.1444C139.2%2032.9444%20139.3%2033.4444%20139.2%2034.1444C139.1%2034.8444%20138.6%2035.5444%20137.9%2036.0444C137.1%2036.6444%20136.1%2036.7444%20135.3%2036.5444C134.7%2036.3444%20134.3%2036.0444%20133.6%2035.2444L133.2%2034.7444L137.8%2031.1444Z'%20fill='%23888888'%20/%3e%3cpath%20d='M115.2%20107.144C111.7%20109.944%20107.7%20112.344%20103.2%20114.344C102.3%20114.744%20101.6%20115.744%20101.2%20116.544C100.3%20118.344%2099.3%20120.044%2098.2%20121.644C104%20118.644%20110.7%20112.944%20115.2%20107.144Z'%20fill='%23888888'%20/%3e%3c/svg%3e", x0 = ({ className: c }) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "143.1px",
    height: "24px",
    viewBox: "0 0 143.1 24",
    "enable-background": "new 0 0 143.1 24",
    className: c,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        id: "Combined-Shape",
        fill: "currentColor",
        d: `M74.3,0c1.7,0,3.1,0.7,3.1,2.2c0,0.9-0.7,1.6-1.5,1.6c-0.4,0-0.7-0.1-1-0.1\r
	c-0.7,0-1,0.4-1,1.1v2h1.4c1.4,0,2.1,0.4,2.1,1.5c0,1.1-0.7,1.5-2.1,1.5h-1.4v11.7c0,1.5-0.9,2.3-2.3,2.3c-1.4,0-2.3-0.8-2.3-2.3\r
	V9.9H68c-1.3,0-1.9-0.5-1.9-1.5c0-1,0.5-1.5,1.9-1.5h1.1V4.5C69.1,1.6,71.5,0,74.3,0z M117.2,6.4c3.2,0,5.9,1.5,5.9,5.7v9.6\r
	c0,1.2-0.5,2.3-2.3,2.3c-1.8,0-2.3-1.1-2.3-2.3v-8.4c0-1.7-0.7-3-2.6-3c-1.8,0-3.4,1.4-3.4,3.6v7.8c0,1.2-0.5,2.3-2.3,2.3\r
	c-1.8,0-2.3-1.1-2.3-2.3v-8.4c0-1.7-0.7-3-2.6-3c-1.8,0-3.4,1.4-3.4,3.6v7.8c0,1.2-0.5,2.3-2.3,2.3c-1.8,0-2.3-1.1-2.3-2.3V8.8\r
	c0-1.4,0.8-2.3,2.2-2.3c1.4,0,2.2,0.9,2.2,2.3v0.6h0.1c1.2-1.9,3.3-2.9,5.7-2.9c1.6,0,3.6,0.7,4.5,2.9C113,7.6,114.7,6.4,117.2,6.4z\r
	 M58,6.4c3.2,0,5.9,1.5,5.9,5.7v9.6c0,1.2-0.5,2.3-2.3,2.3c-1.8,0-2.3-1.1-2.3-2.3v-8.4c0-1.7-0.7-3-2.6-3c-1.8,0-3.4,1.4-3.4,3.6\r
	v7.8c0,1.2-0.5,2.3-2.3,2.3c-1.8,0-2.3-1.1-2.3-2.3v-8.4c0-1.7-0.7-3-2.6-3c-1.8,0-3.4,1.4-3.4,3.6v7.8c0,1.2-0.5,2.3-2.3,2.3\r
	c-1.8,0-2.3-1.1-2.3-2.3V8.8c0-1.4,0.8-2.3,2.2-2.3c1.4,0,2.2,0.9,2.2,2.3v0.6h0.1c1.2-1.9,3.3-2.9,5.7-2.9c1.6,0,3.6,0.7,4.5,2.9\r
	C53.8,7.6,55.5,6.4,58,6.4z M8.8,6.4c3.9,0,6.8,2.2,6.8,4.4c0,1.3-1,2-2.2,2c-2.2,0-1.4-2.8-4.8-2.8c-1.8,0-4,1.2-4,5.5\r
	c0,2.9,1.4,4.8,4,4.8c3.3,0,2.6-3,5-3c1.2,0,2,0.9,2,1.8c0,2-2.3,4.9-7.1,4.9C2.7,24,0,20.4,0,15.6C0,10.2,3.1,6.4,8.8,6.4z\r
	 M26.9,6.1c2.1,0.1,4.1,1,5.7,2.6c1.7,1.7,2.6,4,2.6,6.3c0,2.3-0.9,4.6-2.6,6.3c-1.7,1.7-4,2.6-6.3,2.6h0c-2.3,0-4.6-0.9-6.3-2.6\r
	c-1.7-1.7-2.6-4-2.6-6.3c0-2.3,0.9-4.6,2.6-6.3c0.8-0.8,2.1-0.8,2.9,0c0.8,0.8,0.8,2.1,0,2.9c-1,0.9-1.4,2.2-1.4,3.4\r
	c0,1.2,0.5,2.5,1.4,3.4c1,0.9,2.2,1.4,3.4,1.4c1.3,0,2.5-0.5,3.4-1.4c1-0.9,1.4-2.2,1.4-3.4c0-1.2-0.5-2.5-1.4-3.4\r
	c-0.9-0.9-2-1.3-3.1-1.4c-1.1-0.1-2-1-1.9-2.2C24.8,6.9,25.7,6.1,26.9,6.1z M134.4,6.5c0.7,0,1.4,0.4,1.8,1.1l6.8,13.4l0,0\r
	c0.5,1,0.1,2.1-0.9,2.6c-0.3,0.1-0.6,0.2-0.9,0.2c-0.7,0-1.4-0.4-1.8-1.1l-5-9.9l-3.6,7.1l4.3,0c1.1,0,2,0.9,2,1.9\r
	c0,1.1-0.9,1.9-2,1.9h-7.5c-0.7,0-1.3-0.3-1.7-0.9c-0.4-0.6-0.4-1.3-0.1-1.9l6.7-13.4C132.9,6.9,133.6,6.5,134.4,6.5z M87.5,7.5\r
	L94.2,21c0.3,0.6,0.3,1.3-0.1,1.9c-0.4,0.6-1,0.9-1.7,0.9H78.9c-0.7,0-1.3-0.3-1.7-0.9c-0.4-0.6-0.4-1.3-0.1-1.9l3.8-7.5\r
	c0.5-1,1.7-1.4,2.6-0.9c1,0.5,1.4,1.7,0.9,2.6l-2.3,4.6h7.1L84,9.3h0c-0.5-1-0.1-2.1,0.9-2.6C85.8,6.2,87,6.6,87.5,7.5z`
      }
    )
  }
), R1 = ({ topContent: c, mainContent: t }) => /* @__PURE__ */ e.jsx("footer", { className: "cfm:w-full cfm:border-t-[3px] cfm:border-primary cfm:bg-gray-50 cfm:text-sm", children: /* @__PURE__ */ e.jsxs("div", { className: "cfm:container cfm:mx-auto", children: [
  /* @__PURE__ */ e.jsx("div", { className: "cfm:px-4 cfm:mt-12 cfm:md:mt-18", children: /* @__PURE__ */ e.jsx("div", { className: "cfm:max-w-screen-lg cfm:mx-auto cfm:relative", children: c }) }),
  /* @__PURE__ */ e.jsx("hr", { className: "cfm:max-w-[78.13%] cfm:mx-auto cfm:text-secondary-300  cfm:mt-12 cfm:md:mt-18" }),
  /* @__PURE__ */ e.jsx("div", { className: "cfm:px-4  cfm:mt-12 cfm:md:mt-18", children: /* @__PURE__ */ e.jsx("div", { className: "cfm:max-w-screen-lg cfm:mx-auto", children: t }) }),
  /* @__PURE__ */ e.jsx("hr", { className: "cfm:max-w-[60%] cfm:mx-auto cfm:text-secondary-300  cfm:mt-12 cfm:md:mt-18" }),
  /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:flex-col cfm:items-center cfm:text-center cfm:px-4  cfm:mt-12 cfm:md:mt-18 cfm:text-gray-600", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "cfm:mb-6 cfm:flex cfm:flex-col cfm:items-center cfm:gap-4", children: [
      /* @__PURE__ */ e.jsx(x0, { className: "cfm:w-[180px] cfm:max-w-full cfm:text-primary" }),
      /* @__PURE__ */ e.jsx("p", { className: "cfm:text-xs", children: "Comfama es un sitio seguro." })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:justify-center cfm:items-center cfm:gap-8 cfm:my-4", children: [
      /* @__PURE__ */ e.jsx(
        "img",
        {
          src: a1,
          alt: "Asocajas",
          className: "cfm:max-w-[100px] md:cfm:max-w-[150px]"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "img",
        {
          src: n1,
          alt: "Pacto Global",
          className: "cfm:max-w-[100px] md:cfm:max-w-[150px]"
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("p", { className: "cfm:text-[0.65rem] md:cfm:text-xs cfm:text-gray-400 cfm:max-w-[80%] md:cfm:max-w-[570px] cfm:mx-auto", children: "Este sitio funciona mejor con Internet Explorer 10 en adelante con vista de compatibilidad activada, Google Chrome y Firefox y en resolución 1024 x 768 px." })
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "cfm:w-full cfm:h-[72px] cfm:bg-secondary-200 cfm:flex cfm:items-center cfm:justify-center cfm:text-center cfm:text-xs cfm:font-semibold cfm:text-gray-700 cfm:mt-12 md:cfm:mt-20 cfm:px-4", children: [
    "© ",
    (/* @__PURE__ */ new Date()).getFullYear(),
    " Comfama Todos los derechos reservados Medellín - Colombia."
  ] })
] }) }), z1 = ({
  fixed: c = !1,
  children: t,
  topNav: s,
  bottomNav: a,
  megaMenu: n,
  logo: f = /* @__PURE__ */ e.jsx(x0, { className: "cfm:text-primary" })
}) => {
  const [l, i] = z(!1);
  I(() => (document.body.style.overflow = l ? "hidden" : "auto", () => {
    document.body.style.overflow = "auto";
  }), [l]);
  const o = () => {
    i((x) => !x);
  }, m = (x) => {
    (x.key === "Enter" || x.key === " ") && o();
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: u(
        "cfm:header-home cfm:w-full cfm:max-w-full cfm:z-10",
        c && "cfm:fixed cfm:top-0 cfm:right-0"
      ),
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "cfm:border-b cfm:border-secondary-300 cfm:bg-white", children: /* @__PURE__ */ e.jsxs("div", { className: "cfm:lg:max-w-[1200px] cfm:xl:max-w-[1200px] cfm:2xl:max-w-[1536px] cfm:max-w-full cfm:mx-auto cfm:flex cfm:items-center cfm:justify-between cfm:h-[60px] cfm:sm:h-[90px]", children: [
          /* @__PURE__ */ e.jsx("div", { className: "cfm:max-w-[145px] cfm:ml-2", children: f }),
          /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:items-center cfm:h-full cfm:gap-6", children: [
            /* @__PURE__ */ e.jsx("nav", { className: "cfm:flex cfm:gap-5 cfm:items-center", children: s }),
            /* @__PURE__ */ e.jsxs(
              "button",
              {
                className: "cfm:menu-toggle cfm:gap-x-2 cfm:cursor-pointer cfm:h-[100%] cfm:relative cfm:flex cfm:items-center cfm:flex-col cfm:flex-col-reverse cfm:sm:flex-row cfm:px-4 cfm:py-2 cfm:text-white cfm:bg-primary cfm:font-bold cfm:text-sm",
                onClick: o,
                onKeyDown: m,
                "aria-expanded": l,
                children: [
                  /* @__PURE__ */ e.jsx("span", { children: "Menú" }),
                  /* @__PURE__ */ e.jsx("span", { className: "cfm:md:ml-3 cfm:text-lg", children: l ? "✖" : "☰" })
                ]
              }
            )
          ] })
        ] }) }),
        a && /* @__PURE__ */ e.jsx("div", { className: "cfm:hidden cfm:md:flex cfm:bg-secondary-100 cfm:h-[50px] cfm:items-center cfm:justify-between cfm:px-4", children: /* @__PURE__ */ e.jsx("div", { className: "cfm:container cfm:mx-auto", children: a }) }),
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: u(
              "cfm:absolute cfm:left-0 cfm:w-full cfm:z-10 cfm:flex cfm:justify-around cfm:p-5 cfm:transition-all cfm:duration-300 cfm:origin-right",
              a ? "" : "cfm:top-[90px]",
              l ? "cfm:scale-x-100 cfm:opacity-100 cfm:pointer-events-auto cfm:bg-gray-100" : "cfm:scale-x-0 cfm:opacity-0 cfm:pointer-events-none"
            ),
            style: { transformOrigin: "right" },
            children: /* @__PURE__ */ e.jsx(
              "div",
              {
                className: u(
                  "cfm:flex-1 cfm:p-2 cfm:transition-all cfm:duration-300",
                  l ? "cfm:translate-y-0 cfm:opacity-100" : "cfm:translate-y-8 cfm:opacity-0"
                ),
                children: n
              }
            )
          }
        ),
        t
      ]
    }
  );
}, t2 = {
  cda: /* @__PURE__ */ e.jsxs(
    "svg",
    {
      width: "48",
      height: "49",
      viewBox: "0 0 48 49",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e.jsx("circle", { cx: "24", cy: "24.1689", r: "24", fill: "#F3F3F3" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M24 40.1689C16.66 40.1689 12.98 40.1689 10.49 37.6789C8.00001 35.1889 8 31.5089 8 24.1689C8 16.8289 8.00001 13.1489 10.49 10.6589C12.98 8.16895 16.66 8.16895 24 8.16895C31.34 8.16895 35.02 8.16895 37.51 10.6589C40 13.1489 40 16.8289 40 24.1689C40 31.5089 40 35.1889 37.51 37.6789C35.02 40.1689 31.34 40.1689 24 40.1689ZM24 10.1689C17.21 10.1689 13.81 10.1689 11.9 12.0689C9.98999 13.9689 10 17.3789 10 24.1689C10 30.9589 9.99999 34.3589 11.9 36.2689C13.8 38.1689 17.21 38.1689 24 38.1689C30.79 38.1689 34.19 38.1689 36.1 36.2689C38 34.3689 38 30.9589 38 24.1689C38 17.3789 38 13.9789 36.1 12.0689C34.2 10.1589 30.79 10.1689 24 10.1689Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M24.0004 26.6689C23.4504 26.6689 23.0004 26.2189 23.0004 25.6689V23.7889C23.0004 23.0489 23.3304 21.9789 24.9204 21.0389C25.4704 20.7089 25.8104 20.1189 25.8104 19.4789C25.8104 18.4789 25.0004 17.6689 24.0004 17.6689C23.0004 17.6689 22.1904 18.4789 22.1904 19.4789C22.1904 20.0289 21.7404 20.4789 21.1904 20.4789C20.6404 20.4789 20.1904 20.0289 20.1904 19.4789C20.1904 17.3789 21.9004 15.6689 24.0004 15.6689C26.1004 15.6689 27.8104 17.3789 27.8104 19.4789C27.8104 20.8189 27.0904 22.0789 25.9404 22.7589C25.3504 23.1089 25.0004 23.4889 25.0004 23.7889V25.6689C25.0004 26.2189 24.5504 26.6689 24.0004 26.6689Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M24 31.6689C24.8284 31.6689 25.5 30.9974 25.5 30.1689C25.5 29.3405 24.8284 28.6689 24 28.6689C23.1716 28.6689 22.5 29.3405 22.5 30.1689C22.5 30.9974 23.1716 31.6689 24 31.6689Z",
            fill: "#EE2B7B"
          }
        )
      ]
    }
  ),
  whatsapp: /* @__PURE__ */ e.jsxs(
    "svg",
    {
      width: "49",
      height: "49",
      viewBox: "0 0 49 49",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e.jsx("circle", { cx: "24.167", cy: "24.6255", r: "24", fill: "#F3F3F3" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M18.2651 17.1545C18.5351 17.1145 19.3251 17.1045 19.5851 17.1545C19.8951 17.2045 20.0151 17.4845 20.1351 17.7245C20.5051 18.4745 20.9351 19.4745 21.2251 20.2545C21.5451 21.0945 21.5651 21.2645 21.0451 22.0145C20.8651 22.2745 20.1551 22.9645 20.1251 23.1645C20.0751 23.4445 20.2651 23.6845 20.4051 23.9145C21.3351 25.4845 22.8651 26.9145 24.4751 27.7745C24.9751 28.0445 25.5151 28.2445 26.0251 28.5045C26.1351 28.5145 26.2451 28.4845 26.3351 28.4145C26.8651 28.0445 27.3751 27.0445 27.8351 26.5945C28.1451 26.2945 28.5651 26.5145 28.9051 26.6545C29.7051 26.9745 31.1551 27.6445 31.8651 28.0945C32.1451 28.2745 32.1751 28.3245 32.1951 28.6645C32.3051 30.1545 31.1951 31.4145 29.8551 31.8845C26.3751 33.1145 21.3751 29.4545 19.1951 26.9645C17.2651 24.7545 15.0151 21.4245 16.7551 18.4845C17.0451 17.9945 17.6651 17.2345 18.2651 17.1445V17.1545Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M8.22346 40.7572L10.4635 32.7572C8.95758 30.2725 8.16699 27.4113 8.16699 24.4937C8.16699 15.6748 15.3482 8.49365 24.167 8.49365C32.9858 8.49365 40.167 15.6748 40.167 24.4937C40.167 33.3125 32.9858 40.4937 24.167 40.4937C21.5317 40.4937 18.9341 39.8442 16.6188 38.6019L8.22346 40.7572ZM16.8823 36.5972L17.2117 36.7854C19.3199 37.9807 21.7293 38.6113 24.167 38.6113C31.9505 38.6113 38.2846 32.2772 38.2846 24.4937C38.2846 16.7101 31.9505 10.376 24.167 10.376C16.3835 10.376 10.0493 16.7101 10.0493 24.4937C10.0493 27.0913 10.7646 29.6419 12.1105 31.8442L12.4964 32.456L10.9058 38.1313L16.8729 36.5972H16.8823Z",
            fill: "#EE2B7B"
          }
        )
      ]
    }
  ),
  services: /* @__PURE__ */ e.jsxs(
    "svg",
    {
      width: "48",
      height: "49",
      viewBox: "0 0 48 49",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e.jsx("circle", { cx: "24", cy: "24.1689", r: "24", fill: "#F3F3F3" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M24 34C23.21 34 22.42 33.84 21.69 33.53C15.72 30.98 12.5 24.02 12.5 18.77C12.5 12.83 17.66 8 24 8C30.34 8 35.5 12.83 35.5 18.77C35.5 24.02 32.28 30.98 26.31 33.53C25.57 33.84 24.79 34 24 34ZM24 10C18.76 10 14.5 13.94 14.5 18.77C14.5 23.6 17.29 29.47 22.47 31.69C23.44 32.11 24.55 32.1 25.52 31.69C30.7 29.48 33.49 23.38 33.49 18.77C33.49 13.93 29.23 10 23.99 10H24Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M24 23.5C21.79 23.5 20 21.71 20 19.5C20 17.29 21.79 15.5 24 15.5C26.21 15.5 28 17.29 28 19.5C28 21.71 26.21 23.5 24 23.5ZM24 17.5C22.9 17.5 22 18.4 22 19.5C22 20.6 22.9 21.5 24 21.5C25.1 21.5 26 20.6 26 19.5C26 18.4 25.1 17.5 24 17.5Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M24 39.9999C15.03 39.9999 8 36.5999 8 32.2499C8 30.9199 8.65 29.6299 9.89 28.5099C10.3 28.1399 10.93 28.1699 11.3 28.5799C11.67 28.9899 11.64 29.6199 11.23 29.9899C10.41 30.7299 10 31.4899 10 32.2499C10 34.9699 15.75 37.9999 24 37.9999C32.25 37.9999 38 34.9699 38 32.2499C38 31.4899 37.59 30.7299 36.77 29.9899C36.36 29.6199 36.33 28.9899 36.7 28.5799C37.07 28.1699 37.7 28.1399 38.11 28.5099C39.34 29.6299 40 30.9199 40 32.2499C40 36.5999 32.97 39.9999 24 39.9999Z",
            fill: "#EE2B7B"
          }
        )
      ]
    }
  ),
  presential: /* @__PURE__ */ e.jsxs(
    "svg",
    {
      width: "48",
      height: "49",
      viewBox: "0 0 48 49",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e.jsx("circle", { cx: "24", cy: "24.1689", r: "24", fill: "#F3F3F3" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M23.9396 24.7786C23.9396 25.5686 23.7596 26.1686 23.4096 26.5986C23.0596 27.0286 22.5596 27.2386 21.9196 27.2386C21.2796 27.2386 20.7696 27.0286 20.4196 26.5986C20.0696 26.1686 19.8896 25.5686 19.8896 24.7886V23.7286C19.8896 22.9386 20.0696 22.3386 20.4196 21.9086C20.7696 21.4786 21.2696 21.2686 21.9196 21.2686C22.5696 21.2686 23.0596 21.4786 23.4196 21.9086C23.7696 22.3386 23.9496 22.9486 23.9496 23.7286V24.7886L23.9396 24.7786ZM22.5896 23.5486C22.5896 23.1286 22.5396 22.8186 22.4296 22.6086C22.3196 22.3986 22.1496 22.2986 21.9096 22.2986C21.6696 22.2986 21.5096 22.3986 21.3996 22.5886C21.2996 22.7786 21.2396 23.0686 21.2296 23.4586V24.9486C21.2296 25.3786 21.2796 25.6986 21.3896 25.8986C21.4996 26.0986 21.6696 26.1986 21.9096 26.1986C22.1496 26.1986 22.3096 26.0986 22.4196 25.9086C22.5296 25.7086 22.5896 25.4086 22.5896 24.9886V23.5486Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M27.6195 27.1586H26.2695V22.8586L24.9395 23.2486V22.2286L27.4895 21.3486H27.6095V27.1686L27.6195 27.1586Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M23.99 39.9985C23.15 39.9985 22.3 39.6885 21.63 39.0785C21.05 38.5485 20.18 38.5485 19.61 39.0785C18.26 40.3085 16.23 40.3085 14.89 39.0785L14.17 38.4185C14 38.2685 13.76 38.2685 13.59 38.4185C12.87 39.0785 11.87 39.2385 10.98 38.8485C10.07 38.4485 9.5 37.5685 9.5 36.5585V15.5585C9.5 13.6685 9.49999 12.7185 9.78999 11.8385C10.33 10.1885 11.62 8.85853 13.23 8.29853C14.09 7.99853 15.02 7.99854 16.87 7.99854H31.13C32.98 7.99854 33.91 7.99853 34.77 8.29853C36.38 8.85853 37.67 10.1785 38.21 11.8385C38.5 12.7085 38.5 13.6585 38.5 15.5585V36.5585C38.5 37.5685 37.93 38.4485 37.02 38.8485C36.13 39.2385 35.13 39.0785 34.41 38.4085C34.24 38.2585 34 38.2585 33.83 38.4085L33.11 39.0685C31.76 40.2985 29.73 40.2985 28.38 39.0685C27.8 38.5385 26.93 38.5385 26.36 39.0685C25.69 39.6885 24.84 39.9885 24 39.9885L23.99 39.9985ZM13.86 36.2885C14.45 36.2885 15.03 36.4985 15.5 36.9285L16.23 37.5885C16.81 38.1185 17.68 38.1185 18.25 37.5885C19.6 36.3585 21.63 36.3585 22.97 37.5885C23.55 38.1185 24.42 38.1185 24.99 37.5885C26.34 36.3585 28.37 36.3585 29.71 37.5885C30.29 38.1185 31.16 38.1185 31.73 37.5885L32.45 36.9285C33.38 36.0785 34.79 36.0785 35.73 36.9285C35.9 37.0885 36.07 37.0585 36.18 37.0085C36.27 36.9685 36.46 36.8485 36.46 36.5485V15.5485C36.46 13.8685 36.46 13.0285 36.27 12.4585C35.92 11.3885 35.1 10.5385 34.07 10.1885C33.53 9.99854 32.71 9.99854 31.09 9.99854H16.83C15.21 9.99854 14.39 9.99854 13.85 10.1885C12.82 10.5485 12 11.3985 11.65 12.4585C11.46 13.0285 11.46 13.8685 11.46 15.5485V36.5485C11.46 36.8485 11.66 36.9685 11.74 37.0085C11.85 37.0585 12.02 37.0885 12.19 36.9285C12.66 36.4985 13.24 36.2885 13.83 36.2885H13.86Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M22.6905 18.7285C22.4105 18.7285 22.1305 18.6085 21.9405 18.3985L20.2005 16.4585C19.8305 16.0485 19.8705 15.4185 20.2805 15.0485C20.6905 14.6785 21.3205 14.7185 21.6905 15.1285L22.6805 16.2385L26.2705 12.2185C26.6405 11.8085 27.2705 11.7685 27.6805 12.1385C28.0905 12.5085 28.1305 13.1385 27.7605 13.5485L23.4205 18.4085C23.2305 18.6185 22.9605 18.7385 22.6705 18.7385L22.6905 18.7285Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M30.7402 31.1387H17.2402C16.6902 31.1387 16.2402 30.6887 16.2402 30.1387C16.2402 29.5887 16.6902 29.1387 17.2402 29.1387H30.7402C31.2902 29.1387 31.7402 29.5887 31.7402 30.1387C31.7402 30.6887 31.2902 31.1387 30.7402 31.1387Z",
            fill: "#EE2B7B"
          }
        )
      ]
    }
  ),
  videocall: /* @__PURE__ */ e.jsxs(
    "svg",
    {
      width: "48",
      height: "49",
      viewBox: "0 0 48 49",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e.jsx("circle", { cx: "24", cy: "24.1689", r: "24", fill: "#F3F3F3" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M30 19H28.5C26.18 19 24.9 19 23.95 18.05C23 17.1 23 15.82 23 13.5C23 11.18 23 9.9 23.95 8.95C24.9 8 26.18 8 28.5 8H30C32.32 8 33.6 8 34.55 8.95C35.5 9.9 35.5 11.18 35.5 13.5C35.5 15.82 35.5 17.1 34.55 18.05C33.6 19 32.32 19 30 19ZM28.5 10C26.77 10 25.73 10 25.37 10.37C25.01 10.74 25 11.78 25 13.5C25 15.22 25 16.27 25.37 16.63C25.74 17 26.78 17 28.5 17H30C31.73 17 32.77 17 33.13 16.63C33.49 16.26 33.5 15.22 33.5 13.5C33.5 11.78 33.5 10.73 33.13 10.37C32.76 10 31.72 10 30 10H28.5Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M38.36 17.85C37.83 17.85 37.25 17.61 36.54 17.31L33.5 16.04V10.96L36.54 9.68999C37.65 9.22999 38.45 8.89999 39.22 9.41999C40 9.93999 40 10.8 40 12V15C40 16.2 40 17.06 39.22 17.58C38.94 17.77 38.66 17.84 38.36 17.84V17.85ZM35.5 14.71L37.31 15.46C37.54 15.56 37.79 15.66 37.99 15.74C37.99 15.53 37.99 15.25 37.99 15V12C37.99 11.75 37.99 11.48 37.99 11.26C37.79 11.33 37.54 11.44 37.31 11.53L35.5 12.29V14.71Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M30 40H18C17.45 40 17 39.55 17 39C17 38.45 17.45 38 18 38H30C30.55 38 31 38.45 31 39C31 39.55 30.55 40 30 40Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M24 40C23.45 40 23 39.55 23 39V31.5C23 30.95 23.45 30.5 24 30.5C24.55 30.5 25 30.95 25 31.5V39C25 39.55 24.55 40 24 40Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M39 26.5H9C8.45 26.5 8 26.05 8 25.5C8 24.95 8.45 24.5 9 24.5H39C39.55 24.5 40 24.95 40 25.5C40 26.05 39.55 26.5 39 26.5Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M30 32.5H18C13.49 32.5 11.22 32.5 9.61 30.89C8 29.28 8 27.01 8 22.5V20.25C8 15.09 8 12.5 9.59 10.56C9.88 10.21 10.21 9.88 10.56 9.59C12.5 8 15.09 8 20.25 8C20.8 8 21.25 8.45 21.25 9C21.25 9.55 20.8 10 20.25 10C15.56 10 13.21 10 11.83 11.14C11.58 11.35 11.35 11.58 11.14 11.83C10 13.21 10 15.57 10 20.25V22.5C10 26.46 10 28.45 11.03 29.48C12.05 30.5 14.04 30.5 18 30.5H30C33.96 30.5 35.95 30.5 36.98 29.48C38 28.45 38 26.47 38 22.5V21C38 20.45 38.45 20 39 20C39.55 20 40 20.45 40 21V22.5C40 27.01 40 29.28 38.39 30.89C36.78 32.5 34.51 32.5 30 32.5Z",
            fill: "#EE2B7B"
          }
        )
      ]
    }
  ),
  call: /* @__PURE__ */ e.jsxs(
    "svg",
    {
      width: "48",
      height: "49",
      viewBox: "0 0 48 49",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e.jsx("circle", { cx: "24", cy: "24.1689", r: "24", fill: "#F3F3F3" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M38.9961 23.337C38.4862 23.337 38.0462 22.9469 37.9962 22.4268C37.9962 22.3968 37.5863 19.0162 33.2871 14.7054C28.9879 10.4047 25.5985 9.99458 25.5685 9.99458C25.0186 9.93457 24.6187 9.44448 24.6787 8.90438C24.7287 8.35428 25.2086 7.95421 25.7585 8.00422C25.9185 8.02422 29.8377 8.4243 34.7068 13.2952C39.5759 18.1661 39.9759 22.0768 39.9959 22.2468C40.0459 22.7969 39.6359 23.287 39.086 23.337C39.056 23.337 39.0261 23.337 38.9961 23.337Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M33.0775 22.9672C32.6375 22.9672 32.2376 22.6771 32.1176 22.2371C32.1176 22.2371 31.6377 20.7568 29.4281 18.5464C27.2185 16.336 25.7388 15.8559 25.7288 15.8459C25.2089 15.6859 24.909 15.1258 25.0589 14.6057C25.2189 14.0856 25.7588 13.7855 26.2887 13.9256C26.4787 13.9856 28.2584 14.5457 30.8479 17.1261C33.4374 19.7066 33.9873 21.4869 34.0473 21.687C34.1973 22.2171 33.8873 22.7672 33.3574 22.9272C33.2674 22.9572 33.1774 22.9672 33.0775 22.9672Z",
            fill: "#EE2B7B"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            d: "M28.5085 40C24.8492 40 19.6302 38.8198 14.4011 33.5888C8.86213 28.0478 7.87232 22.5168 8.01229 18.8462C8.08228 16.9058 9.04211 14.9955 10.8518 13.1851C12.2315 11.7949 14.1612 11.1248 16.0108 11.3848C17.6905 11.6149 19.1103 12.585 19.9301 14.0353L21.0099 15.9756C22.1997 18.106 21.7498 20.8865 19.9101 22.7369C19.8201 22.8469 18.9103 24.0871 21.4098 26.5876C23.9094 29.088 25.2091 28.1278 25.2591 28.0878C27.0888 26.2575 29.8783 25.7974 32.0079 26.9876L33.9475 28.0678C35.3973 28.878 36.3671 30.3082 36.5971 31.9785C36.857 33.8289 36.1771 35.7592 34.7974 37.1395C32.9877 38.9498 31.0781 39.91 29.1384 39.98C28.9285 39.98 28.7185 39.99 28.4985 39.99L28.5085 40ZM15.231 13.3352C14.1612 13.3352 13.0814 13.7953 12.2715 14.6054C11.2817 15.5956 10.0819 17.1559 10.0119 18.9262C9.89195 22.1968 10.7918 27.1577 15.8209 32.1786C20.8499 37.2095 25.809 38.1197 29.0684 37.9896C30.8381 37.9196 32.3978 36.7194 33.3877 35.7292C34.3275 34.7891 34.7874 33.4888 34.6174 32.2486C34.4674 31.1784 33.8875 30.3182 32.9677 29.8082L31.0281 28.728C29.6683 27.9678 27.8687 28.2879 26.6389 29.5181C26.5589 29.5981 25.869 30.2582 24.6293 30.3182C23.1695 30.3983 21.5898 29.6081 19.9801 27.9978C17.2306 25.2473 17.5106 23.187 17.9205 22.1968C18.1004 21.7567 18.3004 21.4766 18.4904 21.3066C19.6902 20.0864 20.0101 18.2961 19.2602 16.9458L18.1804 15.0055C17.6705 14.0953 16.8007 13.5052 15.7409 13.3552C15.5709 13.3352 15.4009 13.3152 15.231 13.3152V13.3352Z",
            fill: "#EE2B7B"
          }
        )
      ]
    }
  )
}, p0 = [
  {
    id: "cda",
    icon: t2.cda,
    title: "Centro de ayuda",
    description: "Consulta las preguntas más frecuentes",
    action: "https://www.comfama.com/ayuda/"
  },
  {
    id: "whatsapp",
    icon: t2.whatsapp,
    title: "Atención WhatsApp",
    description: "Recibe acompañamiento desde nuestro canal de WhatsApp",
    action: "https://wa.me/3103016666",
    target: "_blank"
  },
  {
    id: "servicios",
    icon: t2.services,
    title: "Centros de servicio presencial",
    description: "Conoce en dónde estamos ubicados",
    action: "https://www.comfama.com/mapa-de-sedes/"
  },
  {
    id: "presential",
    icon: t2.presential,
    title: "Turno atención presencial",
    description: "Solicita tu turno desde casa para recibir atención presencial sin filas en nuestras sedes",
    action: "https://www.comfama.com/portal-servicios/personas/solicitud-de-turnos/"
  },
  {
    id: "videollamada",
    icon: t2.videocall,
    title: "Centro de servicios virtual",
    description: "Inicia una video llamada con un asesor",
    action: "https://comfama.qanty.com/portals/tickets"
  },
  {
    id: "call",
    icon: t2.call,
    title: "Central de llamadas",
    description: "Comunícate a través de llamada al 604 3607080",
    action: "tel:6043607080"
  }
], f1 = ({
  channels: c = p0,
  buttonLabel: t = "Canales de servicio",
  buttonPosition: s = "bottom-right"
}) => {
  const [a, n] = z(!1), [f, l] = z(!1), i = W(null), o = W(null);
  I(() => {
    const C = (w) => {
      w.key === "Escape" && a && n(!1);
    };
    return document.addEventListener("keydown", C), () => document.removeEventListener("keydown", C);
  }, [a]), I(() => {
    const C = (w) => {
      a && i.current && !i.current.contains(w.target) && o.current && !o.current.contains(w.target) && n(!1);
    };
    return document.addEventListener("mousedown", C), () => document.removeEventListener("mousedown", C);
  }, [a]), I(() => {
    const C = () => {
      l(window.innerWidth <= 768);
    };
    return C(), window.addEventListener("resize", C), () => window.removeEventListener("resize", C);
  }, []);
  const m = c.filter((C) => {
    const w = C.visibility ?? "both";
    return w === "both" || w === "mobile" && f || w === "desktop" && !f;
  }), x = K(() => n((C) => !C), []), p = K(
    (C) => {
      C.action && typeof C.action == "function" && (C.action(), n(!1));
    },
    []
  ), g = () => {
    switch (s) {
      case "top-left":
        return "cfm:top-0 cfm:left-0 cfm:md:left-8";
      case "top-right":
        return "cfm:top-0 cfm:right-0 cfm:md:right-8";
      case "bottom-left":
        return "cfm:bottom-0 cfm:left-0 cfm:md:left-8";
      case "bottom-right":
      default:
        return "cfm:bottom-0 cfm:right-0 cfm:md:right-8";
    }
  }, S = () => {
    switch (s) {
      case "top-left":
        return "cfm:top-16 cfm:left-0 cfm:md:left-0";
      case "top-right":
        return "cfm:top-16 cfm:left-0 cfm:md:left-auto cfm:md:right-0";
      case "bottom-left":
        return "cfm:bottom-16 cfm:left-0 cfm:md:left-0";
      case "bottom-right":
      default:
        return "cfm:bottom-16 cfm:left-0 cfm:sm:left-auto cfm:md:right-0";
    }
  }, M = K(
    (C) => {
      const w = /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("div", { className: "cfm:flex-shrink-0 cfm:w-9 cfm:h-9 cfm:flex cfm:items-center cfm:justify-center cfm:rounded-full cfm:mr-4", children: C.icon }),
        /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex-1", children: [
          /* @__PURE__ */ e.jsx("h3", { className: "cfm:font-medium cfm:text-gray-900", children: C.title }),
          /* @__PURE__ */ e.jsx("p", { className: "cfm:text-sm cfm:text-gray-500", children: C.description })
        ] })
      ] });
      return C.action ? typeof C.action == "function" ? /* @__PURE__ */ e.jsx(
        "button",
        {
          className: "cfm:w-full cfm:text-left cfm:flex cfm:items-start cfm:px-4 cfm:py-3 cfm:hover:bg-gray-50 cfm:transition-colors",
          onClick: () => p(C),
          children: w
        }
      ) : /* @__PURE__ */ e.jsx(
        "a",
        {
          href: C.action,
          target: C.target ?? "_self",
          role: "button",
          className: "cfm:flex cfm:items-start cfm:px-4 cfm:py-3 cfm:hover:bg-gray-50 cfm:transition-colors",
          onClick: () => n(!1),
          children: w
        }
      ) : /* @__PURE__ */ e.jsx("div", { className: "cfm:flex cfm:items-start cfm:px-4 cfm:py-3", children: w });
    },
    [p]
  );
  return m.length === 0 ? null : /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: u(
        "cfm:w-full cfm:flex cfm:justify-center cfm:sm:w-auto cfm:fixed cfm:z-1200",
        g()
      ),
      children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: u(
              "cfm:fixed cfm:inset-0 cfm:bg-chaos-black/82 cfm:backdrop-blur-sm cfm:z-40 cfm:transition-opacity cfm:duration-300 cfm:ease-out",
              a ? "cfm:opacity-100 cfm:pointer-events-auto" : "cfm:opacity-0 cfm:pointer-events-none"
            ),
            role: "dialog",
            "aria-modal": "true",
            "aria-hidden": !a,
            onClick: () => n(!1)
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            ref: i,
            id: "channels-popup",
            className: u(
              "cfm:absolute cfm:max-h-[calc(100vh-70px)] cfm:max-sm:w-full cfm:sm:w-105 cfm:px-2 cfm:py-3 cfm:bg-secondary-100 cfm:rounded-3xl cfm:border cfm:border-secondary-400 cfm:shadow-[0px_0px_11px_-4px_rgba(0,0,0,0.2)] cfm:z-50",
              S(),
              "cfm:transition-all cfm:duration-300 cfm:ease-in-out",
              // Unifica la transición
              a ? "cfm:opacity-100 cfm:translate-y-0 cfm:pointer-events-auto" : "cfm:opacity-0 cfm:translate-y-4 cfm:pointer-events-none"
              // Invierte translate-y para un efecto "slide-up"
            ),
            role: "dialog",
            "aria-labelledby": "channels-title",
            "aria-hidden": !a,
            children: [
              /* @__PURE__ */ e.jsx("div", { className: "cfm:sr-only", id: "channels-title", children: t }),
              /* @__PURE__ */ e.jsx("div", { className: "cfm:overflow-y-auto cfm:max-h-[calc(100vh-80px)]", children: m.map((C, w) => /* @__PURE__ */ e.jsxs("div", { children: [
                " ",
                M(C),
                w < m.length - 1 && /* @__PURE__ */ e.jsx("div", { className: "cfm:mx-4 cfm:border-t cfm:border-gray-100" })
              ] }, C.id || w)) }),
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: u(
                    "cfm:bg-secondary-100 cfm:border-inherit cfm:w-5 cfm:h-5 cfm:absolute cfm:clip-triangle cfm:rounded-bl-md",
                    s.startsWith("bottom") ? "cfm:bottom-[-10px] cfm:rotate-[-45deg]" : "cfm:top-[-10px] cfm:rotate-[135deg]",
                    // Triángulo hacia abajo si el botón está arriba
                    s.endsWith("right") ? "cfm:right-1/4 cfm:translate-x-1/2" : "cfm:left-1/4 cfm:-translate-x-1/2"
                    // Ajusta la posición horizontal
                  ),
                  "aria-hidden": "true"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            ref: o,
            onClick: x,
            className: u(
              "cfm:w-full cfm:sm:w-auto cfm:transition-all cfm:duration-300 cfm:relative cfm:flex cfm:items-center cfm:justify-center cfm:space-x-2 cfm:px-4 cfm:py-2 cfm:shadow-md cfm:focus:outline-none cfm:z-50 cfm:cursor-pointer cfm:disabled:cursor-not-allowed",
              a ? "cfm:bg-white cfm:text-primary-main" : "cfm:bg-tertiary-800 cfm:text-white",
              s.startsWith("top") ? "cfm:rounded-b-xl" : "cfm:rounded-t-xl"
            ),
            "aria-expanded": a,
            "aria-controls": "channels-popup",
            children: [
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: u(
                    "cfm:w-[33px] cfm:h-[33px] cfm:flex cfm:items-center cfm:justify-center cfm:rounded-full cfm:transition-transform cfm:duration-300 cfm:ease-in-out",
                    a ? "cfm:bg-primary-main cfm:text-secondary-100 cfm:rotate-45" : "cfm:bg-secondary-100 cfm:text-primary-main cfm:rotate-0"
                  ),
                  children: /* @__PURE__ */ e.jsx(
                    "svg",
                    {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 18 18",
                      stroke: "none",
                      fill: "currentColor",
                      className: "cfm:w-5 cfm:h-5",
                      "aria-hidden": "true",
                      focusable: "false",
                      children: /* @__PURE__ */ e.jsx("path", { d: "M9.00171 17.4419C8.73597 17.4419 8.51322 17.352 8.33345 17.1722C8.15369 16.9925 8.0638 16.7697 8.0638 16.504V9.93864H1.49845C1.23271 9.93864 1.00996 9.84876 0.830195 9.66899C0.65043 9.48923 0.560547 9.26647 0.560547 9.00073C0.560547 8.73499 0.65043 8.51224 0.830195 8.33247C1.00996 8.15271 1.23271 8.06283 1.49845 8.06283H8.0638V1.49748C8.0638 1.23174 8.15369 1.00898 8.33345 0.829219C8.51322 0.649453 8.73597 0.55957 9.00171 0.55957C9.26745 0.55957 9.4902 0.649453 9.66997 0.829219C9.84973 1.00898 9.93962 1.23174 9.93962 1.49748V8.06283H16.505C16.7707 8.06283 16.9935 8.15271 17.1732 8.33247C17.353 8.51224 17.4429 8.73499 17.4429 9.00073C17.4429 9.26647 17.353 9.48923 17.1732 9.66899C16.9935 9.84876 16.7707 9.93864 16.505 9.93864H9.93962V16.504C9.93962 16.7697 9.84973 16.9925 9.66997 17.1722C9.4902 17.352 9.26745 17.4419 9.00171 17.4419Z" })
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx("span", { children: t })
            ]
          }
        )
      ]
    }
  );
};
f1.defaultOptions = p0;
const o0 = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: !0,
  autoplay: !1,
  autoplaySpeed: 3e3,
  speed: 500,
  arrows: !0,
  dots: !1,
  fade: !1,
  centerMode: !1,
  centerPadding: "50px",
  variableWidth: !1,
  adaptiveHeight: !1,
  pauseOnHover: !0,
  pauseOnFocus: !0,
  swipeToSlide: !1,
  touchThreshold: 5,
  edgeFriction: 0.35
}, m1 = (c, t, s, a, n) => {
  const [f, l] = z(0), [i, o] = z(!1), [m, x] = z(
    () => ({
      ...o0,
      ...t
    })
  ), p = W(null), g = W(!1), S = c.length, M = T2(() => m.variableWidth || m.fade ? S - 1 : Math.max(0, S - m.slidesToShow), [
    S,
    m.slidesToShow,
    m.fade,
    m.variableWidth
  ]), C = K(() => {
    if (typeof window > "u") return;
    const b = window.innerWidth;
    let y = { ...o0, ...t };
    const N = [...s].sort(
      (O, G) => O.breakpoint - G.breakpoint
    );
    for (const O of N)
      b <= O.breakpoint && (y = { ...y, ...O.settings });
    x((O) => Object.keys(y).some(
      (D) => O[D] !== y[D]
    ) ? y : O);
  }, [t, s]);
  I(() => {
    g.current || (C(), g.current = !0, n == null || n());
    const b = () => {
      window.requestAnimationFrame ? window.requestAnimationFrame(C) : setTimeout(C, 100);
    };
    return window.addEventListener("resize", b), () => {
      window.removeEventListener("resize", b);
    };
  }, [C, n]);
  const w = K(
    (b) => {
      if (i) return;
      let y = b;
      m.infinite ? y < 0 ? y = S - 1 : y >= S && (y = 0) : y = Math.max(0, Math.min(M, y)), o(!0), l(y), a == null || a(y);
      const N = setTimeout(() => {
        o(!1);
      }, m.speed);
      return () => clearTimeout(N);
    },
    [
      i,
      m.infinite,
      m.speed,
      S,
      M,
      a
    ]
  ), E = K(() => {
    const b = f - m.slidesToScroll;
    w(b);
  }, [f, m.slidesToScroll, w]), j = K(() => {
    const b = f + m.slidesToScroll;
    w(b);
  }, [f, m.slidesToScroll, w]);
  return I(() => {
    if (!m.autoplay) {
      p.current && (clearInterval(p.current), p.current = null);
      return;
    }
    const b = () => {
      p.current && clearInterval(p.current), p.current = setInterval(() => {
        j();
      }, m.autoplaySpeed);
    }, y = () => {
      p.current && (clearInterval(p.current), p.current = null);
    };
    b();
    const N = document.querySelector(".advanced-slider-container");
    return N && (m.pauseOnHover && (N.addEventListener("mouseenter", y), N.addEventListener("mouseleave", b)), m.pauseOnFocus && (N.addEventListener("focusin", y), N.addEventListener("focusout", b))), () => {
      y(), N && (N.removeEventListener("mouseenter", y), N.removeEventListener("mouseleave", b), N.removeEventListener("focusin", y), N.removeEventListener("focusout", b));
    };
  }, [
    m.autoplay,
    m.autoplaySpeed,
    m.pauseOnHover,
    m.pauseOnFocus,
    j
  ]), I(() => {
    const b = (y) => {
      y.key === "ArrowLeft" ? E() : y.key === "ArrowRight" && j();
    };
    return (m.pauseOnFocus || m.arrows) && window.addEventListener("keydown", b), () => {
      window.removeEventListener("keydown", b);
    };
  }, [
    E,
    j,
    m.pauseOnFocus,
    m.arrows
  ]), {
    currentIndex: f,
    isTransitioning: i,
    currentSettings: m,
    totalSlides: S,
    maxIndex: M,
    goToPrevious: E,
    goToNext: j,
    goToSlide: w,
    sliderRef: W(null)
    // This ref should be passed to the main container
  };
}, C0 = G0(void 0), i1 = ({ children: c, value: t }) => /* @__PURE__ */ e.jsx(C0.Provider, { value: t, children: c }), C2 = () => {
  const c = U0(C0);
  if (c === void 0)
    throw new Error("useSliderContext must be used within a SliderProvider");
  return c;
}, g2 = () => {
  const {
    settings: c,
    goToPrevious: t,
    goToNext: s,
    currentIndex: a,
    totalSlides: n,
    maxIndex: f,
    prevArrow: l,
    nextArrow: i,
    arrowClassName: o,
    navigation: m,
    isTransitioning: x,
    variant: p
  } = C2();
  if (!c.arrows) return null;
  const g = K(() => {
    const b = "cfm:absolute cfm:z-2", { position: y, align: N } = m || {};
    if (p === "modern")
      switch (y) {
        case "top":
          return u(
            b,
            {
              "cfm:left-0": N === "left",
              "cfm:left-1/2 -cfm:translate-x-1/2": N === "center",
              "cfm:right-0": N === "right" || !N
            },
            "cfm:top-0"
          );
        case "middle":
          return u(
            b,
            {
              "cfm:left-4": N === "left",
              "cfm:left-1/2 -cfm:translate-x-1/2": N === "center",
              "cfm:right-4": N === "right" || !N
            },
            "cfm:top-1/2 -cfm:translate-y-1/2"
          );
        case "bottom":
        default:
          return u(
            b,
            {
              "cfm:left-4": N === "left",
              "cfm:left-1/2 -cfm:translate-x-1/2": N === "center",
              "cfm:right-4": N === "right" || !N
            },
            "cfm:bottom-4"
          );
      }
    return "";
  }, [m, p]), S = u(
    "cfm:flex cfm:items-center cfm:justify-center cfm:transition-colors  cfm:cursor-pointer",
    "cfm:disabled:opacity-50 cfm:disabled:cursor-not-allowed",
    o
  ), M = !c.infinite && a === 0, C = !c.infinite && a >= f;
  if (p === "modern")
    return /* @__PURE__ */ e.jsx("div", { className: g(), children: /* @__PURE__ */ e.jsxs("div", { className: "cfm:flex cfm:items-center cfm:bg-primary cfm:overflow-hidden", children: [
      /* @__PURE__ */ e.jsxs(
        "button",
        {
          onClick: t,
          disabled: x || M,
          "aria-label": (m == null ? void 0 : m.prevLabel) || "Previous slide",
          className: u(
            "cfm:flex cfm:items-center cfm:gap-2 cfm:px-4 cfm:py-2 cfm:text-white cfm:hover:text-pink-900 cfm:cursor-pointer cfm:disabled:opacity-50 cfm:disabled:cursor-not-allowed cfm:text-sm cfm:font-bold",
            o
          ),
          children: [
            m == null ? void 0 : m.prevLabel,
            /* @__PURE__ */ e.jsx(J4, { className: "cfm:w-4 cfm:h-4" })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "cfm:w-px cfm:h-6 cfm:bg-pink-400" }),
      /* @__PURE__ */ e.jsxs(
        "button",
        {
          onClick: s,
          disabled: x || C,
          "aria-label": (m == null ? void 0 : m.nextLabel) || "Next slide",
          className: u(
            "cfm:flex cfm:items-center cfm:gap-2 cfm:px-4 cfm:py-2 cfm:text-white cfm:hover:text-pink-900 cfm:cursor-pointer cfm:disabled:opacity-50 cfm:disabled:cursor-not-allowed cfm:text-sm cfm:font-bold",
            o
          ),
          children: [
            /* @__PURE__ */ e.jsx(X4, { className: "cfm:w-4 cfm:h-4" }),
            m == null ? void 0 : m.nextLabel
          ]
        }
      ),
      (m == null ? void 0 : m.showCounter) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("div", { className: "cfm:w-px cfm:h-6 cfm:bg-pink-400" }),
        /* @__PURE__ */ e.jsxs("div", { className: "cfm:px-4 cfm:py-2 cfm:text-white cfm:text-base cfm:font-medium", children: [
          a + 1,
          "/",
          n
        ] })
      ] })
    ] }) });
  const w = p === "hero" || p === "classic", E = w ? "cfm:w-12 cfm:h-12 cfm:bg-pink-500 cfm:hover:bg-pink-600 cfm:text-white cfm:rounded-full" : "cfm:w-10 cfm:h-10 cfm:bg-white cfm:shadow-lg cfm:hover:shadow-xl cfm:text-gray-700 cfm:rounded-full", j = p === "hero" ? "cfm:w-16 cfm:h-16 cfm:bg-black/20 cfm:hover:bg-black/40 cfm:text-white cfm:rounded-full cfm:backdrop-blur-sm" : "";
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      "button",
      {
        onClick: t,
        disabled: x || M,
        "aria-label": "Previous slide",
        className: u(
          "cfm:absolute cfm:top-1/2 -cfm:translate-y-1/2 cfm:z-10",
          w ? "cfm:left-4" : "cfm:left-2",
          E,
          j,
          S
        ),
        children: l || /* @__PURE__ */ e.jsx(e1, { className: w ? "cfm:w-6 cfm:h-6" : "cfm:w-5 cfm:h-5" })
      }
    ),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        onClick: s,
        disabled: x || C,
        "aria-label": "Next slide",
        className: u(
          "cfm:absolute cfm:top-1/2 -cfm:translate-y-1/2 cfm:z-10",
          w ? "cfm:right-4" : "cfm:right-2",
          E,
          j,
          S
        ),
        children: i || /* @__PURE__ */ e.jsx(c1, { className: w ? "cfm:w-6 cfm:h-6" : "cfm:w-5 cfm:h-5" })
      }
    )
  ] });
}, B2 = () => {
  const { settings: c, totalSlides: t, currentIndex: s, goToSlide: a, customDot: n, dotClassName: f, variant: l } = C2();
  if (!c.dots) return null;
  const i = Math.ceil(t / c.slidesToShow), o = u("cfm:flex cfm:justify-center cfm:gap-2", {
    "cfm:mt-6": l === "classic" || l === "cards",
    "cfm:absolute cfm:bottom-8 cfm:left-1/2 -cfm:translate-x-1/2 cfm:gap-3": l === "hero"
  }), m = (x, p) => {
    const g = "cfm:rounded-full cfm:transition-colors cfm:cursor-pointer";
    return l === "hero" ? u(
      g,
      "cfm:w-4 cfm:h-4 cfm:transition-all",
      {
        "cfm:bg-white cfm:scale-125": p,
        "cfm:bg-white/50 cfm:hover:bg-white/75": !p
      },
      f
    ) : u(
      g,
      "cfm:w-3 cfm:h-3",
      {
        "cfm:bg-pink-500": p,
        "cfm:bg-gray-300 cfm:hover:bg-gray-400": !p
      },
      f
    );
  };
  return /* @__PURE__ */ e.jsx("div", { className: o, children: Array.from({ length: i }).map((x, p) => {
    const g = Math.floor(s / c.slidesToShow) === p;
    return /* @__PURE__ */ e.jsx(
      "button",
      {
        onClick: () => a(p * c.slidesToScroll),
        className: m(p, g),
        "aria-label": `Go to slide ${p + 1}`,
        children: n == null ? void 0 : n(p, g)
      },
      p
    );
  }) });
}, v2 = ({ items: c }) => {
  const { settings: t, currentIndex: s, slideClassName: a, variant: n } = C2(), f = T2(() => t.variableWidth ? "auto" : `${100 / t.slidesToShow}%`, [t.slidesToShow, t.variableWidth]), l = T2(() => t.fade ? 0 : -(s * (100 / t.slidesToShow)), [s, t.slidesToShow, t.fade]), i = u({
    "cfm:absolute cfm:inset-0": t.fade,
    // For fade variant
    "cfm:transition-transform cfm:ease-in-out": !t.fade,
    "cfm:duration-300": n === "modern" && !t.fade,
    "cfm:h-full": n === "modern"
  }), o = u({
    "cfm:absolute cfm:inset-0 cfm:opacity-0 cfm:transition-opacity": t.fade,
    "cfm:h-full": n === "modern",
    "!cfm:w-[calc(${100 / settings.slidesToShow}% - 1rem)]": n === "cards"
    // Specific for cards variant gap
  });
  return n === "hero" ? /* @__PURE__ */ e.jsx("div", { className: "cfm:relative cfm:h-full", children: c.map((m, x) => /* @__PURE__ */ e.jsx(
    "div",
    {
      className: u(
        "cfm:absolute cfm:inset-0 cfm:transition-opacity cfm:duration-1000",
        x === s ? "cfm:opacity-100" : "cfm:opacity-0",
        a
      ),
      children: m.content
    },
    m.id
  )) }) : /* @__PURE__ */ e.jsx(
    "div",
    {
      className: u("cfm:flex", i),
      style: {
        transform: `translateX(${l}%)`,
        transitionDuration: `${t.speed}ms`,
        transitionProperty: t.fade ? "opacity" : "transform",
        flexWrap: t.variableWidth ? "nowrap" : "initial"
      },
      children: c.map((m, x) => /* @__PURE__ */ e.jsx(
        "div",
        {
          className: u(
            "cfm:flex-shrink-0",
            t.fade && "cfm:absolute cfm:inset-0 cfm:opacity-0 cfm:transition-opacity",
            t.fade && x === s && "cfm:opacity-100",
            a,
            o
          ),
          style: { width: f },
          children: m.content
        },
        m.id
      ))
    }
  );
}, b2 = ({ children: c, className: t, sliderRef: s }) => {
  const { variant: a } = C2(), n = "cfm:relative cfm:w-full cfm:overflow-hidden", f = {
    hero: "cfm:h-screen",
    classic: "cfm:pb-4"
  };
  return /* @__PURE__ */ e.jsx("div", { ref: s, className: u(n, f[a], t), children: c });
}, l1 = ({ items: c, className: t, sliderRef: s }) => /* @__PURE__ */ e.jsxs(b2, { className: t, sliderRef: s, children: [
  /* @__PURE__ */ e.jsxs("div", { className: "cfm:relative", children: [
    /* @__PURE__ */ e.jsx(v2, { items: c }),
    /* @__PURE__ */ e.jsx(g2, {})
  ] }),
  /* @__PURE__ */ e.jsx(B2, {})
] }), o1 = ({ items: c, className: t, sliderRef: s }) => /* @__PURE__ */ e.jsxs(b2, { className: t, sliderRef: s, children: [
  /* @__PURE__ */ e.jsx("div", { className: "cfm:relative cfm:h-full", children: /* @__PURE__ */ e.jsx(v2, { items: c }) }),
  /* @__PURE__ */ e.jsx(g2, {})
] }), d1 = ({ items: c, className: t, sliderRef: s }) => /* @__PURE__ */ e.jsxs(b2, { className: t, sliderRef: s, children: [
  /* @__PURE__ */ e.jsx("div", { className: "cfm:overflow-hidden", children: /* @__PURE__ */ e.jsx(v2, { items: c }) }),
  /* @__PURE__ */ e.jsx(g2, {}),
  /* @__PURE__ */ e.jsx(B2, {})
] }), u1 = ({ items: c, className: t, sliderRef: s }) => /* @__PURE__ */ e.jsxs(b2, { className: t, sliderRef: s, children: [
  /* @__PURE__ */ e.jsx(v2, { items: c }),
  /* @__PURE__ */ e.jsx(g2, {}),
  /* @__PURE__ */ e.jsx(B2, {})
] });
function O1({
  items: c,
  variant: t = "classic",
  settings: s = {},
  responsive: a = [],
  className: n,
  slideClassName: f,
  arrowClassName: l,
  dotClassName: i,
  prevArrow: o,
  nextArrow: m,
  customDot: x,
  onSlideChange: p,
  onInit: g,
  navigation: S = {}
}) {
  const {
    currentIndex: M,
    isTransitioning: C,
    currentSettings: w,
    totalSlides: E,
    maxIndex: j,
    goToPrevious: b,
    goToNext: y,
    goToSlide: N,
    sliderRef: O
  } = m1(c, s, a, p, g);
  if (c.length === 0)
    return /* @__PURE__ */ e.jsx("div", { className: "cfm:text-center cfm:text-gray-500 cfm:p-8", children: "No hay elementos para mostrar en el carrusel." });
  const G = {
    settings: w,
    currentIndex: M,
    totalSlides: E,
    maxIndex: j,
    isTransitioning: C,
    goToPrevious: b,
    goToNext: y,
    goToSlide: N,
    variant: t,
    slideClassName: f,
    arrowClassName: l,
    dotClassName: i,
    prevArrow: o,
    nextArrow: m,
    customDot: x,
    navigation: S
  }, D = {
    items: c,
    className: n,
    sliderRef: O
  };
  return /* @__PURE__ */ e.jsx(i1, { value: G, children: (() => {
    switch (t) {
      case "modern":
        return /* @__PURE__ */ e.jsx(o1, { ...D });
      case "cards":
        return /* @__PURE__ */ e.jsx(d1, { ...D });
      case "hero":
        return /* @__PURE__ */ e.jsx(u1, { ...D });
      case "classic":
      default:
        return /* @__PURE__ */ e.jsx(l1, { ...D });
    }
  })() });
}
export {
  O1 as AdvancedSlider,
  H4 as Breadcrumb,
  Y as Button,
  w4 as CardBgColor,
  j4 as CardIcon,
  L4 as CardIconBgImg,
  y1 as CardImg,
  N4 as CardImgBgColor,
  b1 as CardImgCta,
  k4 as CardImgCta2,
  M4 as CardPlan,
  w1 as ChatFloating,
  p1 as Checkbox,
  i2 as Container,
  T4 as DropdownSelector,
  R1 as Footer,
  z1 as Header,
  _2 as Image,
  p4 as Input,
  V1 as MainHero,
  f1 as OptionsFloatings,
  g1 as RadioButton,
  j1 as SectionAccordionImgCta,
  N1 as SectionCardBgColor,
  L1 as SectionCardIcon,
  k1 as SectionCardIconBgImg,
  S1 as SectionCardImgBgColor,
  T1 as SectionCardImgCta2,
  E1 as SectionCtaBgImg,
  M1 as SectionCtaImg,
  _1 as SectionPlanes,
  r2 as SimpleSectionHeader,
  H1 as SocialNav,
  s1 as Step,
  V2 as StepLabel,
  Z1 as Stepper,
  V4 as TabSelector,
  v1 as Table,
  B1 as TabsSticky,
  C1 as Toggle,
  T as Typography
};
